/**
 * Represents the localization data for Brazilian municipalities.
 */
export default [
  { id: '1200013', name: 'Acrelândia' },
  { id: '1200054', name: 'Asis Brasil' },
  { id: '1200104', name: 'Brasiléia' },
  { id: '1200138', name: 'Bujari' },
  { id: '1200179', name: 'Capixaba' },
  { id: '1200203', name: 'Cruzeiro do Sul' },
  { id: '1200252', name: 'Epitaciolândia' },
  { id: '1200302', name: 'Feijó' },
  { id: '1200328', name: 'Jordão' },
  { id: '1200336', name: 'Mâncio Lima' },
  { id: '1200344', name: 'Manoel Urbano' },
  { id: '1200351', name: 'Marechal Thaumaturgo' },
  { id: '1200385', name: 'Plácido de Castro' },
  { id: '1200807', name: 'Porto Acre' },
  { id: '1200393', name: 'Porto Walter' },
  { id: '1200401', name: 'Rio Branco' },
  { id: '1200427', name: 'Rodrigues Alves' },
  { id: '1200435', name: 'Santa Rosa do Purus' },
  { id: '1200500', name: 'Sena Madureira' },
  { id: '1200450', name: 'Senador Guiomard' },
  { id: '1200609', name: 'Tarauacá' },
  { id: '1200708', name: 'Xapuri' },
  { id: '2700102', name: 'Água Branca' },
  { id: '2700201', name: 'Anadia' },
  { id: '2700300', name: 'Arapiraca' },
  { id: '2700409', name: 'Atalaia' },
  { id: '2700508', name: 'Barra de Santo Antônio' },
  { id: '2700607', name: 'Barra de São Miguel' },
  { id: '2700706', name: 'Batalha' },
  { id: '2700805', name: 'Belém' },
  { id: '2700904', name: 'Belo Monte' },
  { id: '2701001', name: 'Boca da Mata' },
  { id: '2701100', name: 'Branquinha' },
  { id: '2701209', name: 'Cacimbinhas' },
  { id: '2701308', name: 'Cajueiro' },
  { id: '2701357', name: 'Campestre' },
  { id: '2701407', name: 'Campo Alegre' },
  { id: '2701506', name: 'Campo Grande' },
  { id: '2701605', name: 'Canapi' },
  { id: '2701704', name: 'Capela' },
  { id: '2701803', name: 'Carneiros' },
  { id: '2701902', name: 'Chã Preta' },
  { id: '2702009', name: 'Coité do Nóia' },
  { id: '2702108', name: 'Colônia Leopoldina' },
  { id: '2702207', name: 'Coqueiro Seco' },
  { id: '2702306', name: 'Coruripe' },
  { id: '2702355', name: 'Craíbas' },
  { id: '2702405', name: 'Delmiro Gouveia' },
  { id: '2702504', name: 'Dois Riachos' },
  { id: '2702553', name: 'Estrela de Alagoas' },
  { id: '2702603', name: 'Feira Grande' },
  { id: '2702702', name: 'Feliz Deserto' },
  { id: '2702801', name: 'Flexeiras' },
  { id: '2702900', name: 'Girau do Ponciano' },
  { id: '2703007', name: 'Ibateguara' },
  { id: '2703106', name: 'Igaci' },
  { id: '2703205', name: 'Igreja Nova' },
  { id: '2703304', name: 'Inhapi' },
  { id: '2703403', name: 'Jacaré dos Homens' },
  { id: '2703502', name: 'Jacuípe' },
  { id: '2703601', name: 'Japaratinga' },
  { id: '2703700', name: 'Jaramataia' },
  { id: '2703759', name: 'Jequiá da Praia' },
  { id: '2703809', name: 'Joaquim Gomes' },
  { id: '2703908', name: 'Jundiá' },
  { id: '2704005', name: 'Junqueiro' },
  { id: '2704104', name: 'Lagoa da Canoa' },
  { id: '2704203', name: 'Limoeiro de Anadia' },
  { id: '2704302', name: 'Maceió' },
  { id: '2704401', name: 'Major Isidoro' },
  { id: '2704906', name: 'Mar Vermelho' },
  { id: '2704500', name: 'Maragogi' },
  { id: '2704609', name: 'Maravilha' },
  { id: '2704708', name: 'Marechal Deodoro' },
  { id: '2704807', name: 'Maribondo' },
  { id: '2705002', name: 'Mata Grande' },
  { id: '2705101', name: 'Matriz de Camaragibe' },
  { id: '2705200', name: 'MeSias' },
  { id: '2705309', name: 'Minador do Negrão' },
  { id: '2705408', name: 'Monteirópolis' },
  { id: '2705507', name: 'Murici' },
  { id: '2705606', name: 'Novo Lino' },
  { id: '2705903', name: 'Olho d"Água Grande' },
  { id: '2705705', name: 'Olho d"Água das Flores' },
  { id: '2705804', name: 'Olho d"Água do Casado' },
  { id: '2706000', name: 'Olivença' },
  { id: '2706109', name: 'Ouro Branco' },
  { id: '2706208', name: 'Palestina' },
  { id: '2706307', name: 'Palmeira dos Índios' },
  { id: '2706406', name: 'Pão de Açúcar' },
  { id: '2706422', name: 'Pariconha' },
  { id: '2706448', name: 'Paripueira' },
  { id: '2706505', name: 'PaSo de Camaragibe' },
  { id: '2706604', name: 'Paulo Jacinto' },
  { id: '2706703', name: 'Penedo' },
  { id: '2706802', name: 'Piaçabuçu' },
  { id: '2706901', name: 'Pilar' },
  { id: '2707008', name: 'Pindoba' },
  { id: '2707107', name: 'Piranhas' },
  { id: '2707206', name: 'Poço das Trincheiras' },
  { id: '2707305', name: 'Porto Calvo' },
  { id: '2707503', name: 'Porto Real do Colégio' },
  { id: '2707404', name: 'Porto de Pedras' },
  { id: '2707602', name: 'QQuebrangulo' },
  { id: '2707701', name: 'Rio Largo' },
  { id: '2707800', name: 'Roteiro' },
  { id: '2707909', name: 'Santa Luzia do Norte' },
  { id: '2708006', name: 'Santana do Ipanema' },
  { id: '2708105', name: 'Santana do Mundaú' },
  { id: '2708204', name: 'São Brás' },
  { id: '2708303', name: 'São José da Laje' },
  { id: '2708402', name: 'São José da Tapera' },
  { id: '2708501', name: 'São Luís do Quitunde' },
  { id: '2708600', name: 'São Miguel dos Campos' },
  { id: '2708709', name: 'São Miguel dos Milagres' },
  { id: '2708808', name: 'São Sebastião' },
  { id: '2708907', name: 'Satuba' },
  { id: '2708956', name: 'Senador Rui Palmeira' },
  { id: '2709004', name: 'Tanque d"Arca' },
  { id: '2709103', name: 'Taquarana' },
  { id: '2709152', name: 'Teotônio Vilela' },
  { id: '2709202', name: 'Traipu' },
  { id: '2709301', name: 'União dos Palmares' },
  { id: '2709400', name: 'Viçosa' },
  { id: '1600105', name: 'Amapá' },
  { id: '1600204', name: 'Calçoene' },
  { id: '1600212', name: 'Cutias' },
  { id: '1600238', name: 'FeReira Gomes' },
  { id: '1600253', name: 'Itaubal' },
  { id: '1600279', name: 'Laranjal do Jari' },
  { id: '1600303', name: 'Macapá' },
  { id: '1600402', name: 'Mazagão' },
  { id: '1600501', name: 'Oiapoque' },
  { id: '1600154', name: 'Pedra Branca do Amapari' },
  { id: '1600535', name: 'Porto Grande' },
  { id: '1600550', name: 'Pracuúba' },
  { id: '1600600', name: 'Santana' },
  { id: '1600055', name: 'Serra do Navio' },
  { id: '1600709', name: 'Tartarugalzinho' },
  { id: '1600808', name: 'Vitória do Jari' },
  { id: '1300029', name: 'Alvarães' },
  { id: '1300060', name: 'Amaturá' },
  { id: '1300086', name: 'Anamã' },
  { id: '1300102', name: 'Anori' },
  { id: '1300144', name: 'Apuí' },
  { id: '1300201', name: 'Atalaia do Norte' },
  { id: '1300300', name: 'Autazes' },
  { id: '1300409', name: 'Barcelos' },
  { id: '1300508', name: 'BaReirinha' },
  { id: '1300607', name: 'Benjamin Constant' },
  { id: '1300631', name: 'Beruri' },
  { id: '1300680', name: 'Boa Vista do Ramos' },
  { id: '1300706', name: 'Boca do Acre' },
  { id: '1300805', name: 'Borba' },
  { id: '1300839', name: 'Capiranga' },
  { id: '1300904', name: 'Canutama' },
  { id: '1301001', name: 'Carauari' },
  { id: '1301100', name: 'Careiro' },
  { id: '1301159', name: 'Careiro da Várzea' },
  { id: '1301209', name: 'Coari' },
  { id: '1301308', name: 'Codajás' },
  { id: '1301407', name: 'Eirunepé' },
  { id: '1301506', name: 'Envira' },
  { id: '1301605', name: 'Fonte Boa' },
  { id: '1301654', name: 'Guajará' },
  { id: '1301704', name: 'Humaitá' },
  { id: '1301803', name: 'Ipixuna' },
  { id: '1301852', name: 'Iranduba' },
  { id: '1301902', name: 'Itacoatiara' },
  { id: '1301951', name: 'Itamarati' },
  { id: '1302009', name: 'Itapiranga' },
  { id: '1302108', name: 'Japurá' },
  { id: '1302207', name: 'Juruá' },
  { id: '1302306', name: 'Jutaí' },
  { id: '1302405', name: 'Lábrea' },
  { id: '1302504', name: 'Manacapuru' },
  { id: '1302553', name: 'Manaquiri' },
  { id: '1302603', name: 'Manaus' },
  { id: '1302702', name: 'Manicoré' },
  { id: '1302801', name: 'Maraã' },
  { id: '1302900', name: 'Maués' },
  { id: '1303007', name: 'Nhamundá' },
  { id: '1303106', name: 'Nova Olinda do Norte' },
  { id: '1303205', name: 'Novo Airão' },
  { id: '1303304', name: 'Novo Aripuanã' },
  { id: '1303403', name: 'Parintins' },
  { id: '1303502', name: 'Pauini' },
  { id: '1303536', name: 'Presidente Figueiredo' },
  { id: '1303569', name: 'Rio Preto da Eva' },
  { id: '1303601', name: 'Santa Isabel do Rio Negro' },
  { id: '1303700', name: 'Santo Antônio do Içá' },
  { id: '1303809', name: 'São Gabriel da Cachoeira' },
  { id: '1303908', name: 'São Paulo de Olivença' },
  { id: '1303957', name: 'São Sebastião do Uatumã' },
  { id: '1304005', name: 'Silves' },
  { id: '1304062', name: 'Tabatinga' },
  { id: '1304104', name: 'Tapauá' },
  { id: '1304203', name: 'Tefé' },
  { id: '1304237', name: 'Tonantins' },
  { id: '1304260', name: 'Uarini' },
  { id: '1304302', name: 'Urucará' },
  { id: '1304401', name: 'Urucurituba' },
  { id: '2900108', name: 'Abaíra' },
  { id: '2900207', name: 'Abaré' },
  { id: '2900306', name: 'Acajutiba' },
  { id: '2900355', name: 'Adustina' },
  { id: '2900405', name: 'Água Fria' },
  { id: '2900603', name: 'Aiquara' },
  { id: '2900702', name: 'Alagoinhas' },
  { id: '2900801', name: 'Alcobaça' },
  { id: '2900900', name: 'Almadina' },
  { id: '2901007', name: 'Amargosa' },
  { id: '2901106', name: 'Amélia Rodrigues' },
  { id: '2901155', name: 'América Dourada' },
  { id: '2901205', name: 'Anagé' },
  { id: '2901304', name: 'Andaraí' },
  { id: '2901353', name: 'Andorinha' },
  { id: '2901403', name: 'Angical' },
  { id: '2901502', name: 'Anguera' },
  { id: '2901601', name: 'Antas' },
  { id: '2901700', name: 'Antônio Cardoso' },
  { id: '2901809', name: 'Antônio Gonçalves' },
  { id: '2901908', name: 'Aporá' },
  { id: '2901957', name: 'Apuarema' },
  { id: '2902054', name: 'Araçás' },
  { id: '2902005', name: 'Aracatu' },
  { id: '2902104', name: 'Araci' },
  { id: '2902203', name: 'Aramari' },
  { id: '2902252', name: 'Arataca' },
  { id: '2902302', name: 'Aratuípe' },
  { id: '2902401', name: 'Aurelino Leal' },
  { id: '2902500', name: 'Baianópolis' },
  { id: '2902609', name: 'Baixa Grande' },
  { id: '2902658', name: 'Banzaê' },
  { id: '2902708', name: 'BaRa' },
  { id: '2902807', name: 'BaRa da Estiva' },
  { id: '2902906', name: 'BaRa do Choça' },
  { id: '2903003', name: 'BaRa do Mendes' },
  { id: '2903102', name: 'BaRa do Rocha' },
  { id: '2903201', name: 'BaReiras' },
  { id: '2903235', name: 'BaRo Alto' },
  { id: '2903300', name: 'BaRo Preto' },
  { id: '2903276', name: 'BaRocas' },
  { id: '2903409', name: 'Belmonte' },
  { id: '2903508', name: 'Belo Campo' },
  { id: '2903607', name: 'Biritinga' },
  { id: '2903706', name: 'Boa Nova' },
  { id: '2903805', name: 'Boa Vista do Tupim' },
  { id: '2903904', name: 'Bom Jesus da Lapa' },
  { id: '2903953', name: 'Bom Jesus da Serra' },
  { id: '2904001', name: 'Boninal' },
  { id: '2904050', name: 'Bonito' },
  { id: '2904100', name: 'Boquira' },
  { id: '2904209', name: 'Botuporã' },
  { id: '2904308', name: 'Brejões' },
  { id: '2904407', name: 'Brejolândia' },
  { id: '2904506', name: 'Brotas de Macaúbas' },
  { id: '2904605', name: 'Brumado' },
  { id: '2904704', name: 'Buerarema' },
  { id: '2904753', name: 'Buritirama' },
  { id: '2904803', name: 'CAtiba' },
  { id: '2904852', name: 'Cabaceiras do Paraguaçu' },
  { id: '2904902', name: 'Cachoeira' },
  { id: '2905008', name: 'Caculé' },
  { id: '2905107', name: 'Caém' },
  { id: '2905156', name: 'Caetanos' },
  { id: '2905206', name: 'Caetité' },
  { id: '2905305', name: 'Cafarnaum' },
  { id: '2905404', name: 'Cairu' },
  { id: '2905503', name: 'Caldeirão Grande' },
  { id: '2905602', name: 'Camacan' },
  { id: '2905701', name: 'Camaçari' },
  { id: '2905800', name: 'Camamu' },
  { id: '2905909', name: 'Campo Alegre de Lourdes' },
  { id: '2906006', name: 'Campo Formoso' },
  { id: '2906105', name: 'Canápolis' },
  { id: '2906204', name: 'Canarana' },
  { id: '2906303', name: 'Canavieiras' },
  { id: '2906402', name: 'Candeal' },
  { id: '2906501', name: 'Candeias' },
  { id: '2906600', name: 'Candiba' },
  { id: '2906709', name: 'Cândido Sales' },
  { id: '2906808', name: 'Cansanção' },
  { id: '2906824', name: 'Canudos' },
  { id: '2906857', name: 'Capela do Alto Alegre' },
  { id: '2906873', name: 'Capim GroSo' },
  { id: '2906899', name: 'Caraíbas' },
  { id: '2906907', name: 'Caravelas' },
  { id: '2907004', name: 'Cardeal da Silva' },
  { id: '2907103', name: 'Carinhanha' },
  { id: '2907202', name: 'Casa Nova' },
  { id: '2907301', name: 'Castro Alves' },
  { id: '2907400', name: 'Catolândia' },
  { id: '2907509', name: 'Catu' },
  { id: '2907558', name: 'Caturama' },
  { id: '2907608', name: 'Central' },
  { id: '2907707', name: 'ChoRochó' },
  { id: '2907806', name: 'Cícero Dantas' },
  { id: '2907905', name: 'Cipó' },
  { id: '2908002', name: 'Coaraci' },
  { id: '2908101', name: 'Cocos' },
  { id: '2908200', name: 'Conceição da Feira' },
  { id: '2908309', name: 'Conceição do Almeida' },
  { id: '2908408', name: 'Conceição do Coité' },
  { id: '2908507', name: 'Conceição do Jacuípe' },
  { id: '2908606', name: 'Conde' },
  { id: '2908705', name: 'Condeúba' },
  { id: '2908804', name: 'Contendas do Sincorá' },
  { id: '2908903', name: 'Coração de Maria' },
  { id: '2909000', name: 'Cordeiros' },
  { id: '2909109', name: 'Coribe' },
  { id: '2909208', name: 'Coronel João Sá' },
  { id: '2909307', name: 'CoRentina' },
  { id: '2909406', name: 'Cotegipe' },
  { id: '2909505', name: 'Cravolândia' },
  { id: '2909604', name: 'Crisópolis' },
  { id: '2909703', name: 'Cristópolis' },
  { id: '2909802', name: 'Cruz das Almas' },
  { id: '2909901', name: 'Curaçá' },
  { id: '2910008', name: 'Dário Meira' },
  { id: '2910057', name: 'Dias d"Ávila' },
  { id: '2910107', name: 'Dom Basílio' },
  { id: '2910206', name: 'Dom Macedo Costa' },
  { id: '2910305', name: 'Elísio Medrado' },
  { id: '2910404', name: 'Encruzilhada' },
  { id: '2910503', name: 'Entre Rios' },
  { id: '2900504', name: 'Érico Cardoso' },
  { id: '2910602', name: 'Esplanada' },
  { id: '2910701', name: 'Euclides da Cunha' },
  { id: '2910727', name: 'Eunápolis' },
  { id: '2910750', name: 'Fátima' },
  { id: '2910776', name: 'Feira da Mata' },
  { id: '2910800', name: 'Feira de Santana' },
  { id: '2910859', name: 'Filadélfia' },
  { id: '2910909', name: 'Firmino Alves' },
  { id: '2911006', name: 'Floresta Azul' },
  { id: '2911105', name: 'Formosa do Rio Preto' },
  { id: '2911204', name: 'Gandu' },
  { id: '2911253', name: 'Gavião' },
  { id: '2911303', name: 'Gentio do Ouro' },
  { id: '2911402', name: 'Glória' },
  { id: '2911501', name: 'Gongogi' },
  { id: '2911600', name: 'Governador Mangabeira' },
  { id: '2911659', name: 'Guajeru' },
  { id: '2911709', name: 'Guanambi' },
  { id: '2911808', name: 'Guaratinga' },
  { id: '2911857', name: 'Heliópolis' },
  { id: '2911907', name: 'Iaçu' },
  { id: '2912004', name: 'IbiaSucê' },
  { id: '2912103', name: 'Ibicaraí' },
  { id: '2912202', name: 'Ibicoara' },
  { id: '2912301', name: 'Ibicuí' },
  { id: '2912400', name: 'Ibipeba' },
  { id: '2912509', name: 'Ibipitanga' },
  { id: '2912608', name: 'Ibiquera' },
  { id: '2912707', name: 'Ibirapitanga' },
  { id: '2912806', name: 'Ibirapuã' },
  { id: '2912905', name: 'Ibirataia' },
  { id: '2913002', name: 'Ibitiara' },
  { id: '2913101', name: 'Ibititá' },
  { id: '2913200', name: 'Ibotirama' },
  { id: '2913309', name: 'Ichu' },
  { id: '2913408', name: 'Igaporã' },
  { id: '2913457', name: 'Igrapiúna' },
  { id: '2913507', name: 'Iguaí' },
  { id: '2913606', name: 'Ilhéus' },
  { id: '2913705', name: 'Inhambupe' },
  { id: '2913804', name: 'Ipecaetá' },
  { id: '2913903', name: 'Ipiaú' },
  { id: '2914000', name: 'Ipirá' },
  { id: '2914109', name: 'Ipupiara' },
  { id: '2914208', name: 'Irajuba' },
  { id: '2914307', name: 'Iramaia' },
  { id: '2914406', name: 'Iraquara' },
  { id: '2914505', name: 'Irará' },
  { id: '2914604', name: 'Irecê' },
  { id: '2914653', name: 'Itabela' },
  { id: '2914703', name: 'Itaberaba' },
  { id: '2914802', name: 'Itabuna' },
  { id: '2914901', name: 'Itacaré' },
  { id: '2915007', name: 'Itaeté' },
  { id: '2915106', name: 'Itagi' },
  { id: '2915205', name: 'Itagibá' },
  { id: '2915304', name: 'Itagimirim' },
  { id: '2915353', name: 'Itaguaçu da Bahia' },
  { id: '2915403', name: 'Itaju do Colônia' },
  { id: '2915502', name: 'Itajuípe' },
  { id: '2915601', name: 'Itamaraju' },
  { id: '2915700', name: 'Itamari' },
  { id: '2915809', name: 'Itambé' },
  { id: '2915908', name: 'Itanagra' },
  { id: '2916005', name: 'Itanhém' },
  { id: '2916104', name: 'Itaparica' },
  { id: '2916203', name: 'Itapé' },
  { id: '2916302', name: 'Itapebi' },
  { id: '2916401', name: 'Itapetinga' },
  { id: '2916500', name: 'Itapicuru' },
  { id: '2916609', name: 'Itapitanga' },
  { id: '2916708', name: 'Itaquara' },
  { id: '2916807', name: 'Itarantim' },
  { id: '2916856', name: 'Itatim' },
  { id: '2916906', name: 'Itiruçu' },
  { id: '2917003', name: 'Itiúba' },
  { id: '2917102', name: 'Itororó' },
  { id: '2917201', name: 'Ituaçu' },
  { id: '2917300', name: 'Ituberá' },
  { id: '2917334', name: 'Iuiu' },
  { id: '2917359', name: 'Jaborandi' },
  { id: '2917409', name: 'Jacaraci' },
  { id: '2917508', name: 'Jacobina' },
  { id: '2917607', name: 'Jaguaquara' },
  { id: '2917706', name: 'Jaguarari' },
  { id: '2917805', name: 'Jaguaripe' },
  { id: '2917904', name: 'Jandaíra' },
  { id: '2918001', name: 'Jequié' },
  { id: '2918100', name: 'Jeremoabo' },
  { id: '2918209', name: 'Jiquiriçá' },
  { id: '2918308', name: 'Jitaúna' },
  { id: '2918357', name: 'João Dourado' },
  { id: '2918407', name: 'Juazeiro' },
  { id: '2918456', name: 'Jucuruçu' },
  { id: '2918506', name: 'JuSara' },
  { id: '2918555', name: 'JuSari' },
  { id: '2918605', name: 'JuSiape' },
  { id: '2918704', name: 'Lafaiete Coutinho' },
  { id: '2918753', name: 'Lagoa Real' },
  { id: '2918803', name: 'Laje' },
  { id: '2918902', name: 'Lajedão' },
  { id: '2919009', name: 'Lajedinho' },
  { id: '2919058', name: 'Lajedo do Tabocal' },
  { id: '2919108', name: 'Lamarão' },
  { id: '2919157', name: 'Lapão' },
  { id: '2919207', name: 'Lauro de Freitas' },
  { id: '2919306', name: 'Lençóis' },
  { id: '2919405', name: 'Licínio de Almeida' },
  { id: '2919504', name: 'Livramento de NoSa Senhora' },
  { id: '2919553', name: 'Luís Eduardo Magalhães' },
  { id: '2919603', name: 'Macajuba' },
  { id: '2919702', name: 'Macarani' },
  { id: '2919801', name: 'Macaúbas' },
  { id: '2919900', name: 'Macururé' },
  { id: '2919926', name: 'Madre de Deus' },
  { id: '2919959', name: 'Maetinga' },
  { id: '2920007', name: 'Maiquinique' },
  { id: '2920106', name: 'Mairi' },
  { id: '2920205', name: 'Malhada' },
  { id: '2920304', name: 'Malhada de Pedras' },
  { id: '2920403', name: 'Manoel Vitorino' },
  { id: '2920452', name: 'Mansidão' },
  { id: '2920502', name: 'Maracás' },
  { id: '2920601', name: 'Maragogipe' },
  { id: '2920700', name: 'Maraú' },
  { id: '2920809', name: 'Marcionílio Souza' },
  { id: '2920908', name: 'Mascote' },
  { id: '2921005', name: 'Mata de São João' },
  { id: '2921054', name: 'Matina' },
  { id: '2921104', name: 'Medeiros Neto' },
  { id: '2921203', name: 'Miguel Calmon' },
  { id: '2921302', name: 'Milagres' },
  { id: '2921401', name: 'Mirangaba' },
  { id: '2921450', name: 'Mirante' },
  { id: '2921500', name: 'Monte Santo' },
  { id: '2921609', name: 'Morpará' },
  { id: '2921708', name: 'MoRo do Chapéu' },
  { id: '2921807', name: 'Mortugaba' },
  { id: '2921906', name: 'Mucugê' },
  { id: '2922003', name: 'Mucuri' },
  { id: '2922052', name: 'Mulungu do MoRo' },
  { id: '2922102', name: 'Mundo Novo' },
  { id: '2922201', name: 'Muniz FeReira' },
  { id: '2922250', name: 'Muquém do São Francisco' },
  { id: '2922300', name: 'Muritiba' },
  { id: '2922409', name: 'Mutuípe' },
  { id: '2922508', name: 'Nazaré' },
  { id: '2922607', name: 'Nilo Peçanha' },
  { id: '2922656', name: 'Nordestina' },
  { id: '2922706', name: 'Nova Canaã' },
  { id: '2922730', name: 'Nova Fátima' },
  { id: '2922755', name: 'Nova Ibiá' },
  { id: '2922805', name: 'Nova Itarana' },
  { id: '2922854', name: 'Nova Redenção' },
  { id: '2922904', name: 'Nova Soure' },
  { id: '2923001', name: 'Nova Viçosa' },
  { id: '2923035', name: 'Novo Horizonte' },
  { id: '2923050', name: 'Novo Triunfo' },
  { id: '2923100', name: 'Olindina' },
  { id: '2923209', name: 'Oliveira dos Brejinhos' },
  { id: '2923308', name: 'Ouriçangas' },
  { id: '2923357', name: 'Ourolândia' },
  { id: '2923407', name: 'Palmas de Monte Alto' },
  { id: '2923506', name: 'Palmeiras' },
  { id: '2923605', name: 'Paramirim' },
  { id: '2923704', name: 'Paratinga' },
  { id: '2923803', name: 'Paripiranga' },
  { id: '2923902', name: 'Pau Brasil' },
  { id: '2924009', name: 'Paulo Afonso' },
  { id: '2924058', name: 'Pé de Serra' },
  { id: '2924108', name: 'Pedrão' },
  { id: '2924207', name: 'Pedro Alexandre' },
  { id: '2924306', name: 'Piatã' },
  { id: '2924405', name: 'Pilão Arcado' },
  { id: '2924504', name: 'Pindaí' },
  { id: '2924603', name: 'Pindobaçu' },
  { id: '2924652', name: 'Pintadas' },
  { id: '2924678', name: 'Piraí do Norte' },
  { id: '2924702', name: 'Piripá' },
  { id: '2924801', name: 'Piritiba' },
  { id: '2924900', name: 'Planaltino' },
  { id: '2925006', name: 'Planalto' },
  { id: '2925105', name: 'Poções' },
  { id: '2925204', name: 'Pojuca' },
  { id: '2925253', name: 'Ponto Novo' },
  { id: '2925303', name: 'Porto Seguro' },
  { id: '2925402', name: 'Potiraguá' },
  { id: '2925501', name: 'Prado' },
  { id: '2925600', name: 'Presidente Dutra' },
  { id: '2925709', name: 'Presidente Jânio Quadros' },
  { id: '2925758', name: 'Presidente Tancredo Neves' },
  { id: '2925808', name: 'QQueimadas' },
  { id: '2925907', name: 'Quijingue' },
  { id: '2925931', name: 'Quixabeira' },
  { id: '2925956', name: 'Rafael Jambeiro' },
  { id: '2926004', name: 'Remanso' },
  { id: '2926103', name: 'Retirolândia' },
  { id: '2926202', name: 'Riachão das Neves' },
  { id: '2926301', name: 'Riachão do Jacuípe' },
  { id: '2926400', name: 'Riacho de Santana' },
  { id: '2926509', name: 'Ribeira do Amparo' },
  { id: '2926608', name: 'Ribeira do Pombal' },
  { id: '2926657', name: 'Ribeirão do Largo' },
  { id: '2927002', name: 'Rio Real' },
  { id: '2926707', name: 'Rio de Contas' },
  { id: '2926806', name: 'Rio do Antônio' },
  { id: '2926905', name: 'Rio do Pires' },
  { id: '2927101', name: 'Rodelas' },
  { id: '2927200', name: 'Ruy Barbosa' },
  { id: '2927309', name: 'Salinas da Margarida' },
  { id: '2927408', name: 'Salvador' },
  { id: '2927507', name: 'Santa Bárbara' },
  { id: '2927606', name: 'Santa Brígida' },
  { id: '2927705', name: 'Santa Cruz Cabrália' },
  { id: '2927804', name: 'Santa Cruz da Vitória' },
  { id: '2927903', name: 'Santa Inês' },
  { id: '2928059', name: 'Santa Luzia' },
  { id: '2928109', name: 'Santa Maria da Vitória' },
  { id: '2928406', name: 'Santa Rita de CáSia' },
  { id: '2928505', name: 'Santa Terezinha' },
  { id: '2928000', name: 'Santaluz' },
  { id: '2928208', name: 'Santana' },
  { id: '2928307', name: 'Santanópolis' },
  { id: '2928604', name: 'Santo Amaro' },
  { id: '2928703', name: 'Santo Antônio de Jesus' },
  { id: '2928802', name: 'Santo Estêvão' },
  { id: '2928901', name: 'São Desidério' },
  { id: '2928950', name: 'São Domingos' },
  { id: '2929107', name: 'São Felipe' },
  { id: '2929008', name: 'São Félix' },
  { id: '2929057', name: 'São Félix do Coribe' },
  { id: '2929206', name: 'São Francisco do Conde' },
  { id: '2929255', name: 'São Gabriel' },
  { id: '2929305', name: 'São Gonçalo dos Campos' },
  { id: '2929354', name: 'São José da Vitória' },
  { id: '2929370', name: 'São José do Jacuípe' },
  { id: '2929404', name: 'São Miguel das Matas' },
  { id: '2929503', name: 'São Sebastião do PaSé' },
  { id: '2929602', name: 'Sapeaçu' },
  { id: '2929701', name: 'Sátiro Dias' },
  { id: '2929750', name: 'Saubara' },
  { id: '2929800', name: 'Saúde' },
  { id: '2929909', name: 'Seabra' },
  { id: '2930006', name: 'Sebastião Laranjeiras' },
  { id: '2930105', name: 'Senhor do Bonfim' },
  { id: '2930204', name: 'Sento Sé' },
  { id: '2930303', name: 'Serra Dourada' },
  { id: '2930402', name: 'Serra Preta' },
  { id: '2930154', name: 'Serra do Ramalho' },
  { id: '2930501', name: 'SeRinha' },
  { id: '2930600', name: 'SeRolândia' },
  { id: '2930709', name: 'Simões Filho' },
  { id: '2930758', name: 'Sítio do Mato' },
  { id: '2930766', name: 'Sítio do Quinto' },
  { id: '2930774', name: 'Sobradinho' },
  { id: '2930808', name: 'Souto Soares' },
  { id: '2930907', name: 'Tabocas do Brejo Velho' },
  { id: '2931004', name: 'Tanhaçu' },
  { id: '2931053', name: 'Tanque Novo' },
  { id: '2931103', name: 'Tanquinho' },
  { id: '2931202', name: 'Taperoá' },
  { id: '2931301', name: 'Tapiramutá' },
  { id: '2931350', name: 'Teixeira de Freitas' },
  { id: '2931400', name: 'Teodoro Sampaio' },
  { id: '2931509', name: 'Teofilândia' },
  { id: '2931608', name: 'Teolândia' },
  { id: '2931707', name: 'TeRa Nova' },
  { id: '2931806', name: 'Tremedal' },
  { id: '2931905', name: 'Tucano' },
  { id: '2932002', name: 'Uauá' },
  { id: '2932101', name: 'Ubaíra' },
  { id: '2932200', name: 'Ubaitaba' },
  { id: '2932309', name: 'Ubatã' },
  { id: '2932408', name: 'Uibaí' },
  { id: '2932457', name: 'Umburanas' },
  { id: '2932507', name: 'Una' },
  { id: '2932606', name: 'Urandi' },
  { id: '2932705', name: 'Uruçuca' },
  { id: '2932804', name: 'Utinga' },
  { id: '2932903', name: 'Valença' },
  { id: '2933000', name: 'Valente' },
  { id: '2933158', name: 'Várzea Nova' },
  { id: '2933059', name: 'Várzea da Roça' },
  { id: '2933109', name: 'Várzea do Poço' },
  { id: '2933174', name: 'Varzedo' },
  { id: '2933208', name: 'Vera Cruz' },
  { id: '2933257', name: 'Vereda' },
  { id: '2933307', name: 'Vitória da Conquista' },
  { id: '2933406', name: 'Wagner' },
  { id: '2933455', name: 'Wanderley' },
  { id: '2933505', name: 'Wenceslau Guimarães' },
  { id: '2933604', name: 'Xique-Xique' },
  { id: '2300101', name: 'Abaiara' },
  { id: '2300150', name: 'Acarape' },
  { id: '2300200', name: 'Acaraú' },
  { id: '2300309', name: 'Acopiara' },
  { id: '2300408', name: 'Aiuaba' },
  { id: '2300507', name: 'Alcântaras' },
  { id: '2300606', name: 'Altaneira' },
  { id: '2300705', name: 'Alto Santo' },
  { id: '2300754', name: 'Amontada' },
  { id: '2300804', name: 'Antonina do Norte' },
  { id: '2300903', name: 'Apuiarés' },
  { id: '2301000', name: 'Aquiraz' },
  { id: '2301109', name: 'Aracati' },
  { id: '2301208', name: 'Aracoiaba' },
  { id: '2301257', name: 'Ararendá' },
  { id: '2301307', name: 'Araripe' },
  { id: '2301406', name: 'Aratuba' },
  { id: '2301505', name: 'Arneiroz' },
  { id: '2301604', name: 'ASaré' },
  { id: '2301703', name: 'Aurora' },
  { id: '2301802', name: 'Baixio' },
  { id: '2301851', name: 'Banabuiú' },
  { id: '2301901', name: 'Barbalha' },
  { id: '2301950', name: 'BaReira' },
  { id: '2302008', name: 'BaRo' },
  { id: '2302057', name: 'BaRoquinha' },
  { id: '2302107', name: 'Baturité' },
  { id: '2302206', name: 'Beberibe' },
  { id: '2302305', name: 'Bela Cruz' },
  { id: '2302404', name: 'Boa Viagem' },
  { id: '2302503', name: 'Brejo Santo' },
  { id: '2302602', name: 'Camocim' },
  { id: '2302701', name: 'Campos Sales' },
  { id: '2302800', name: 'Canindé' },
  { id: '2302909', name: 'Capistrano' },
  { id: '2303006', name: 'Caridade' },
  { id: '2303105', name: 'Cariré' },
  { id: '2303204', name: 'Caririaçu' },
  { id: '2303303', name: 'Cariús' },
  { id: '2303402', name: 'Carnaubal' },
  { id: '2303501', name: 'Cascavel' },
  { id: '2303600', name: 'Catarina' },
  { id: '2303659', name: 'Catunda' },
  { id: '2303709', name: 'Caucaia' },
  { id: '2303808', name: 'Cedro' },
  { id: '2303907', name: 'Chaval' },
  { id: '2303931', name: 'Choró' },
  { id: '2303956', name: 'Chorozinho' },
  { id: '2304004', name: 'Coreaú' },
  { id: '2304103', name: 'Crateús' },
  { id: '2304202', name: 'Crato' },
  { id: '2304236', name: 'Croatá' },
  { id: '2304251', name: 'Cruz' },
  { id: '2304269', name: 'Deputado Irapuan Pinheiro' },
  { id: '2304277', name: 'Ereré' },
  { id: '2304285', name: 'Eusébio' },
  { id: '2304301', name: 'Farias Brito' },
  { id: '2304350', name: 'Forquilha' },
  { id: '2304400', name: 'Fortaleza' },
  { id: '2304459', name: 'Fortim' },
  { id: '2304509', name: 'Frecheirinha' },
  { id: '2304608', name: 'General Sampaio' },
  { id: '2304657', name: 'Graça' },
  { id: '2304707', name: 'Granja' },
  { id: '2304806', name: 'Granjeiro' },
  { id: '2304905', name: 'Groaíras' },
  { id: '2304954', name: 'Guaiúba' },
  { id: '2305001', name: 'Guaraciaba do Norte' },
  { id: '2305100', name: 'Guaramiranga' },
  { id: '2305209', name: 'Hidrolândia' },
  { id: '2305233', name: 'Horizonte' },
  { id: '2305266', name: 'Ibaretama' },
  { id: '2305308', name: 'Ibiapina' },
  { id: '2305332', name: 'Ibicuitinga' },
  { id: '2305357', name: 'Icapuí' },
  { id: '2305407', name: 'Icó' },
  { id: '2305506', name: 'Iguatu' },
  { id: '2305605', name: 'Independência' },
  { id: '2305654', name: 'Ipaporanga' },
  { id: '2305704', name: 'Ipaumirim' },
  { id: '2305803', name: 'Ipu' },
  { id: '2305902', name: 'Ipueiras' },
  { id: '2306009', name: 'Iracema' },
  { id: '2306108', name: 'Irauçuba' },
  { id: '2306207', name: 'Itaiçaba' },
  { id: '2306256', name: 'Itaitinga' },
  { id: '2306306', name: 'Itapajé' },
  { id: '2306405', name: 'Itapipoca' },
  { id: '2306504', name: 'Itapiúna' },
  { id: '2306553', name: 'Itarema' },
  { id: '2306603', name: 'Itatira' },
  { id: '2306702', name: 'Jaguaretama' },
  { id: '2306801', name: 'Jaguaribara' },
  { id: '2306900', name: 'Jaguaribe' },
  { id: '2307007', name: 'Jaguaruana' },
  { id: '2307106', name: 'Jardim' },
  { id: '2307205', name: 'Jati' },
  { id: '2307254', name: 'Jijoca de Jericoacoara' },
  { id: '2307304', name: 'Juazeiro do Norte' },
  { id: '2307403', name: 'Jucás' },
  { id: '2307502', name: 'Lavras da Mangabeira' },
  { id: '2307601', name: 'Limoeiro do Norte' },
  { id: '2307635', name: 'Madalena' },
  { id: '2307650', name: 'Maracanaú' },
  { id: '2307700', name: 'Maranguape' },
  { id: '2307809', name: 'Marco' },
  { id: '2307908', name: 'Martinópole' },
  { id: '2308005', name: 'MaSapê' },
  { id: '2308104', name: 'Mauriti' },
  { id: '2308203', name: 'Meruoca' },
  { id: '2308302', name: 'Milagres' },
  { id: '2308351', name: 'Milhã' },
  { id: '2308377', name: 'Miraíma' },
  { id: '2308401', name: 'MiSão Velha' },
  { id: '2308500', name: 'Mombaça' },
  { id: '2308609', name: 'Monsenhor Tabosa' },
  { id: '2308708', name: 'Morada Nova' },
  { id: '2308807', name: 'Moraújo' },
  { id: '2308906', name: 'MoRinhos' },
  { id: '2309003', name: 'Mucambo' },
  { id: '2309102', name: 'Mulungu' },
  { id: '2309201', name: 'Nova Olinda' },
  { id: '2309300', name: 'Nova RuSas' },
  { id: '2309409', name: 'Novo Oriente' },
  { id: '2309458', name: 'Ocara' },
  { id: '2309508', name: 'Orós' },
  { id: '2309607', name: 'Pacajus' },
  { id: '2309706', name: 'Pacatuba' },
  { id: '2309805', name: 'Pacoti' },
  { id: '2309904', name: 'Pacujá' },
  { id: '2310001', name: 'Palhano' },
  { id: '2310100', name: 'Palmácia' },
  { id: '2310209', name: 'Paracuru' },
  { id: '2310258', name: 'Paraipaba' },
  { id: '2310308', name: 'Parambu' },
  { id: '2310407', name: 'Paramoti' },
  { id: '2310506', name: 'Pedra Branca' },
  { id: '2310605', name: 'Penaforte' },
  { id: '2310704', name: 'Pentecoste' },
  { id: '2310803', name: 'Pereiro' },
  { id: '2310852', name: 'Pindoretama' },
  { id: '2310902', name: 'Piquet Carneiro' },
  { id: '2310951', name: 'Pires FeReira' },
  { id: '2311009', name: 'Poranga' },
  { id: '2311108', name: 'Porteiras' },
  { id: '2311207', name: 'Potengi' },
  { id: '2311231', name: 'Potiretama' },
  { id: '2311264', name: 'QQuiterianópolis' },
  { id: '2311306', name: 'Quixadá' },
  { id: '2311355', name: 'Quixelô' },
  { id: '2311405', name: 'Quixeramobim' },
  { id: '2311504', name: 'Quixeré' },
  { id: '2311603', name: 'Redenção' },
  { id: '2311702', name: 'Reriutaba' },
  { id: '2311801', name: 'RuSas' },
  { id: '2311900', name: 'Saboeiro' },
  { id: '2311959', name: 'Salitre' },
  { id: '2312205', name: 'Santa Quitéria' },
  { id: '2312007', name: 'Santana do Acaraú' },
  { id: '2312106', name: 'Santana do Cariri' },
  { id: '2312304', name: 'São Benedito' },
  { id: '2312403', name: 'São Gonçalo do Amarante' },
  { id: '2312502', name: 'São João do Jaguaribe' },
  { id: '2312601', name: 'São Luís do Curu' },
  { id: '2312700', name: 'Senador Pompeu' },
  { id: '2312809', name: 'Senador Sá' },
  { id: '2312908', name: 'Sobral' },
  { id: '2313005', name: 'Solonópole' },
  { id: '2313104', name: 'Tabuleiro do Norte' },
  { id: '2313203', name: 'Tamboril' },
  { id: '2313252', name: 'TaRafas' },
  { id: '2313302', name: 'Tauá' },
  { id: '2313351', name: 'Tejuçuoca' },
  { id: '2313401', name: 'Tianguá' },
  { id: '2313500', name: 'Trairi' },
  { id: '2313559', name: 'Tururu' },
  { id: '2313609', name: 'Ubajara' },
  { id: '2313708', name: 'Umari' },
  { id: '2313757', name: 'Umirim' },
  { id: '2313807', name: 'Uruburetama' },
  { id: '2313906', name: 'Uruoca' },
  { id: '2313955', name: 'Varjota' },
  { id: '2314003', name: 'Várzea Alegre' },
  { id: '2314102', name: 'Viçosa do Ceará' },
  { id: '5300108', name: 'Brasília' },
  { id: '3200102', name: 'Afonso Cláudio' },
  { id: '3200169', name: 'Água Doce do Norte' },
  { id: '3200136', name: 'Águia Branca' },
  { id: '3200201', name: 'Alegre' },
  { id: '3200300', name: 'Alfredo Chaves' },
  { id: '3200359', name: 'Alto Rio Novo' },
  { id: '3200409', name: 'Anchieta' },
  { id: '3200508', name: 'Apiacá' },
  { id: '3200607', name: 'Aracruz' },
  { id: '3200706', name: 'Atílio Vivácqua' },
  { id: '3200805', name: 'Baixo Guandu' },
  { id: '3200904', name: 'BaRa de São Francisco' },
  { id: '3201001', name: 'Boa Esperança' },
  { id: '3201100', name: 'Bom Jesus do Norte' },
  { id: '3201159', name: 'Brejetuba' },
  { id: '3201209', name: 'Cachoeiro de Itapemirim' },
  { id: '3201308', name: 'Cariacica' },
  { id: '3201407', name: 'Castelo' },
  { id: '3201506', name: 'Colatina' },
  { id: '3201605', name: 'Conceição da BaRa' },
  { id: '3201704', name: 'Conceição do Castelo' },
  { id: '3201803', name: 'Divino de São Lourenço' },
  { id: '3201902', name: 'Domingos Martins' },
  { id: '3202009', name: 'Dores do Rio Preto' },
  { id: '3202108', name: 'Ecoporanga' },
  { id: '3202207', name: 'Fundão' },
  { id: '3202256', name: 'Governador Lindenberg' },
  { id: '3202306', name: 'Guaçuí' },
  { id: '3202405', name: 'Guarapari' },
  { id: '3202454', name: 'Ibatiba' },
  { id: '3202504', name: 'Ibiraçu' },
  { id: '3202553', name: 'Ibitirama' },
  { id: '3202603', name: 'Iconha' },
  { id: '3202652', name: 'Irupi' },
  { id: '3202702', name: 'Itaguaçu' },
  { id: '3202801', name: 'Itapemirim' },
  { id: '3202900', name: 'Itarana' },
  { id: '3203007', name: 'Iúna' },
  { id: '3203056', name: 'Jaguaré' },
  { id: '3203106', name: 'Jerônimo Monteiro' },
  { id: '3203130', name: 'João Neiva' },
  { id: '3203163', name: 'Laranja da TeRa' },
  { id: '3203205', name: 'Linhares' },
  { id: '3203304', name: 'Mantenópolis' },
  { id: '3203320', name: 'Marataízes' },
  { id: '3203346', name: 'Marechal Floriano' },
  { id: '3203353', name: 'Marilândia' },
  { id: '3203403', name: 'Mimoso do Sul' },
  { id: '3203502', name: 'Montanha' },
  { id: '3203601', name: 'Mucurici' },
  { id: '3203700', name: 'Muniz Freire' },
  { id: '3203809', name: 'Muqui' },
  { id: '3203908', name: 'Nova Venécia' },
  { id: '3204005', name: 'Pancas' },
  { id: '3204054', name: 'Pedro Canário' },
  { id: '3204104', name: 'Pinheiros' },
  { id: '3204203', name: 'Piúma' },
  { id: '3204252', name: 'Ponto Belo' },
  { id: '3204302', name: 'Presidente KeNedy' },
  { id: '3204351', name: 'Rio Bananal' },
  { id: '3204401', name: 'Rio Novo do Sul' },
  { id: '3204500', name: 'Santa Leopoldina' },
  { id: '3204559', name: 'Santa Maria de Jetibá' },
  { id: '3204609', name: 'Santa Teresa' },
  { id: '3204658', name: 'São Domingos do Norte' },
  { id: '3204708', name: 'São Gabriel da Palha' },
  { id: '3204807', name: 'São José do Calçado' },
  { id: '3204906', name: 'São Mateus' },
  { id: '3204955', name: 'São Roque do Canaã' },
  { id: '3205002', name: 'Serra' },
  { id: '3205010', name: 'SOretama' },
  { id: '3205036', name: 'Vargem Alta' },
  { id: '3205069', name: 'Venda Nova do Imigrante' },
  { id: '3205101', name: 'Viana' },
  { id: '3205150', name: 'Vila Pavão' },
  { id: '3205176', name: 'Vila Valério' },
  { id: '3205200', name: 'Vila Velha' },
  { id: '3205309', name: 'Vitória' },
  { id: '5200050', name: 'Abadia de Goiás' },
  { id: '5200100', name: 'Abadiânia' },
  { id: '5200134', name: 'Acreúna' },
  { id: '5200159', name: 'Adelândia' },
  { id: '5200175', name: 'Água Fria de Goiás' },
  { id: '5200209', name: 'Água Limpa' },
  { id: '5200258', name: 'Águas Lindas de Goiás' },
  { id: '5200308', name: 'Alexânia' },
  { id: '5200506', name: 'Aloândia' },
  { id: '5200555', name: 'Alto Horizonte' },
  { id: '5200605', name: 'Alto Paraíso de Goiás' },
  { id: '5200803', name: 'Alvorada do Norte' },
  { id: '5200829', name: 'Amaralina' },
  { id: '5200852', name: 'Americano do Brasil' },
  { id: '5200902', name: 'Amorinópolis' },
  { id: '5201108', name: 'Anápolis' },
  { id: '5201207', name: 'Anhanguera' },
  { id: '5201306', name: 'Anicuns' },
  { id: '5201405', name: 'Aparecida de Goiânia' },
  { id: '5201454', name: 'Aparecida do Rio Doce' },
  { id: '5201504', name: 'Aporé' },
  { id: '5201603', name: 'Araçu' },
  { id: '5201702', name: 'Aragarças' },
  { id: '5201801', name: 'Aragoiânia' },
  { id: '5202155', name: 'Araguapaz' },
  { id: '5202353', name: 'Arenópolis' },
  { id: '5202502', name: 'Aruanã' },
  { id: '5202601', name: 'Aurilândia' },
  { id: '5202809', name: 'Avelinópolis' },
  { id: '5203104', name: 'Baliza' },
  { id: '5203203', name: 'BaRo Alto' },
  { id: '5203302', name: 'Bela Vista de Goiás' },
  { id: '5203401', name: 'Bom Jardim de Goiás' },
  { id: '5203500', name: 'Bom Jesus de Goiás' },
  { id: '5203559', name: 'Bonfinópolis' },
  { id: '5203575', name: 'Bonópolis' },
  { id: '5203609', name: 'Brazabrantes' },
  { id: '5203807', name: 'Britânia' },
  { id: '5203906', name: 'Buriti Alegre' },
  { id: '5203939', name: 'Buriti de Goiás' },
  { id: '5203962', name: 'Buritinópolis' },
  { id: '5204003', name: 'Cabeceiras' },
  { id: '5204102', name: 'Cachoeira Alta' },
  { id: '5204250', name: 'Cachoeira Dourada' },
  { id: '5204201', name: 'Cachoeira de Goiás' },
  { id: '5204300', name: 'Caçu' },
  { id: '5204409', name: 'Caiapônia' },
  { id: '5204508', name: 'Caldas Novas' },
  { id: '5204557', name: 'Caldazinha' },
  { id: '5204607', name: 'Campestre de Goiás' },
  { id: '5204656', name: 'Campinaçu' },
  { id: '5204706', name: 'Campinorte' },
  { id: '5204805', name: 'Campo Alegre de Goiás' },
  { id: '5204854', name: 'Campo Limpo de Goiás' },
  { id: '5204904', name: 'Campos Belos' },
  { id: '5204953', name: 'Campos Verdes' },
  { id: '5205000', name: 'Carmo do Rio Verde' },
  { id: '5205059', name: 'Castelândia' },
  { id: '5205109', name: 'Catalão' },
  { id: '5205208', name: 'Caturaí' },
  { id: '5205307', name: 'Cavalcante' },
  { id: '5205406', name: 'Ceres' },
  { id: '5205455', name: 'Cezarina' },
  { id: '5205471', name: 'Chapadão do Céu' },
  { id: '5205497', name: 'Cidade Ocidental' },
  { id: '5205513', name: 'Cocalzinho de Goiás' },
  { id: '5205521', name: 'Colinas do Sul' },
  { id: '5205703', name: 'CóRego do Ouro' },
  { id: '5205802', name: 'Corumbá de Goiás' },
  { id: '5205901', name: 'Corumbaíba' },
  { id: '5206206', name: 'Cristalina' },
  { id: '5206305', name: 'Cristianópolis' },
  { id: '5206404', name: 'Crixás' },
  { id: '5206503', name: 'Cromínia' },
  { id: '5206602', name: 'Cumari' },
  { id: '5206701', name: 'Damianópolis' },
  { id: '5206800', name: 'Damolândia' },
  { id: '5206909', name: 'Davinópolis' },
  { id: '5207105', name: 'Diorama' },
  { id: '5208301', name: 'Divinópolis de Goiás' },
  { id: '5207253', name: 'Doverlândia' },
  { id: '5207352', name: 'Edealina' },
  { id: '5207402', name: 'Edéia' },
  { id: '5207501', name: 'Estrela do Norte' },
  { id: '5207535', name: 'Faina' },
  { id: '5207600', name: 'Fazenda Nova' },
  { id: '5207808', name: 'Firminópolis' },
  { id: '5207907', name: 'Flores de Goiás' },
  { id: '5208004', name: 'Formosa' },
  { id: '5208103', name: 'Formoso' },
  { id: '5208152', name: 'Gameleira de Goiás' },
  { id: '5208400', name: 'Goianápolis' },
  { id: '5208509', name: 'Goiandira' },
  { id: '5208608', name: 'Goianésia' },
  { id: '5208707', name: 'Goiânia' },
  { id: '5208806', name: 'Goianira' },
  { id: '5208905', name: 'Goiás' },
  { id: '5209101', name: 'Goiatuba' },
  { id: '5209150', name: 'Gouvelândia' },
  { id: '5209200', name: 'Guapó' },
  { id: '5209291', name: 'Guaraíta' },
  { id: '5209408', name: 'Guarani de Goiás' },
  { id: '5209457', name: 'Guarinos' },
  { id: '5209606', name: 'Heitoraí' },
  { id: '5209705', name: 'Hidrolândia' },
  { id: '5209804', name: 'Hidrolina' },
  { id: '5209903', name: 'Iaciara' },
  { id: '5209937', name: 'Inaciolândia' },
  { id: '5209952', name: 'Indiara' },
  { id: '5210000', name: 'Inhumas' },
  { id: '5210109', name: 'Ipameri' },
  { id: '5210158', name: 'Ipiranga de Goiás' },
  { id: '5210208', name: 'Iporá' },
  { id: '5210307', name: 'Israelândia' },
  { id: '5210406', name: 'Itaberaí' },
  { id: '5210562', name: 'Itaguari' },
  { id: '5210604', name: 'Itaguaru' },
  { id: '5210802', name: 'Itajá' },
  { id: '5210901', name: 'Itapaci' },
  { id: '5211008', name: 'Itapirapuã' },
  { id: '5211206', name: 'Itapuranga' },
  { id: '5211305', name: 'Itarumã' },
  { id: '5211404', name: 'Itauçu' },
  { id: '5211503', name: 'Itumbiara' },
  { id: '5211602', name: 'Ivolândia' },
  { id: '5211701', name: 'Jandaia' },
  { id: '5211800', name: 'Jaraguá' },
  { id: '5211909', name: 'Jataí' },
  { id: '5212006', name: 'Jaupaci' },
  { id: '5212055', name: 'Jesúpolis' },
  { id: '5212105', name: 'Joviânia' },
  { id: '5212204', name: 'JuSara' },
  { id: '5212253', name: 'Lagoa Santa' },
  { id: '5212303', name: 'Leopoldo de Bulhões' },
  { id: '5212501', name: 'Luziânia' },
  { id: '5212600', name: 'Mairipotaba' },
  { id: '5212709', name: 'Mambaí' },
  { id: '5212808', name: 'Mara Rosa' },
  { id: '5212907', name: 'Marzagão' },
  { id: '5212956', name: 'Matrinchã' },
  { id: '5213004', name: 'Maurilândia' },
  { id: '5213053', name: 'Mimoso de Goiás' },
  { id: '5213087', name: 'Minaçu' },
  { id: '5213103', name: 'Mineiros' },
  { id: '5213400', name: 'Moiporá' },
  { id: '5213509', name: 'Monte Alegre de Goiás' },
  { id: '5213707', name: 'Montes Claros de Goiás' },
  { id: '5213756', name: 'Montividiu' },
  { id: '5213772', name: 'Montividiu do Norte' },
  { id: '5213806', name: 'MoRinhos' },
  { id: '5213855', name: 'MoRo Agudo de Goiás' },
  { id: '5213905', name: 'MoSâmedes' },
  { id: '5214002', name: 'Mozarlândia' },
  { id: '5214051', name: 'Mundo Novo' },
  { id: '5214101', name: 'Mutunópolis' },
  { id: '5214408', name: 'Nazário' },
  { id: '5214507', name: 'Nerópolis' },
  { id: '5214606', name: 'Niquelândia' },
  { id: '5214705', name: 'Nova América' },
  { id: '5214804', name: 'Nova Aurora' },
  { id: '5214838', name: 'Nova Crixás' },
  { id: '5214861', name: 'Nova Glória' },
  { id: '5214879', name: 'Nova Iguaçu de Goiás' },
  { id: '5214903', name: 'Nova Roma' },
  { id: '5215009', name: 'Nova Veneza' },
  { id: '5215207', name: 'Novo Brasil' },
  { id: '5215231', name: 'Novo Gama' },
  { id: '5215256', name: 'Novo Planalto' },
  { id: '5215306', name: 'Orizona' },
  { id: '5215405', name: 'Ouro Verde de Goiás' },
  { id: '5215504', name: 'Ouvidor' },
  { id: '5215603', name: 'Padre Bernardo' },
  { id: '5215652', name: 'Palestina de Goiás' },
  { id: '5215702', name: 'Palmeiras de Goiás' },
  { id: '5215801', name: 'Palmelo' },
  { id: '5215900', name: 'Palminópolis' },
  { id: '5216007', name: 'Panamá' },
  { id: '5216304', name: 'Paranaiguara' },
  { id: '5216403', name: 'Paraúna' },
  { id: '5216452', name: 'Perolândia' },
  { id: '5216809', name: 'Petrolina de Goiás' },
  { id: '5216908', name: 'Pilar de Goiás' },
  { id: '5217104', name: 'Piracanjuba' },
  { id: '5217203', name: 'Piranhas' },
  { id: '5217302', name: 'Pirenópolis' },
  { id: '5217401', name: 'Pires do Rio' },
  { id: '5217609', name: 'Planaltina' },
  { id: '5217708', name: 'Pontalina' },
  { id: '5218003', name: 'Porangatu' },
  { id: '5218052', name: 'Porteirão' },
  { id: '5218102', name: 'Portelândia' },
  { id: '5218300', name: 'PoSe' },
  { id: '5218391', name: 'ProfeSor Jamil' },
  { id: '5218508', name: 'QQuirinópolis' },
  { id: '5218607', name: 'Rialma' },
  { id: '5218706', name: 'Rianápolis' },
  { id: '5218789', name: 'Rio Quente' },
  { id: '5218805', name: 'Rio Verde' },
  { id: '5218904', name: 'Rubiataba' },
  { id: '5219001', name: 'Sanclerlândia' },
  { id: '5219100', name: 'Santa Bárbara de Goiás' },
  { id: '5219209', name: 'Santa Cruz de Goiás' },
  { id: '5219258', name: 'Santa Fé de Goiás' },
  { id: '5219308', name: 'Santa Helena de Goiás' },
  { id: '5219357', name: 'Santa Isabel' },
  { id: '5219407', name: 'Santa Rita do Araguaia' },
  { id: '5219456', name: 'Santa Rita do Novo Destino' },
  { id: '5219506', name: 'Santa Rosa de Goiás' },
  { id: '5219605', name: 'Santa Tereza de Goiás' },
  { id: '5219704', name: 'Santa Terezinha de Goiás' },
  { id: '5219712', name: 'Santo Antônio da BaRa' },
  { id: '5219738', name: 'Santo Antônio de Goiás' },
  { id: '5219753', name: 'Santo Antônio do Descoberto' },
  { id: '5219803', name: 'São Domingos' },
  { id: '5219902', name: 'São Francisco de Goiás' },
  { id: '5220009', name: 'São João d"Aliança' },
  { id: '5220058', name: 'São João da Paraúna' },
  { id: '5220108', name: 'São Luís de Montes Belos' },
  { id: '5220157', name: 'São Luiz do Norte' },
  { id: '5220207', name: 'São Miguel do Araguaia' },
  { id: '5220264', name: 'São Miguel do PaSa Quatro' },
  { id: '5220280', name: 'São Patrício' },
  { id: '5220405', name: 'São Simão' },
  { id: '5220454', name: 'Senador Canedo' },
  { id: '5220504', name: 'Serranópolis' },
  { id: '5220603', name: 'Silvânia' },
  { id: '5220686', name: 'Simolândia' },
  { id: '5220702', name: 'Sítio d"Abadia' },
  { id: '5221007', name: 'Taquaral de Goiás' },
  { id: '5221080', name: 'Teresina de Goiás' },
  { id: '5221197', name: 'Terezópolis de Goiás' },
  { id: '5221304', name: 'Três Ranchos' },
  { id: '5221403', name: 'Trindade' },
  { id: '5221452', name: 'Trombas' },
  { id: '5221502', name: 'Turvânia' },
  { id: '5221551', name: 'Turvelândia' },
  { id: '5221577', name: 'Uirapuru' },
  { id: '5221601', name: 'Uruaçu' },
  { id: '5221700', name: 'Uruana' },
  { id: '5221809', name: 'Urutaí' },
  { id: '5221858', name: 'Valparaíso de Goiás' },
  { id: '5221908', name: 'Varjão' },
  { id: '5222005', name: 'Vianópolis' },
  { id: '5222054', name: 'Vicentinópolis' },
  { id: '5222203', name: 'Vila Boa' },
  { id: '5222302', name: 'Vila Propício' },
  { id: '2100055', name: 'Açailândia' },
  { id: '2100105', name: 'Afonso Cunha' },
  { id: '2100154', name: 'Água Doce do Maranhão' },
  { id: '2100204', name: 'Alcântara' },
  { id: '2100303', name: 'Aldeias Altas' },
  { id: '2100402', name: 'Altamira do Maranhão' },
  { id: '2100436', name: 'Alto Alegre do Maranhão' },
  { id: '2100477', name: 'Alto Alegre do Pindaré' },
  { id: '2100501', name: 'Alto Parnaíba' },
  { id: '2100550', name: 'Amapá do Maranhão' },
  { id: '2100600', name: 'Amarante do Maranhão' },
  { id: '2100709', name: 'Anajatuba' },
  { id: '2100808', name: 'Anapurus' },
  { id: '2100832', name: 'Apicum-Açu' },
  { id: '2100873', name: 'Araguanã' },
  { id: '2100907', name: 'Araioses' },
  { id: '2100956', name: 'Arame' },
  { id: '2101004', name: 'Arari' },
  { id: '2101103', name: 'Axixá' },
  { id: '2101202', name: 'Bacabal' },
  { id: '2101251', name: 'Bacabeira' },
  { id: '2101301', name: 'Bacuri' },
  { id: '2101350', name: 'Bacurituba' },
  { id: '2101400', name: 'Balsas' },
  { id: '2101509', name: 'Barão de Grajaú' },
  { id: '2101608', name: 'BaRa do Corda' },
  { id: '2101707', name: 'BaReirinhas' },
  { id: '2101772', name: 'Bela Vista do Maranhão' },
  { id: '2101731', name: 'Belágua' },
  { id: '2101806', name: 'Benedito Leite' },
  { id: '2101905', name: 'Bequimão' },
  { id: '2101939', name: 'Bernardo do Mearim' },
  { id: '2101970', name: 'Boa Vista do Gurupi' },
  { id: '2102002', name: 'Bom Jardim' },
  { id: '2102036', name: 'Bom Jesus das Selvas' },
  { id: '2102077', name: 'Bom Lugar' },
  { id: '2102101', name: 'Brejo' },
  { id: '2102150', name: 'Brejo de Areia' },
  { id: '2102200', name: 'Buriti' },
  { id: '2102309', name: 'Buriti Bravo' },
  { id: '2102325', name: 'Buriticupu' },
  { id: '2102358', name: 'Buritirana' },
  { id: '2102374', name: 'Cachoeira Grande' },
  { id: '2102408', name: 'Cajapió' },
  { id: '2102507', name: 'Cajari' },
  { id: '2102556', name: 'Campestre do Maranhão' },
  { id: '2102606', name: 'Cândido Mendes' },
  { id: '2102705', name: 'Cantanhede' },
  { id: '2102754', name: 'Capinzal do Norte' },
  { id: '2102804', name: 'Carolina' },
  { id: '2102903', name: 'Carutapera' },
  { id: '2103000', name: 'Caxias' },
  { id: '2103109', name: 'Cedral' },
  { id: '2103125', name: 'Central do Maranhão' },
  { id: '2103174', name: 'Centro Novo do Maranhão' },
  { id: '2103158', name: 'Centro do Guilherme' },
  { id: '2103208', name: 'Chapadinha' },
  { id: '2103257', name: 'Cidelândia' },
  { id: '2103307', name: 'Codó' },
  { id: '2103406', name: 'Coelho Neto' },
  { id: '2103505', name: 'Colinas' },
  { id: '2103554', name: 'Conceição do Lago-Açu' },
  { id: '2103604', name: 'Coroatá' },
  { id: '2103703', name: 'Cururupu' },
  { id: '2103752', name: 'Davinópolis' },
  { id: '2103802', name: 'Dom Pedro' },
  { id: '2103901', name: 'Duque Bacelar' },
  { id: '2104008', name: 'Esperantinópolis' },
  { id: '2104057', name: 'Estreito' },
  { id: '2104073', name: 'Feira Nova do Maranhão' },
  { id: '2104081', name: 'Fernando Falcão' },
  { id: '2104099', name: 'Formosa da Serra Negra' },
  { id: '2104107', name: 'Fortaleza dos Nogueiras' },
  { id: '2104206', name: 'Fortuna' },
  { id: '2104305', name: 'Godofredo Viana' },
  { id: '2104404', name: 'Gonçalves Dias' },
  { id: '2104503', name: 'Governador Archer' },
  { id: '2104552', name: 'Governador Edison Lobão' },
  { id: '2104602', name: 'Governador Eugênio BaRos' },
  { id: '2104628', name: 'Governador Luiz Rocha' },
  { id: '2104651', name: 'Governador Newton BeLo' },
  { id: '2104677', name: 'Governador Nunes Freire' },
  { id: '2104701', name: 'Graça Aranha' },
  { id: '2104800', name: 'Grajaú' },
  { id: '2104909', name: 'Guimarães' },
  { id: '2105005', name: 'Humberto de Campos' },
  { id: '2105104', name: 'Icatu' },
  { id: '2105203', name: 'Igarapé Grande' },
  { id: '2105153', name: 'Igarapé do Meio' },
  { id: '2105302', name: 'Imperatriz' },
  { id: '2105351', name: 'Itaipava do Grajaú' },
  { id: '2105401', name: 'Itapecuru Mirim' },
  { id: '2105427', name: 'Itinga do Maranhão' },
  { id: '2105450', name: 'Jatobá' },
  { id: '2105476', name: 'Jenipapo dos Vieiras' },
  { id: '2105500', name: 'João Lisboa' },
  { id: '2105609', name: 'Joselândia' },
  { id: '2105658', name: 'Junco do Maranhão' },
  { id: '2105906', name: 'Lago Verde' },
  { id: '2105708', name: 'Lago da Pedra' },
  { id: '2105807', name: 'Lago do Junco' },
  { id: '2105948', name: 'Lago dos Rodrigues' },
  { id: '2105963', name: 'Lagoa Grande do Maranhão' },
  { id: '2105922', name: 'Lagoa do Mato' },
  { id: '2105989', name: 'Lajeado Novo' },
  { id: '2106003', name: 'Lima Campos' },
  { id: '2106102', name: 'Loreto' },
  { id: '2106201', name: 'Luís Domingues' },
  { id: '2106300', name: 'Magalhães de Almeida' },
  { id: '2106326', name: 'Maracaçumé' },
  { id: '2106359', name: 'Marajá do Sena' },
  { id: '2106375', name: 'Maranhãozinho' },
  { id: '2106409', name: 'Mata Roma' },
  { id: '2106508', name: 'Matinha' },
  { id: '2106607', name: 'Matões' },
  { id: '2106631', name: 'Matões do Norte' },
  { id: '2106672', name: 'Milagres do Maranhão' },
  { id: '2106706', name: 'Mirador' },
  { id: '2106755', name: 'Miranda do Norte' },
  { id: '2106805', name: 'Mirinzal' },
  { id: '2106904', name: 'Monção' },
  { id: '2107001', name: 'Montes Altos' },
  { id: '2107100', name: 'MoRos' },
  { id: '2107209', name: 'Nina Rodrigues' },
  { id: '2107258', name: 'Nova Colinas' },
  { id: '2107308', name: 'Nova Iorque' },
  { id: '2107357', name: 'Nova Olinda do Maranhão' },
  { id: '2107407', name: 'Olho d"Água das Cunhãs' },
  { id: '2107456', name: 'Olinda Nova do Maranhão' },
  { id: '2107506', name: 'Paço do Lumiar' },
  { id: '2107605', name: 'Palmeirândia' },
  { id: '2107704', name: 'Paraibano' },
  { id: '2107803', name: 'Parnarama' },
  { id: '2107902', name: 'PaSagem Franca' },
  { id: '2108009', name: 'Pastos Bons' },
  { id: '2108058', name: 'Paulino Neves' },
  { id: '2108108', name: 'Paulo Ramos' },
  { id: '2108207', name: 'Pedreiras' },
  { id: '2108256', name: 'Pedro do Rosário' },
  { id: '2108306', name: 'Penalva' },
  { id: '2108405', name: 'Peri Mirim' },
  { id: '2108454', name: 'Peritoró' },
  { id: '2108504', name: 'Pindaré-Mirim' },
  { id: '2108603', name: 'Pinheiro' },
  { id: '2108702', name: 'Pio XI' },
  { id: '2108801', name: 'Pirapemas' },
  { id: '2108900', name: 'Poção de Pedras' },
  { id: '2109007', name: 'Porto Franco' },
  { id: '2109056', name: 'Porto Rico do Maranhão' },
  { id: '2109106', name: 'Presidente Dutra' },
  { id: '2109205', name: 'Presidente Juscelino' },
  { id: '2109239', name: 'Presidente Médici' },
  { id: '2109270', name: 'Presidente Sarney' },
  { id: '2109304', name: 'Presidente Vargas' },
  { id: '2109403', name: 'Primeira Cruz' },
  { id: '2109452', name: 'Raposa' },
  { id: '2109502', name: 'Riachão' },
  { id: '2109551', name: 'Ribamar Fiquene' },
  { id: '2109601', name: 'Rosário' },
  { id: '2109700', name: 'Sambaíba' },
  { id: '2109759', name: 'Santa Filomena do Maranhão' },
  { id: '2109809', name: 'Santa Helena' },
  { id: '2109908', name: 'Santa Inês' },
  { id: '2110005', name: 'Santa Luzia' },
  { id: '2110039', name: 'Santa Luzia do Paruá' },
  { id: '2110104', name: 'Santa Quitéria do Maranhão' },
  { id: '2110203', name: 'Santa Rita' },
  { id: '2110237', name: 'Santana do Maranhão' },
  { id: '2110278', name: 'Santo Amaro do Maranhão' },
  { id: '2110302', name: 'Santo Antônio dos Lopes' },
  { id: '2110401', name: 'São Benedito do Rio Preto' },
  { id: '2110500', name: 'São Bento' },
  { id: '2110609', name: 'São Bernardo' },
  { id: '2110658', name: 'São Domingos do Azeitão' },
  { id: '2110708', name: 'São Domingos do Maranhão' },
  { id: '2110807', name: 'São Félix de Balsas' },
  { id: '2110856', name: 'São Francisco do Brejão' },
  { id: '2110906', name: 'São Francisco do Maranhão' },
  { id: '2111003', name: 'São João Batista' },
  { id: '2111029', name: 'São João do Carú' },
  { id: '2111052', name: 'São João do Paraíso' },
  { id: '2111078', name: 'São João do Soter' },
  { id: '2111102', name: 'São João dos Patos' },
  { id: '2111201', name: 'São José de Ribamar' },
  { id: '2111250', name: 'São José dos Basílios' },
  { id: '2111300', name: 'São Luís' },
  { id: '2111409', name: 'São Luís Gonzaga do Maranhão' },
  { id: '2111508', name: 'São Mateus do Maranhão' },
  { id: '2111532', name: 'São Pedro da Água Branca' },
  { id: '2111573', name: 'São Pedro dos Crentes' },
  { id: '2111607', name: 'São Raimundo das Mangabeiras' },
  { id: '2111631', name: 'São Raimundo do Doca BezeRa' },
  { id: '2111672', name: 'São Roberto' },
  { id: '2111706', name: 'São Vicente FeRer' },
  { id: '2111722', name: 'Satubinha' },
  { id: '2111748', name: 'Senador Alexandre Costa' },
  { id: '2111763', name: 'Senador La Rocque' },
  { id: '2111789', name: 'Serrano do Maranhão' },
  { id: '2111805', name: 'Sítio Novo' },
  { id: '2111904', name: 'Sucupira do Norte' },
  { id: '2111953', name: 'Sucupira do Riachão' },
  { id: '2112001', name: 'TaSo Fragoso' },
  { id: '2112100', name: 'Timbiras' },
  { id: '2112209', name: 'Timon' },
  { id: '2112233', name: 'Trizidela do Vale' },
  { id: '2112274', name: 'Tufilândia' },
  { id: '2112308', name: 'Tuntum' },
  { id: '2112407', name: 'Turiaçu' },
  { id: '2112456', name: 'Turilândia' },
  { id: '2112506', name: 'Tutóia' },
  { id: '2112605', name: 'Urbano Santos' },
  { id: '2112704', name: 'Vargem Grande' },
  { id: '2112803', name: 'Viana' },
  { id: '2112852', name: 'Vila Nova dos Martírios' },
  { id: '2112902', name: 'Vitória do Mearim' },
  { id: '2113009', name: 'Vitorino Freire' },
  { id: '2114007', name: 'Zé Doca' },
  { id: '5100102', name: 'Acorizal' },
  { id: '5100201', name: 'Água Boa' },
  { id: '5100250', name: 'Alta Floresta' },
  { id: '5100300', name: 'Alto Araguaia' },
  { id: '5100359', name: 'Alto Boa Vista' },
  { id: '5100409', name: 'Alto Garças' },
  { id: '5100508', name: 'Alto Paraguai' },
  { id: '5100607', name: 'Alto Taquari' },
  { id: '5100805', name: 'Apiacás' },
  { id: '5101001', name: 'Araguaiana' },
  { id: '5101209', name: 'Araguainha' },
  { id: '5101258', name: 'Araputanga' },
  { id: '5101308', name: 'Arenápolis' },
  { id: '5101407', name: 'Aripuanã' },
  { id: '5101605', name: 'Barão de Melgaço' },
  { id: '5101704', name: 'BaRa do Bugres' },
  { id: '5101803', name: 'BaRa do Garças' },
  { id: '5101852', name: 'Bom Jesus do Araguaia' },
  { id: '5101902', name: 'Brasnorte' },
  { id: '5102504', name: 'Cáceres' },
  { id: '5102603', name: 'Campinápolis' },
  { id: '5102637', name: 'Campo Novo do Parecis' },
  { id: '5102678', name: 'Campo Verde' },
  { id: '5102686', name: 'Campos de Júlio' },
  { id: '5102694', name: 'Canabrava do Norte' },
  { id: '5102702', name: 'Canarana' },
  { id: '5102793', name: 'Carlinda' },
  { id: '5102850', name: 'Castanheira' },
  { id: '5103007', name: 'Chapada dos Guimarães' },
  { id: '5103056', name: 'Cláudia' },
  { id: '5103106', name: 'Cocalinho' },
  { id: '5103205', name: 'Colíder' },
  { id: '5103254', name: 'Colniza' },
  { id: '5103304', name: 'Comodoro' },
  { id: '5103353', name: 'Confresa' },
  { id: '5103361', name: 'Conquista D"Oeste' },
  { id: '5103379', name: 'Cotriguaçu' },
  { id: '5103403', name: 'Cuiabá' },
  { id: '5103437', name: 'Curvelândia' },
  { id: '5103452', name: 'Denise' },
  { id: '5103502', name: 'Diamantino' },
  { id: '5103601', name: 'Dom Aquino' },
  { id: '5103700', name: 'Feliz Natal' },
  { id: '5103809', name: 'Figueirópolis D"Oeste' },
  { id: '5103858', name: 'Gaúcha do Norte' },
  { id: '5103908', name: 'General Carneiro' },
  { id: '5103957', name: 'Glória D"Oeste' },
  { id: '5104104', name: 'Guarantã do Norte' },
  { id: '5104203', name: 'Guiratinga' },
  { id: '5104500', name: 'Indiavaí' },
  { id: '5104526', name: 'Ipiranga do Norte' },
  { id: '5104542', name: 'Itanhangá' },
  { id: '5104559', name: 'Itaúba' },
  { id: '5104609', name: 'Itiquira' },
  { id: '5104807', name: 'Jaciara' },
  { id: '5104906', name: 'Jangada' },
  { id: '5105002', name: 'Jauru' },
  { id: '5105101', name: 'Juara' },
  { id: '5105150', name: 'Juína' },
  { id: '5105176', name: 'Juruena' },
  { id: '5105200', name: 'Juscimeira' },
  { id: '5105234', name: 'Lambari D"Oeste' },
  { id: '5105259', name: 'Lucas do Rio Verde' },
  { id: '5105309', name: 'Luciara' },
  { id: '5105580', name: 'Marcelândia' },
  { id: '5105606', name: 'Matupá' },
  { id: '5105622', name: 'MiraSol d"Oeste' },
  { id: '5105903', name: 'Nobres' },
  { id: '5106000', name: 'Nortelândia' },
  { id: '5106109', name: 'NoSa Senhora do Livramento' },
  { id: '5106158', name: 'Nova Bandeirantes' },
  { id: '5106208', name: 'Nova Brasilândia' },
  { id: '5106216', name: 'Nova Canaã do Norte' },
  { id: '5108808', name: 'Nova Guarita' },
  { id: '5106182', name: 'Nova Lacerda' },
  { id: '5108857', name: 'Nova Marilândia' },
  { id: '5108907', name: 'Nova Maringá' },
  { id: '5108956', name: 'Nova Monte Verde' },
  { id: '5106224', name: 'Nova Mutum' },
  { id: '5106174', name: 'Nova Nazaré' },
  { id: '5106232', name: 'Nova Olímpia' },
  { id: '5106190', name: 'Nova Santa Helena' },
  { id: '5106240', name: 'Nova Ubiratã' },
  { id: '5106257', name: 'Nova Xavantina' },
  { id: '5106273', name: 'Novo Horizonte do Norte' },
  { id: '5106265', name: 'Novo Mundo' },
  { id: '5106315', name: 'Novo Santo Antônio' },
  { id: '5106281', name: 'Novo São Joaquim' },
  { id: '5106299', name: 'Paranaíta' },
  { id: '5106307', name: 'Paranatinga' },
  { id: '5106372', name: 'Pedra Preta' },
  { id: '5106422', name: 'Peixoto de Azevedo' },
  { id: '5106455', name: 'Planalto da Serra' },
  { id: '5106505', name: 'Poconé' },
  { id: '5106653', name: 'Pontal do Araguaia' },
  { id: '5106703', name: 'Ponte Branca' },
  { id: '5106752', name: 'Pontes e Lacerda' },
  { id: '5106778', name: 'Porto Alegre do Norte' },
  { id: '5106828', name: 'Porto Esperidião' },
  { id: '5106851', name: 'Porto Estrela' },
  { id: '5106802', name: 'Porto dos Gaúchos' },
  { id: '5107008', name: 'Poxoréu' },
  { id: '5107040', name: 'Primavera do Leste' },
  { id: '5107065', name: 'QQuerência' },
  { id: '5107156', name: 'Reserva do Cabaçal' },
  { id: '5107180', name: 'Ribeirão Cascalheira' },
  { id: '5107198', name: 'Ribeirãozinho' },
  { id: '5107206', name: 'Rio Branco' },
  { id: '5107578', name: 'Rondolândia' },
  { id: '5107602', name: 'Rondonópolis' },
  { id: '5107701', name: 'Rosário Oeste' },
  { id: '5107750', name: 'Salto do Céu' },
  { id: '5107248', name: 'Santa Carmem' },
  { id: '5107743', name: 'Santa Cruz do Xingu' },
  { id: '5107768', name: 'Santa Rita do Trivelato' },
  { id: '5107776', name: 'Santa Terezinha' },
  { id: '5107263', name: 'Santo Afonso' },
  { id: '5107792', name: 'Santo Antônio do Leste' },
  { id: '5107800', name: 'Santo Antônio do Leverger' },
  { id: '5107859', name: 'São Félix do Araguaia' },
  { id: '5107297', name: 'São José do Povo' },
  { id: '5107305', name: 'São José do Rio Claro' },
  { id: '5107354', name: 'São José do Xingu' },
  { id: '5107107', name: 'São José dos Quatro Marcos' },
  { id: '5107404', name: 'São Pedro da Cipa' },
  { id: '5107875', name: 'Sapezal' },
  { id: '5107883', name: 'Serra Nova Dourada' },
  { id: '5107909', name: 'Sinop' },
  { id: '5107925', name: 'SoRiso' },
  { id: '5107941', name: 'Tabaporã' },
  { id: '5107958', name: 'Tangará da Serra' },
  { id: '5108006', name: 'Tapurah' },
  { id: '5108055', name: 'TeRa Nova do Norte' },
  { id: '5108105', name: 'Tesouro' },
  { id: '5108204', name: 'Torixoréu' },
  { id: '5108303', name: 'União do Sul' },
  { id: '5108352', name: 'Vale de São Domingos' },
  { id: '5108402', name: 'Várzea Grande' },
  { id: '5108501', name: 'Vera' },
  { id: '5105507', name: 'Vila Bela da SantíSima Trindade' },
  { id: '5108600', name: 'Vila Rica' },
  { id: '5000203', name: 'AÁgua Clara' },
  { id: '5000252', name: 'Alcinópolis' },
  { id: '5000609', name: 'Amambai' },
  { id: '5000708', name: 'Anastácio' },
  { id: '5000807', name: 'Anaurilândia' },
  { id: '5000856', name: 'Angélica' },
  { id: '5000906', name: 'Antônio João' },
  { id: '5001003', name: 'Aparecida do Taboado' },
  { id: '5001102', name: 'Aquidauana' },
  { id: '5001243', name: 'Aral Moreira' },
  { id: '5001508', name: 'Bandeirantes' },
  { id: '5001904', name: 'BataguaSu' },
  { id: '5002001', name: 'Batayporã' },
  { id: '5002100', name: 'Bela Vista' },
  { id: '5002159', name: 'Bodoquena' },
  { id: '5002209', name: 'Bonito' },
  { id: '5002308', name: 'Brasilândia' },
  { id: '5002407', name: 'CArapó' },
  { id: '5002605', name: 'Camapuã' },
  { id: '5002704', name: 'Campo Grande' },
  { id: '5002803', name: 'Caracol' },
  { id: '5002902', name: 'CaSilândia' },
  { id: '5002951', name: 'Chapadão do Sul' },
  { id: '5003108', name: 'Corguinho' },
  { id: '5003157', name: 'Coronel Sapucaia' },
  { id: '5003207', name: 'Corumbá' },
  { id: '5003256', name: 'Costa Rica' },
  { id: '5003306', name: 'Coxim' },
  { id: '5003454', name: 'Deodápolis' },
  { id: '5003488', name: 'Dois Irmãos do Buriti' },
  { id: '5003504', name: 'Douradina' },
  { id: '5003702', name: 'Dourados' },
  { id: '5003751', name: 'Eldorado' },
  { id: '5003801', name: 'Fátima do Sul' },
  { id: '5003900', name: 'Figueirão' },
  { id: '5004007', name: 'Glória de Dourados' },
  { id: '5004106', name: 'Guia Lopes da Laguna' },
  { id: '5004304', name: 'Iguatemi' },
  { id: '5004403', name: 'Inocência' },
  { id: '5004502', name: 'Itaporã' },
  { id: '5004601', name: 'Itaquiraí' },
  { id: '5004700', name: 'Ivinhema' },
  { id: '5004809', name: 'Japorã' },
  { id: '5004908', name: 'Jaraguari' },
  { id: '5005004', name: 'Jardim' },
  { id: '5005103', name: 'Jateí' },
  { id: '5005152', name: 'Juti' },
  { id: '5005202', name: 'Ladário' },
  { id: '5005251', name: 'Laguna Carapã' },
  { id: '5005400', name: 'Maracaju' },
  { id: '5005608', name: 'Miranda' },
  { id: '5005681', name: 'Mundo Novo' },
  { id: '5005707', name: 'Naviraí' },
  { id: '5005806', name: 'Nioaque' },
  { id: '5006002', name: 'Nova Alvorada do Sul' },
  { id: '5006200', name: 'Nova Andradina' },
  { id: '5006259', name: 'Novo Horizonte do Sul' },
  { id: '5006275', name: 'Paraíso das Águas' },
  { id: '5006309', name: 'Paranaíba' },
  { id: '5006358', name: 'Paranhos' },
  { id: '5006408', name: 'Pedro Gomes' },
  { id: '5006606', name: 'Ponta Porã' },
  { id: '5006903', name: 'Porto Murtinho' },
  { id: '5007109', name: 'Ribas do Rio Pardo' },
  { id: '5007208', name: 'Rio Brilhante' },
  { id: '5007307', name: 'Rio Negro' },
  { id: '5007406', name: 'Rio Verde de Mato GroSo' },
  { id: '5007505', name: 'Rochedo' },
  { id: '5007554', name: 'Santa Rita do Pardo' },
  { id: '5007695', name: 'São Gabriel do Oeste' },
  { id: '5007802', name: 'Selvíria' },
  { id: '5007703', name: 'Sete Quedas' },
  { id: '5007901', name: 'Sidrolândia' },
  { id: '5007935', name: 'Sonora' },
  { id: '5007950', name: 'Tacuru' },
  { id: '5007976', name: 'TaquaruSu' },
  { id: '5008008', name: 'Terenos' },
  { id: '5008305', name: 'Três Lagoas' },
  { id: '5008404', name: 'Vicentina' },
  { id: '3100104', name: 'Abadia dos Dourados' },
  { id: '3100203', name: 'Abaeté' },
  { id: '3100302', name: 'Abre Campo' },
  { id: '3100401', name: 'Acaiaca' },
  { id: '3100500', name: 'Açucena' },
  { id: '3100609', name: 'Água Boa' },
  { id: '3100708', name: 'Água Comprida' },
  { id: '3100807', name: 'Aguanil' },
  { id: '3100906', name: 'Águas Formosas' },
  { id: '3101003', name: 'Águas Vermelhas' },
  { id: '3101102', name: 'Aimorés' },
  { id: '3101201', name: 'Aiuruoca' },
  { id: '3101300', name: 'Alagoa' },
  { id: '3101409', name: 'Albertina' },
  { id: '3101508', name: 'Além Paraíba' },
  { id: '3101607', name: 'Alfenas' },
  { id: '3101631', name: 'Alfredo Vasconcelos' },
  { id: '3101706', name: 'Almenara' },
  { id: '3101805', name: 'Alpercata' },
  { id: '3101904', name: 'Alpinópolis' },
  { id: '3102001', name: 'Alterosa' },
  { id: '3102050', name: 'Alto Caparaó' },
  { id: '3153509', name: 'Alto Jequitibá' },
  { id: '3102100', name: 'Alto Rio Doce' },
  { id: '3102209', name: 'Alvarenga' },
  { id: '3102308', name: 'Alvinópolis' },
  { id: '3102407', name: 'Alvorada de Minas' },
  { id: '3102506', name: 'Amparo do Serra' },
  { id: '3102605', name: 'Andradas' },
  { id: '3102803', name: 'Andrelândia' },
  { id: '3102852', name: 'Angelândia' },
  { id: '3102902', name: 'Antônio Carlos' },
  { id: '3103009', name: 'Antônio Dias' },
  { id: '3103108', name: 'Antônio Prado de Minas' },
  { id: '3103207', name: 'Araçaí' },
  { id: '3103306', name: 'Aracitaba' },
  { id: '3103405', name: 'Araçuaí' },
  { id: '3103504', name: 'Araguari' },
  { id: '3103603', name: 'Arantina' },
  { id: '3103702', name: 'Araponga' },
  { id: '3103751', name: 'Araporã' },
  { id: '3103801', name: 'Arapuá' },
  { id: '3103900', name: 'Araújos' },
  { id: '3104007', name: 'Araxá' },
  { id: '3104106', name: 'Arceburgo' },
  { id: '3104205', name: 'Arcos' },
  { id: '3104304', name: 'Areado' },
  { id: '3104403', name: 'Argirita' },
  { id: '3104452', name: 'Aricanduva' },
  { id: '3104502', name: 'Arinos' },
  { id: '3104601', name: 'Astolfo Dutra' },
  { id: '3104700', name: 'Ataléia' },
  { id: '3104809', name: 'Augusto de Lima' },
  { id: '3104908', name: 'Baependi' },
  { id: '3105004', name: 'Baldim' },
  { id: '3105103', name: 'Bambuí' },
  { id: '3105202', name: 'Bandeira' },
  { id: '3105301', name: 'Bandeira do Sul' },
  { id: '3105400', name: 'Barão de Cocais' },
  { id: '3105509', name: 'Barão de Monte Alto' },
  { id: '3105608', name: 'Barbacena' },
  { id: '3105707', name: 'BaRa Longa' },
  { id: '3105905', name: 'BaRoso' },
  { id: '3106002', name: 'Bela Vista de Minas' },
  { id: '3106101', name: 'Belmiro Braga' },
  { id: '3106200', name: 'Belo Horizonte' },
  { id: '3106309', name: 'Belo Oriente' },
  { id: '3106408', name: 'Belo Vale' },
  { id: '3106507', name: 'Berilo' },
  { id: '3106655', name: 'Berizal' },
  { id: '3106606', name: 'Bertópolis' },
  { id: '3106705', name: 'Betim' },
  { id: '3106804', name: 'Bias Fortes' },
  { id: '3106903', name: 'Bicas' },
  { id: '3107000', name: 'Biquinhas' },
  { id: '3107109', name: 'Boa Esperança' },
  { id: '3107208', name: 'Bocaina de Minas' },
  { id: '3107307', name: 'Bocaiúva' },
  { id: '3107406', name: 'Bom Despacho' },
  { id: '3107505', name: 'Bom Jardim de Minas' },
  { id: '3107604', name: 'Bom Jesus da Penha' },
  { id: '3107703', name: 'Bom Jesus do Amparo' },
  { id: '3107802', name: 'Bom Jesus do Galho' },
  { id: '3107901', name: 'Bom Repouso' },
  { id: '3108008', name: 'Bom SuceSo' },
  { id: '3108107', name: 'Bonfim' },
  { id: '3108206', name: 'Bonfinópolis de Minas' },
  { id: '3108255', name: 'Bonito de Minas' },
  { id: '3108305', name: 'Borda da Mata' },
  { id: '3108404', name: 'Botelhos' },
  { id: '3108503', name: 'Botumirim' },
  { id: '3108701', name: 'Brás Pires' },
  { id: '3108552', name: 'Brasilândia de Minas' },
  { id: '3108602', name: 'Brasília de Minas' },
  { id: '3108800', name: 'Braúnas' },
  { id: '3108909', name: 'Brazópolis' },
  { id: '3109006', name: 'Brumadinho' },
  { id: '3109105', name: 'Bueno Brandão' },
  { id: '3109204', name: 'Buenópolis' },
  { id: '3109253', name: 'Bugre' },
  { id: '3109303', name: 'Buritis' },
  { id: '3109402', name: 'Buritizeiro' },
  { id: '3109451', name: 'Cabeceira Grande' },
  { id: '3109501', name: 'Cabo Verde' },
  { id: '3109808', name: 'Cachoeira Dourada' },
  { id: '3109600', name: 'Cachoeira da Prata' },
  { id: '3109709', name: 'Cachoeira de Minas' },
  { id: '3102704', name: 'Cachoeira de Pajeú' },
  { id: '3109907', name: 'Caetanópolis' },
  { id: '3110004', name: 'Caeté' },
  { id: '3110103', name: 'Caiana' },
  { id: '3110202', name: 'Cajuri' },
  { id: '3110301', name: 'Caldas' },
  { id: '3110400', name: 'Camacho' },
  { id: '3110509', name: 'Camanducaia' },
  { id: '3110608', name: 'Cambuí' },
  { id: '3110707', name: 'Cambuquira' },
  { id: '3110806', name: 'Campanário' },
  { id: '3110905', name: 'Campanha' },
  { id: '3111002', name: 'Campestre' },
  { id: '3111101', name: 'Campina Verde' },
  { id: '3111150', name: 'Campo Azul' },
  { id: '3111200', name: 'Campo Belo' },
  { id: '3111408', name: 'Campo Florido' },
  { id: '3111309', name: 'Campo do Meio' },
  { id: '3111507', name: 'Campos Altos' },
  { id: '3111606', name: 'Campos Gerais' },
  { id: '3111903', name: 'Cana Verde' },
  { id: '3111705', name: 'Canaã' },
  { id: '3111804', name: 'Canápolis' },
  { id: '3112000', name: 'Candeias' },
  { id: '3112059', name: 'Cantagalo' },
  { id: '3112109', name: 'Caparaó' },
  { id: '3112208', name: 'Capela Nova' },
  { id: '3112307', name: 'Capelinha' },
  { id: '3112406', name: 'Capetinga' },
  { id: '3112505', name: 'Capim Branco' },
  { id: '3112604', name: 'Capinópolis' },
  { id: '3112653', name: 'Capitão Andrade' },
  { id: '3112703', name: 'Capitão Enéas' },
  { id: '3112802', name: 'Capitólio' },
  { id: '3112901', name: 'Caputira' },
  { id: '3113008', name: 'Caraí' },
  { id: '3113107', name: 'Caranaíba' },
  { id: '3113206', name: 'Carandaí' },
  { id: '3113305', name: 'Carangola' },
  { id: '3113404', name: 'Caratinga' },
  { id: '3113503', name: 'Carbonita' },
  { id: '3113602', name: 'Careaçu' },
  { id: '3113701', name: 'Carlos Chagas' },
  { id: '3113800', name: 'Carmésia' },
  { id: '3113909', name: 'Carmo da Cachoeira' },
  { id: '3114006', name: 'Carmo da Mata' },
  { id: '3114105', name: 'Carmo de Minas' },
  { id: '3114204', name: 'Carmo do Cajuru' },
  { id: '3114303', name: 'Carmo do Paranaíba' },
  { id: '3114402', name: 'Carmo do Rio Claro' },
  { id: '3114501', name: 'Carmópolis de Minas' },
  { id: '3114550', name: 'Carneirinho' },
  { id: '3114600', name: 'CaRancas' },
  { id: '3114709', name: 'Carvalhópolis' },
  { id: '3114808', name: 'Carvalhos' },
  { id: '3114907', name: 'Casa Grande' },
  { id: '3115003', name: 'Cascalho Rico' },
  { id: '3115102', name: 'CáSia' },
  { id: '3115300', name: 'Cataguases' },
  { id: '3115359', name: 'Catas Altas' },
  { id: '3115409', name: 'Catas Altas da Noruega' },
  { id: '3115458', name: 'Catuji' },
  { id: '3115474', name: 'Catuti' },
  { id: '3115508', name: 'Caxambu' },
  { id: '3115607', name: 'Cedro do Abaeté' },
  { id: '3115706', name: 'Central de Minas' },
  { id: '3115805', name: 'Centralina' },
  { id: '3115904', name: 'Chácara' },
  { id: '3116001', name: 'Chalé' },
  { id: '3116159', name: 'Chapada Gaúcha' },
  { id: '3116100', name: 'Chapada do Norte' },
  { id: '3116209', name: 'Chiador' },
  { id: '3116308', name: 'Cipotânea' },
  { id: '3116407', name: 'Claraval' },
  { id: '3116506', name: 'Claro dos Poções' },
  { id: '3116605', name: 'Cláudio' },
  { id: '3116704', name: 'Coimbra' },
  { id: '3116803', name: 'Coluna' },
  { id: '3116902', name: 'Comendador Gomes' },
  { id: '3117009', name: 'Comercinho' },
  { id: '3117108', name: 'Conceição da Aparecida' },
  { id: '3115201', name: 'Conceição da BaRa de Minas' },
  { id: '3117306', name: 'Conceição das Alagoas' },
  { id: '3117207', name: 'Conceição das Pedras' },
  { id: '3117405', name: 'Conceição de Ipanema' },
  { id: '3117504', name: 'Conceição do Mato Dentro' },
  { id: '3117603', name: 'Conceição do Pará' },
  { id: '3117702', name: 'Conceição do Rio Verde' },
  { id: '3117801', name: 'Conceição dos Ouros' },
  { id: '3117836', name: 'Cônego Marinho' },
  { id: '3117876', name: 'Confins' },
  { id: '3117900', name: 'Congonhal' },
  { id: '3118007', name: 'Congonhas' },
  { id: '3118106', name: 'Congonhas do Norte' },
  { id: '3118205', name: 'Conquista' },
  { id: '3118304', name: 'Conselheiro Lafaiete' },
  { id: '3118403', name: 'Conselheiro Pena' },
  { id: '3118502', name: 'Consolação' },
  { id: '3118601', name: 'Contagem' },
  { id: '3118700', name: 'Coqueiral' },
  { id: '3118809', name: 'Coração de Jesus' },
  { id: '3118908', name: 'Cordisburgo' },
  { id: '3119005', name: 'Cordislândia' },
  { id: '3119104', name: 'Corinto' },
  { id: '3119203', name: 'Coroaci' },
  { id: '3119302', name: 'Coromandel' },
  { id: '3119401', name: 'Coronel Fabriciano' },
  { id: '3119500', name: 'Coronel Murta' },
  { id: '3119609', name: 'Coronel Pacheco' },
  { id: '3119708', name: 'Coronel Xavier Chaves' },
  { id: '3119807', name: 'CóRego Danta' },
  { id: '3119955', name: 'CóRego Fundo' },
  { id: '3120003', name: 'CóRego Novo' },
  { id: '3119906', name: 'CóRego do Bom Jesus' },
  { id: '3120102', name: 'Couto de Magalhães de Minas' },
  { id: '3120151', name: 'Crisólita' },
  { id: '3120201', name: 'Cristais' },
  { id: '3120300', name: 'Cristália' },
  { id: '3120409', name: 'Cristiano Otoni' },
  { id: '3120508', name: 'Cristina' },
  { id: '3120607', name: 'Crucilândia' },
  { id: '3120706', name: 'Cruzeiro da Fortaleza' },
  { id: '3120805', name: 'Cruzília' },
  { id: '3120839', name: 'Cuparaque' },
  { id: '3120870', name: 'CuRal de Dentro' },
  { id: '3120904', name: 'Curvelo' },
  { id: '3121001', name: 'Datas' },
  { id: '3121100', name: 'Delfim Moreira' },
  { id: '3121209', name: 'Delfinópolis' },
  { id: '3121258', name: 'Delta' },
  { id: '3121308', name: 'Descoberto' },
  { id: '3121407', name: 'DesteRo de Entre Rios' },
  { id: '3121506', name: 'DesteRo do Melo' },
  { id: '3121605', name: 'Diamantina' },
  { id: '3121704', name: 'Diogo de Vasconcelos' },
  { id: '3121803', name: 'Dionísio' },
  { id: '3121902', name: 'Divinésia' },
  { id: '3122009', name: 'Divino' },
  { id: '3122108', name: 'Divino das Laranjeiras' },
  { id: '3122207', name: 'Divinolândia de Minas' },
  { id: '3122306', name: 'Divinópolis' },
  { id: '3122355', name: 'Divisa Alegre' },
  { id: '3122405', name: 'Divisa Nova' },
  { id: '3122454', name: 'Divisópolis' },
  { id: '3122470', name: 'Dom Bosco' },
  { id: '3122504', name: 'Dom Cavati' },
  { id: '3122603', name: 'Dom Joaquim' },
  { id: '3122702', name: 'Dom Silvério' },
  { id: '3122801', name: 'Dom Viçoso' },
  { id: '3122900', name: 'Dona Euzébia' },
  { id: '3123007', name: 'Dores de Campos' },
  { id: '3123106', name: 'Dores de Guanhães' },
  { id: '3123205', name: 'Dores do Indaiá' },
  { id: '3123304', name: 'Dores do Turvo' },
  { id: '3123403', name: 'Doresópolis' },
  { id: '3123502', name: 'Douradoquara' },
  { id: '3123528', name: 'Durandé' },
  { id: '3123601', name: 'Elói Mendes' },
  { id: '3123700', name: 'Engenheiro Caldas' },
  { id: '3123809', name: 'Engenheiro NavaRo' },
  { id: '3123858', name: 'Entre Folhas' },
  { id: '3123908', name: 'Entre Rios de Minas' },
  { id: '3124005', name: 'Ervália' },
  { id: '3124104', name: 'Esmeraldas' },
  { id: '3124203', name: 'Espera Feliz' },
  { id: '3124302', name: 'Espinosa' },
  { id: '3124401', name: 'Espírito Santo do Dourado' },
  { id: '3124500', name: 'Estiva' },
  { id: '3124609', name: 'Estrela Dalva' },
  { id: '3124708', name: 'Estrela do Indaiá' },
  { id: '3124807', name: 'Estrela do Sul' },
  { id: '3124906', name: 'Eugenópolis' },
  { id: '3125002', name: 'Ewbank da Câmara' },
  { id: '3125101', name: 'Extrema' },
  { id: '3125200', name: 'Fama' },
  { id: '3125309', name: 'Faria Lemos' },
  { id: '3125408', name: 'Felício dos Santos' },
  { id: '3125606', name: 'Felisburgo' },
  { id: '3125705', name: 'Felixlândia' },
  { id: '3125804', name: 'Fernandes Tourinho' },
  { id: '3125903', name: 'FeRos' },
  { id: '3125952', name: 'Fervedouro' },
  { id: '3126000', name: 'Florestal' },
  { id: '3126109', name: 'Formiga' },
  { id: '3126208', name: 'Formoso' },
  { id: '3126307', name: 'Fortaleza de Minas' },
  { id: '3126406', name: 'Fortuna de Minas' },
  { id: '3126505', name: 'Francisco Badaró' },
  { id: '3126604', name: 'Francisco Dumont' },
  { id: '3126703', name: 'Francisco Sá' },
  { id: '3126752', name: 'Franciscópolis' },
  { id: '3126802', name: 'Frei Gaspar' },
  { id: '3126901', name: 'Frei Inocêncio' },
  { id: '3126950', name: 'Frei Lagonegro' },
  { id: '3127008', name: 'Fronteira' },
  { id: '3127057', name: 'Fronteira dos Vales' },
  { id: '3127073', name: 'Fruta de Leite' },
  { id: '3127107', name: 'Frutal' },
  { id: '3127206', name: 'Funilândia' },
  { id: '3127305', name: 'Galiléia' },
  { id: '3127339', name: 'Gameleiras' },
  { id: '3127354', name: 'Glaucilândia' },
  { id: '3127370', name: 'Goiabeira' },
  { id: '3127388', name: 'Goianá' },
  { id: '3127404', name: 'Gonçalves' },
  { id: '3127503', name: 'Gonzaga' },
  { id: '3127602', name: 'Gouveia' },
  { id: '3127701', name: 'Governador Valadares' },
  { id: '3127800', name: 'Grão Mogol' },
  { id: '3127909', name: 'Grupiara' },
  { id: '3128006', name: 'Guanhães' },
  { id: '3128105', name: 'Guapé' },
  { id: '3128204', name: 'Guaraciaba' },
  { id: '3128253', name: 'Guaraciama' },
  { id: '3128303', name: 'Guaranésia' },
  { id: '3128402', name: 'Guarani' },
  { id: '3128501', name: 'Guarará' },
  { id: '3128600', name: 'Guarda-Mor' },
  { id: '3128709', name: 'Guaxupé' },
  { id: '3128808', name: 'Guidoval' },
  { id: '3128907', name: 'Guimarânia' },
  { id: '3129004', name: 'Guiricema' },
  { id: '3129103', name: 'Gurinhatã' },
  { id: '3129202', name: 'Heliodora' },
  { id: '3129301', name: 'Iapu' },
  { id: '3129400', name: 'Ibertioga' },
  { id: '3129509', name: 'Ibiá' },
  { id: '3129608', name: 'Ibiaí' },
  { id: '3129657', name: 'Ibiracatu' },
  { id: '3129707', name: 'Ibiraci' },
  { id: '3129806', name: 'Ibirité' },
  { id: '3129905', name: 'Ibitiúra de Minas' },
  { id: '3130002', name: 'Ibituruna' },
  { id: '3130051', name: 'Icaraí de Minas' },
  { id: '3130101', name: 'Igarapé' },
  { id: '3130200', name: 'Igaratinga' },
  { id: '3130309', name: 'Iguatama' },
  { id: '3130408', name: 'Ijaci' },
  { id: '3130507', name: 'Ilicínea' },
  { id: '3130556', name: 'Imbé de Minas' },
  { id: '3130606', name: 'Inconfidentes' },
  { id: '3130655', name: 'Indaiabira' },
  { id: '3130705', name: 'Indianópolis' },
  { id: '3130804', name: 'Ingaí' },
  { id: '3130903', name: 'Inhapim' },
  { id: '3131000', name: 'Inhaúma' },
  { id: '3131109', name: 'Inimutaba' },
  { id: '3131158', name: 'Ipaba' },
  { id: '3131208', name: 'Ipanema' },
  { id: '3131307', name: 'Ipatinga' },
  { id: '3131406', name: 'Ipiaçu' },
  { id: '3131505', name: 'Ipuiúna' },
  { id: '3131604', name: 'Iraí de Minas' },
  { id: '3131703', name: 'Itabira' },
  { id: '3131802', name: 'Itabirinha' },
  { id: '3131901', name: 'Itabirito' },
  { id: '3132008', name: 'Itacambira' },
  { id: '3132107', name: 'Itacarambi' },
  { id: '3132206', name: 'Itaguara' },
  { id: '3132305', name: 'Itaipé' },
  { id: '3132404', name: 'Itajubá' },
  { id: '3132503', name: 'Itamarandiba' },
  { id: '3132602', name: 'Itamarati de Minas' },
  { id: '3132701', name: 'Itambacuri' },
  { id: '3132800', name: 'Itambé do Mato Dentro' },
  { id: '3132909', name: 'Itamogi' },
  { id: '3133006', name: 'Itamonte' },
  { id: '3133105', name: 'Itanhandu' },
  { id: '3133204', name: 'Itanhomi' },
  { id: '3133303', name: 'Itaobim' },
  { id: '3133402', name: 'Itapagipe' },
  { id: '3133501', name: 'Itapecerica' },
  { id: '3133600', name: 'Itapeva' },
  { id: '3133709', name: 'Itatiaiuçu' },
  { id: '3133758', name: 'Itaú de Minas' },
  { id: '3133808', name: 'Itaúna' },
  { id: '3133907', name: 'Itaverava' },
  { id: '3134004', name: 'Itinga' },
  { id: '3134103', name: 'Itueta' },
  { id: '3134202', name: 'Ituiutaba' },
  { id: '3134301', name: 'Itumirim' },
  { id: '3134400', name: 'Iturama' },
  { id: '3134509', name: 'Itutinga' },
  { id: '3134608', name: 'Jaboticatubas' },
  { id: '3134707', name: 'Jacinto' },
  { id: '3134806', name: 'Jacuí' },
  { id: '3134905', name: 'Jacutinga' },
  { id: '3135001', name: 'Jaguaraçu' },
  { id: '3135050', name: 'Jaíba' },
  { id: '3135076', name: 'Jampruca' },
  { id: '3135100', name: 'Janaúba' },
  { id: '3135209', name: 'Januária' },
  { id: '3135308', name: 'Japaraíba' },
  { id: '3135357', name: 'Japonvar' },
  { id: '3135407', name: 'Jeceaba' },
  { id: '3135456', name: 'Jenipapo de Minas' },
  { id: '3135506', name: 'Jequeri' },
  { id: '3135605', name: 'Jequitaí' },
  { id: '3135704', name: 'Jequitibá' },
  { id: '3135803', name: 'Jequitinhonha' },
  { id: '3135902', name: 'Jesuânia' },
  { id: '3136009', name: 'Joaíma' },
  { id: '3136108', name: 'Joanésia' },
  { id: '3136207', name: 'João Monlevade' },
  { id: '3136306', name: 'João Pinheiro' },
  { id: '3136405', name: 'Joaquim Felício' },
  { id: '3136504', name: 'Jordânia' },
  { id: '3136520', name: 'José Gonçalves de Minas' },
  { id: '3136553', name: 'José Raydan' },
  { id: '3136579', name: 'Josenópolis' },
  { id: '3136652', name: 'Juatuba' },
  { id: '3136702', name: 'Juiz de Fora' },
  { id: '3136801', name: 'Juramento' },
  { id: '3136900', name: 'Juruaia' },
  { id: '3136959', name: 'Juvenília' },
  { id: '3137007', name: 'Ladainha' },
  { id: '3137106', name: 'Lagamar' },
  { id: '3137403', name: 'Lagoa Dourada' },
  { id: '3137502', name: 'Lagoa Formosa' },
  { id: '3137536', name: 'Lagoa Grande' },
  { id: '3137601', name: 'Lagoa Santa' },
  { id: '3137205', name: 'Lagoa da Prata' },
  { id: '3137304', name: 'Lagoa dos Patos' },
  { id: '3137700', name: 'Lajinha' },
  { id: '3137809', name: 'Lambari' },
  { id: '3137908', name: 'Lamim' },
  { id: '3138005', name: 'Laranjal' },
  { id: '3138104', name: 'LaSance' },
  { id: '3138203', name: 'Lavras' },
  { id: '3138302', name: 'Leandro FeReira' },
  { id: '3138351', name: 'Leme do Prado' },
  { id: '3138401', name: 'Leopoldina' },
  { id: '3138500', name: 'Liberdade' },
  { id: '3138609', name: 'Lima Duarte' },
  { id: '3138625', name: 'Limeira do Oeste' },
  { id: '3138658', name: 'Lontra' },
  { id: '3138674', name: 'Luisburgo' },
  { id: '3138682', name: 'Luislândia' },
  { id: '3138708', name: 'Luminárias' },
  { id: '3138807', name: 'Luz' },
  { id: '3138906', name: 'Machacalis' },
  { id: '3139003', name: 'Machado' },
  { id: '3139102', name: 'Madre de Deus de Minas' },
  { id: '3139201', name: 'Malacacheta' },
  { id: '3139250', name: 'Mamonas' },
  { id: '3139300', name: 'Manga' },
  { id: '3139409', name: 'Manhuaçu' },
  { id: '3139508', name: 'Manhumirim' },
  { id: '3139607', name: 'Mantena' },
  { id: '3139805', name: 'Mar de Espanha' },
  { id: '3139706', name: 'Maravilhas' },
  { id: '3139904', name: 'Maria da Fé' },
  { id: '3140001', name: 'Mariana' },
  { id: '3140100', name: 'Marilac' },
  { id: '3140159', name: 'Mário Campos' },
  { id: '3140209', name: 'Maripá de Minas' },
  { id: '3140308', name: 'Marliéria' },
  { id: '3140407', name: 'Marmelópolis' },
  { id: '3140506', name: 'Martinho Campos' },
  { id: '3140530', name: 'Martins Soares' },
  { id: '3140555', name: 'Mata Verde' },
  { id: '3140605', name: 'Materlândia' },
  { id: '3140704', name: 'Mateus Leme' },
  { id: '3171501', name: 'Mathias Lobato' },
  { id: '3140803', name: 'Matias Barbosa' },
  { id: '3140852', name: 'Matias Cardoso' },
  { id: '3140902', name: 'Matipó' },
  { id: '3141009', name: 'Mato Verde' },
  { id: '3141108', name: 'Matozinhos' },
  { id: '3141207', name: 'Matutina' },
  { id: '3141306', name: 'Medeiros' },
  { id: '3141405', name: 'Medina' },
  { id: '3141504', name: 'Mendes Pimentel' },
  { id: '3141603', name: 'Mercês' },
  { id: '3141702', name: 'Mesquita' },
  { id: '3141801', name: 'Minas Novas' },
  { id: '3141900', name: 'Minduri' },
  { id: '3142007', name: 'Mirabela' },
  { id: '3142106', name: 'Miradouro' },
  { id: '3142205', name: 'Miraí' },
  { id: '3142254', name: 'Miravânia' },
  { id: '3142304', name: 'Moeda' },
  { id: '3142403', name: 'Moema' },
  { id: '3142502', name: 'Monjolos' },
  { id: '3142601', name: 'Monsenhor Paulo' },
  { id: '3142700', name: 'Montalvânia' },
  { id: '3142809', name: 'Monte Alegre de Minas' },
  { id: '3142908', name: 'Monte Azul' },
  { id: '3143005', name: 'Monte Belo' },
  { id: '3143104', name: 'Monte Carmelo' },
  { id: '3143153', name: 'Monte Formoso' },
  { id: '3143203', name: 'Monte Santo de Minas' },
  { id: '3143401', name: 'Monte Sião' },
  { id: '3143302', name: 'Montes Claros' },
  { id: '3143450', name: 'Montezuma' },
  { id: '3143500', name: 'Morada Nova de Minas' },
  { id: '3143609', name: 'MoRo da Garça' },
  { id: '3143708', name: 'MoRo do Pilar' },
  { id: '3143807', name: 'Munhoz' },
  { id: '3143906', name: 'Muriaé' },
  { id: '3144003', name: 'Mutum' },
  { id: '3144102', name: 'Muzambinho' },
  { id: '3144201', name: 'Nacip Raydan' },
  { id: '3144300', name: 'Nanuque' },
  { id: '3144359', name: 'Naque' },
  { id: '3144375', name: 'Natalândia' },
  { id: '3144409', name: 'Natércia' },
  { id: '3144508', name: 'Nazareno' },
  { id: '3144607', name: 'Nepomuceno' },
  { id: '3144656', name: 'Ninheira' },
  { id: '3144672', name: 'Nova Belém' },
  { id: '3144706', name: 'Nova Era' },
  { id: '3144805', name: 'Nova Lima' },
  { id: '3144904', name: 'Nova Módica' },
  { id: '3145000', name: 'Nova Ponte' },
  { id: '3145059', name: 'Nova Porteirinha' },
  { id: '3145109', name: 'Nova Resende' },
  { id: '3145208', name: 'Nova Serrana' },
  { id: '3136603', name: 'Nova União' },
  { id: '3145307', name: 'Novo Cruzeiro' },
  { id: '3145356', name: 'Novo Oriente de Minas' },
  { id: '3145372', name: 'Novorizonte' },
  { id: '3145406', name: 'Olaria' },
  { id: '3145455', name: 'Olhos-d"Água' },
  { id: '3145505', name: 'Olímpio Noronha' },
  { id: '3145604', name: 'Oliveira' },
  { id: '3145703', name: 'Oliveira Fortes' },
  { id: '3145802', name: 'Onça de Pitangui' },
  { id: '3145851', name: 'Oratórios' },
  { id: '3145877', name: 'Orizânia' },
  { id: '3145901', name: 'Ouro Branco' },
  { id: '3146008', name: 'Ouro Fino' },
  { id: '3146107', name: 'Ouro Preto' },
  { id: '3146206', name: 'Ouro Verde de Minas' },
  { id: '3146255', name: 'Padre Carvalho' },
  { id: '3146305', name: 'Padre Paraíso' },
  { id: '3146552', name: 'Pai Pedro' },
  { id: '3146404', name: 'Paineiras' },
  { id: '3146503', name: 'Pains' },
  { id: '3146602', name: 'Paiva' },
  { id: '3146701', name: 'Palma' },
  { id: '3146750', name: 'Palmópolis' },
  { id: '3146909', name: 'Papagaios' },
  { id: '3147105', name: 'Pará de Minas' },
  { id: '3147006', name: 'Paracatu' },
  { id: '3147204', name: 'Paraguaçu' },
  { id: '3147303', name: 'Paraisópolis' },
  { id: '3147402', name: 'Paraopeba' },
  { id: '3147600', name: 'PaSa Quatro' },
  { id: '3147709', name: 'PaSa Tempo' },
  { id: '3147808', name: 'PaSa Vinte' },
  { id: '3147501', name: 'PaSabém' },
  { id: '3147907', name: 'PaSos' },
  { id: '3147956', name: 'Patis' },
  { id: '3148004', name: 'Patos de Minas' },
  { id: '3148103', name: 'Patrocínio' },
  { id: '3148202', name: 'Patrocínio do Muriaé' },
  { id: '3148301', name: 'Paula Cândido' },
  { id: '3148400', name: 'Paulistas' },
  { id: '3148509', name: 'Pavão' },
  { id: '3148608', name: 'Peçanha' },
  { id: '3148707', name: 'Pedra Azul' },
  { id: '3148756', name: 'Pedra Bonita' },
  { id: '3149002', name: 'Pedra Dourada' },
  { id: '3148806', name: 'Pedra do Anta' },
  { id: '3148905', name: 'Pedra do Indaiá' },
  { id: '3149101', name: 'Pedralva' },
  { id: '3149150', name: 'Pedras de Maria da Cruz' },
  { id: '3149200', name: 'Pedrinópolis' },
  { id: '3149309', name: 'Pedro Leopoldo' },
  { id: '3149408', name: 'Pedro Teixeira' },
  { id: '3149507', name: 'Pequeri' },
  { id: '3149606', name: 'Pequi' },
  { id: '3149705', name: 'Perdigão' },
  { id: '3149804', name: 'Perdizes' },
  { id: '3149903', name: 'Perdões' },
  { id: '3149952', name: 'Periquito' },
  { id: '3150000', name: 'Pescador' },
  { id: '3150109', name: 'Piau' },
  { id: '3150158', name: 'Piedade de Caratinga' },
  { id: '3150208', name: 'Piedade de Ponte Nova' },
  { id: '3150307', name: 'Piedade do Rio Grande' },
  { id: '3150406', name: 'Piedade dos Gerais' },
  { id: '3150505', name: 'Pimenta' },
  { id: '3150539', name: 'Pingo-d"Água' },
  { id: '3150570', name: 'Pintópolis' },
  { id: '3150604', name: 'Piracema' },
  { id: '3150703', name: 'Pirajuba' },
  { id: '3150802', name: 'Piranga' },
  { id: '3150901', name: 'Piranguçu' },
  { id: '3151008', name: 'Piranguinho' },
  { id: '3151107', name: 'Pirapetinga' },
  { id: '3151206', name: 'Pirapora' },
  { id: '3151305', name: 'Piraúba' },
  { id: '3151404', name: 'Pitangui' },
  { id: '3151503', name: 'Piumhi' },
  { id: '3151602', name: 'Planura' },
  { id: '3151701', name: 'Poço Fundo' },
  { id: '3151800', name: 'Poços de Caldas' },
  { id: '3151909', name: 'Pocrane' },
  { id: '3152006', name: 'Pompéu' },
  { id: '3152105', name: 'Ponte Nova' },
  { id: '3152131', name: 'Ponto Chique' },
  { id: '3152170', name: 'Ponto dos Volantes' },
  { id: '3152204', name: 'Porteirinha' },
  { id: '3152303', name: 'Porto Firme' },
  { id: '3152402', name: 'Poté' },
  { id: '3152501', name: 'Pouso Alegre' },
  { id: '3152600', name: 'Pouso Alto' },
  { id: '3152709', name: 'Prados' },
  { id: '3152808', name: 'Prata' },
  { id: '3152907', name: 'Pratápolis' },
  { id: '3153004', name: 'Pratinha' },
  { id: '3153103', name: 'Presidente Bernardes' },
  { id: '3153202', name: 'Presidente Juscelino' },
  { id: '3153301', name: 'Presidente Kubitschek' },
  { id: '3153400', name: 'Presidente Olegário' },
  { id: '3153608', name: 'Prudente de Morais' },
  { id: '3153707', name: 'QQuartel Geral' },
  { id: '3153806', name: 'Queluzito' },
  { id: '3153905', name: 'Raposos' },
  { id: '3154002', name: 'Raul Soares' },
  { id: '3154101', name: 'Recreio' },
  { id: '3154150', name: 'Reduto' },
  { id: '3154200', name: 'Resende Costa' },
  { id: '3154309', name: 'Resplendor' },
  { id: '3154408', name: 'ReSaquinha' },
  { id: '3154457', name: 'Riachinho' },
  { id: '3154507', name: 'Riacho dos Machados' },
  { id: '3154705', name: 'Ribeirão Vermelho' },
  { id: '3154606', name: 'Ribeirão das Neves' },
  { id: '3154804', name: 'Rio Acima' },
  { id: '3154903', name: 'Rio Casca' },
  { id: '3155009', name: 'Rio Doce' },
  { id: '3155207', name: 'Rio Espera' },
  { id: '3155306', name: 'Rio Manso' },
  { id: '3155405', name: 'Rio Novo' },
  { id: '3155504', name: 'Rio Paranaíba' },
  { id: '3155603', name: 'Rio Pardo de Minas' },
  { id: '3155702', name: 'Rio Piracicaba' },
  { id: '3155801', name: 'Rio Pomba' },
  { id: '3155900', name: 'Rio Preto' },
  { id: '3156007', name: 'Rio Vermelho' },
  { id: '3155108', name: 'Rio do Prado' },
  { id: '3156106', name: 'Ritápolis' },
  { id: '3156205', name: 'Rochedo de Minas' },
  { id: '3156304', name: 'Rodeiro' },
  { id: '3156403', name: 'Romaria' },
  { id: '3156452', name: 'Rosário da Limeira' },
  { id: '3156502', name: 'Rubelita' },
  { id: '3156601', name: 'Rubim' },
  { id: '3156700', name: 'Sabará' },
  { id: '3156809', name: 'Sabinópolis' },
  { id: '3156908', name: 'Sacramento' },
  { id: '3157005', name: 'Salinas' },
  { id: '3157104', name: 'Salto da Divisa' },
  { id: '3157203', name: 'Santa Bárbara' },
  { id: '3157252', name: 'Santa Bárbara do Leste' },
  { id: '3157278', name: 'Santa Bárbara do Monte Verde' },
  { id: '3157302', name: 'Santa Bárbara do Tugúrio' },
  { id: '3157336', name: 'Santa Cruz de Minas' },
  { id: '3157377', name: 'Santa Cruz de Salinas' },
  { id: '3157401', name: 'Santa Cruz do Escalvado' },
  { id: '3157500', name: 'Santa Efigênia de Minas' },
  { id: '3157609', name: 'Santa Fé de Minas' },
  { id: '3157658', name: 'Santa Helena de Minas' },
  { id: '3157708', name: 'Santa Juliana' },
  { id: '3157807', name: 'Santa Luzia' },
  { id: '3157906', name: 'Santa Margarida' },
  { id: '3158003', name: 'Santa Maria de Itabira' },
  { id: '3158102', name: 'Santa Maria do Salto' },
  { id: '3158201', name: 'Santa Maria do Suaçuí' },
  { id: '3159209', name: 'Santa Rita de Caldas' },
  { id: '3159407', name: 'Santa Rita de Ibitipoca' },
  { id: '3159308', name: 'Santa Rita de Jacutinga' },
  { id: '3159357', name: 'Santa Rita de Minas' },
  { id: '3159506', name: 'Santa Rita do Itueto' },
  { id: '3159605', name: 'Santa Rita do Sapucaí' },
  { id: '3159704', name: 'Santa Rosa da Serra' },
  { id: '3159803', name: 'Santa Vitória' },
  { id: '3158300', name: 'Santana da Vargem' },
  { id: '3158409', name: 'Santana de Cataguases' },
  { id: '3158508', name: 'Santana de Pirapama' },
  { id: '3158607', name: 'Santana do Deserto' },
  { id: '3158706', name: 'Santana do Garambéu' },
  { id: '3158805', name: 'Santana do Jacaré' },
  { id: '3158904', name: 'Santana do Manhuaçu' },
  { id: '3158953', name: 'Santana do Paraíso' },
  { id: '3159001', name: 'Santana do Riacho' },
  { id: '3159100', name: 'Santana dos Montes' },
  { id: '3159902', name: 'Santo Antônio do Amparo' },
  { id: '3160009', name: 'Santo Antônio do Aventureiro' },
  { id: '3160108', name: 'Santo Antônio do Grama' },
  { id: '3160207', name: 'Santo Antônio do Itambé' },
  { id: '3160306', name: 'Santo Antônio do Jacinto' },
  { id: '3160405', name: 'Santo Antônio do Monte' },
  { id: '3160454', name: 'Santo Antônio do Retiro' },
  { id: '3160504', name: 'Santo Antônio do Rio Abaixo' },
  { id: '3160603', name: 'Santo Hipólito' },
  { id: '3160702', name: 'Santos Dumont' },
  { id: '3160801', name: 'São Bento Abade' },
  { id: '3160900', name: 'São Brás do Suaçuí' },
  { id: '3160959', name: 'São Domingos das Dores' },
  { id: '3161007', name: 'São Domingos do Prata' },
  { id: '3161056', name: 'São Félix de Minas' },
  { id: '3161106', name: 'São Francisco' },
  { id: '3161205', name: 'São Francisco de Paula' },
  { id: '3161304', name: 'São Francisco de Sales' },
  { id: '3161403', name: 'São Francisco do Glória' },
  { id: '3161502', name: 'São Geraldo' },
  { id: '3161601', name: 'São Geraldo da Piedade' },
  { id: '3161650', name: 'São Geraldo do Baixio' },
  { id: '3161700', name: 'São Gonçalo do Abaeté' },
  { id: '3161809', name: 'São Gonçalo do Pará' },
  { id: '3161908', name: 'São Gonçalo do Rio Abaixo' },
  { id: '3125507', name: 'São Gonçalo do Rio Preto' },
  { id: '3162005', name: 'São Gonçalo do Sapucaí' },
  { id: '3162104', name: 'São Gotardo' },
  { id: '3162203', name: 'São João Batista do Glória' },
  { id: '3162807', name: 'São João Evangelista' },
  { id: '3162906', name: 'São João Nepomuceno' },
  { id: '3162252', name: 'São João da Lagoa' },
  { id: '3162302', name: 'São João da Mata' },
  { id: '3162401', name: 'São João da Ponte' },
  { id: '3162450', name: 'São João das MiSões' },
  { id: '3162500', name: 'São João del Rei' },
  { id: '3162559', name: 'São João do Manhuaçu' },
  { id: '3162575', name: 'São João do Manteninha' },
  { id: '3162609', name: 'São João do Oriente' },
  { id: '3162658', name: 'São João do Pacuí' },
  { id: '3162708', name: 'São João do Paraíso' },
  { id: '3162922', name: 'São Joaquim de Bicas' },
  { id: '3162948', name: 'São José da BaRa' },
  { id: '3162955', name: 'São José da Lapa' },
  { id: '3163003', name: 'São José da Safira' },
  { id: '3163102', name: 'São José da Varginha' },
  { id: '3163201', name: 'São José do Alegre' },
  { id: '3163300', name: 'São José do Divino' },
  { id: '3163409', name: 'São José do Goiabal' },
  { id: '3163508', name: 'São José do Jacuri' },
  { id: '3163607', name: 'São José do Mantimento' },
  { id: '3163706', name: 'São Lourenço' },
  { id: '3163805', name: 'São Miguel do Anta' },
  { id: '3163904', name: 'São Pedro da União' },
  { id: '3164100', name: 'São Pedro do Suaçuí' },
  { id: '3164001', name: 'São Pedro dos FeRos' },
  { id: '3164209', name: 'São Romão' },
  { id: '3164308', name: 'São Roque de Minas' },
  { id: '3164407', name: 'São Sebastião da Bela Vista' },
  { id: '3164431', name: 'São Sebastião da Vargem Alegre' },
  { id: '3164472', name: 'São Sebastião do Anta' },
  { id: '3164506', name: 'São Sebastião do Maranhão' },
  { id: '3164605', name: 'São Sebastião do Oeste' },
  { id: '3164704', name: 'São Sebastião do Paraíso' },
  { id: '3164803', name: 'São Sebastião do Rio Preto' },
  { id: '3164902', name: 'São Sebastião do Rio Verde' },
  { id: '3165008', name: 'São Tiago' },
  { id: '3165107', name: 'São Tomás de Aquino' },
  { id: '3165206', name: 'São Tomé das Letras' },
  { id: '3165305', name: 'São Vicente de Minas' },
  { id: '3165404', name: 'Sapucaí-Mirim' },
  { id: '3165503', name: 'Sardoá' },
  { id: '3165537', name: 'Sarzedo' },
  { id: '3165560', name: 'Sem-Peixe' },
  { id: '3165578', name: 'Senador Amaral' },
  { id: '3165602', name: 'Senador Cortes' },
  { id: '3165701', name: 'Senador Firmino' },
  { id: '3165800', name: 'Senador José Bento' },
  { id: '3165909', name: 'Senador Modestino Gonçalves' },
  { id: '3166006', name: 'Senhora de Oliveira' },
  { id: '3166105', name: 'Senhora do Porto' },
  { id: '3166204', name: 'Senhora dos Remédios' },
  { id: '3166303', name: 'Sericita' },
  { id: '3166402', name: 'Seritinga' },
  { id: '3166501', name: 'Serra Azul de Minas' },
  { id: '3166600', name: 'Serra da Saudade' },
  { id: '3166808', name: 'Serra do Salitre' },
  { id: '3166709', name: 'Serra dos Aimorés' },
  { id: '3166907', name: 'Serrania' },
  { id: '3166956', name: 'Serranópolis de Minas' },
  { id: '3167004', name: 'Serranos' },
  { id: '3167103', name: 'SeRo' },
  { id: '3167202', name: 'Sete Lagoas' },
  { id: '3165552', name: 'Setubinha' },
  { id: '3167301', name: 'Silveirânia' },
  { id: '3167400', name: 'Silvianópolis' },
  { id: '3167509', name: 'Simão Pereira' },
  { id: '3167608', name: 'Simonésia' },
  { id: '3167707', name: 'Sobrália' },
  { id: '3167806', name: 'Soledade de Minas' },
  { id: '3167905', name: 'Tabuleiro' },
  { id: '3168002', name: 'Taiobeiras' },
  { id: '3168051', name: 'Taparuba' },
  { id: '3168101', name: 'Tapira' },
  { id: '3168200', name: 'Tapiraí' },
  { id: '3168309', name: 'Taquaraçu de Minas' },
  { id: '3168408', name: 'Tarumirim' },
  { id: '3168507', name: 'Teixeiras' },
  { id: '3168606', name: 'Teófilo Otoni' },
  { id: '3168705', name: 'Timóteo' },
  { id: '3168804', name: 'Tiradentes' },
  { id: '3168903', name: 'Tiros' },
  { id: '3169000', name: 'Tocantins' },
  { id: '3169059', name: 'Tocos do Moji' },
  { id: '3169109', name: 'Toledo' },
  { id: '3169208', name: 'Tombos' },
  { id: '3169307', name: 'Três Corações' },
  { id: '3169356', name: 'Três Marias' },
  { id: '3169406', name: 'Três Pontas' },
  { id: '3169505', name: 'Tumiritinga' },
  { id: '3169604', name: 'Tupaciguara' },
  { id: '3169703', name: 'Turmalina' },
  { id: '3169802', name: 'Turvolândia' },
  { id: '3169901', name: 'Ubá' },
  { id: '3170008', name: 'Ubaí' },
  { id: '3170057', name: 'Ubaporanga' },
  { id: '3170107', name: 'Uberaba' },
  { id: '3170206', name: 'Uberlândia' },
  { id: '3170305', name: 'Umburatiba' },
  { id: '3170404', name: 'Unaí' },
  { id: '3170438', name: 'União de Minas' },
  { id: '3170479', name: 'Uruana de Minas' },
  { id: '3170503', name: 'Urucânia' },
  { id: '3170529', name: 'Urucuia' },
  { id: '3170578', name: 'Vargem Alegre' },
  { id: '3170602', name: 'Vargem Bonita' },
  { id: '3170651', name: 'Vargem Grande do Rio Pardo' },
  { id: '3170701', name: 'Varginha' },
  { id: '3170750', name: 'Varjão de Minas' },
  { id: '3170800', name: 'Várzea da Palma' },
  { id: '3170909', name: 'Varzelândia' },
  { id: '3171006', name: 'Vazante' },
  { id: '3171030', name: 'Verdelândia' },
  { id: '3171071', name: 'Veredinha' },
  { id: '3171105', name: 'VeríSimo' },
  { id: '3171154', name: 'Vermelho Novo' },
  { id: '3171204', name: 'Vespasiano' },
  { id: '3171303', name: 'Viçosa' },
  { id: '3171402', name: 'Vieiras' },
  { id: '3171600', name: 'Virgem da Lapa' },
  { id: '3171709', name: 'Virgínia' },
  { id: '3171808', name: 'Virginópolis' },
  { id: '3171907', name: 'Virgolândia' },
  { id: '3172004', name: 'Visconde do Rio Branco' },
  { id: '3172103', name: 'Volta Grande' },
  { id: '3172202', name: 'Wenceslau Braz' },
  { id: '1500107', name: 'Abaetetuba' },
  { id: '1500131', name: 'Abel Figueiredo' },
  { id: '1500206', name: 'Acará' },
  { id: '1500305', name: 'Afuá' },
  { id: '1500347', name: 'Água Azul do Norte' },
  { id: '1500404', name: 'Alenquer' },
  { id: '1500503', name: 'Almeirim' },
  { id: '1500602', name: 'Altamira' },
  { id: '1500701', name: 'Anajás' },
  { id: '1500800', name: 'Ananindeua' },
  { id: '1500859', name: 'Anapu' },
  { id: '1500909', name: 'Augusto CoRêa' },
  { id: '1500958', name: 'Aurora do Pará' },
  { id: '1501006', name: 'Aveiro' },
  { id: '1501105', name: 'Bagre' },
  { id: '1501204', name: 'Baião' },
  { id: '1501253', name: 'BaNach' },
  { id: '1501303', name: 'Barcarena' },
  { id: '1501402', name: 'Belém' },
  { id: '1501451', name: 'BelteRa' },
  { id: '1501501', name: 'Benevides' },
  { id: '1501576', name: 'Bom Jesus do Tocantins' },
  { id: '1501600', name: 'Bonito' },
  { id: '1501709', name: 'Bragança' },
  { id: '1501725', name: 'Brasil Novo' },
  { id: '1501758', name: 'Brejo Grande do Araguaia' },
  { id: '1501782', name: 'Breu Branco' },
  { id: '1501808', name: 'Breves' },
  { id: '1501907', name: 'Bujaru' },
  { id: '1502004', name: 'Cachoeira do Arari' },
  { id: '1501956', name: 'Cachoeira do Piriá' },
  { id: '1502103', name: 'Cametá' },
  { id: '1502152', name: 'Canaã dos Carajás' },
  { id: '1502202', name: 'Capanema' },
  { id: '1502301', name: 'Capitão Poço' },
  { id: '1502400', name: 'Castanhal' },
  { id: '1502509', name: 'Chaves' },
  { id: '1502608', name: 'Colares' },
  { id: '1502707', name: 'Conceição do Araguaia' },
  { id: '1502756', name: 'Concórdia do Pará' },
  { id: '1502764', name: 'Cumaru do Norte' },
  { id: '1502772', name: 'Curionópolis' },
  { id: '1502806', name: 'CuRalinho' },
  { id: '1502855', name: 'Curuá' },
  { id: '1502905', name: 'Curuçá' },
  { id: '1502939', name: 'Dom Eliseu' },
  { id: '1502954', name: 'Eldorado do Carajás' },
  { id: '1503002', name: 'Faro' },
  { id: '1503044', name: 'Floresta do Araguaia' },
  { id: '1503077', name: 'GaRafão do Norte' },
  { id: '1503093', name: 'Goianésia do Pará' },
  { id: '1503101', name: 'Gurupá' },
  { id: '1503200', name: 'Igarapé-Açu' },
  { id: '1503309', name: 'Igarapé-Miri' },
  { id: '1503408', name: 'Inhangapi' },
  { id: '1503457', name: 'Ipixuna do Pará' },
  { id: '1503507', name: 'Irituia' },
  { id: '1503606', name: 'Itaituba' },
  { id: '1503705', name: 'Itupiranga' },
  { id: '1503754', name: 'Jacareacanga' },
  { id: '1503804', name: 'Jacundá' },
  { id: '1503903', name: 'Juruti' },
  { id: '1504000', name: 'Limoeiro do Ajuru' },
  { id: '1504059', name: 'Mãe do Rio' },
  { id: '1504109', name: 'Magalhães Barata' },
  { id: '1504208', name: 'Marabá' },
  { id: '1504307', name: 'Maracanã' },
  { id: '1504406', name: 'Marapanim' },
  { id: '1504422', name: 'Marituba' },
  { id: '1504455', name: 'Medicilândia' },
  { id: '1504505', name: 'Melgaço' },
  { id: '1504604', name: 'Mocajuba' },
  { id: '1504703', name: 'Moju' },
  { id: '1504752', name: 'Mojuí dos Campos' },
  { id: '1504802', name: 'Monte Alegre' },
  { id: '1504901', name: 'Muaná' },
  { id: '1504950', name: 'Nova Esperança do Piriá' },
  { id: '1504976', name: 'Nova Ipixuna' },
  { id: '1505007', name: 'Nova Timboteua' },
  { id: '1505031', name: 'Novo ProgreSo' },
  { id: '1505064', name: 'Novo Repartimento' },
  { id: '1505106', name: 'OÓbidos' },
  { id: '1505205', name: 'Oeiras do Pará' },
  { id: '1505304', name: 'Oriximiná' },
  { id: '1505403', name: 'Ourém' },
  { id: '1505437', name: 'Ourilândia do Norte' },
  { id: '1505486', name: 'Pacajá' },
  { id: '1505494', name: 'Palestina do Pará' },
  { id: '1505502', name: 'Paragominas' },
  { id: '1505536', name: 'Parauapebas' },
  { id: '1505551', name: 'Pau D"Arco' },
  { id: '1505601', name: 'Peixe-Boi' },
  { id: '1505635', name: 'PiçaRa' },
  { id: '1505650', name: 'Placas' },
  { id: '1505700', name: 'Ponta de Pedras' },
  { id: '1505809', name: 'Portel' },
  { id: '1505908', name: 'Porto de Moz' },
  { id: '1506005', name: 'Prainha' },
  { id: '1506104', name: 'Primavera' },
  { id: '1506112', name: 'QQuatipuru' },
  { id: '1506138', name: 'Redenção' },
  { id: '1506161', name: 'Rio Maria' },
  { id: '1506187', name: 'Rondon do Pará' },
  { id: '1506195', name: 'Rurópolis' },
  { id: '1506203', name: 'Salinópolis' },
  { id: '1506302', name: 'SalvateRa' },
  { id: '1506351', name: 'Santa Bárbara do Pará' },
  { id: '1506401', name: 'Santa Cruz do Arari' },
  { id: '1506500', name: 'Santa Izabel do Pará' },
  { id: '1506559', name: 'Santa Luzia do Pará' },
  { id: '1506583', name: 'Santa Maria das BaReiras' },
  { id: '1506609', name: 'Santa Maria do Pará' },
  { id: '1506708', name: 'Santana do Araguaia' },
  { id: '1506807', name: 'Santarém' },
  { id: '1506906', name: 'Santarém Novo' },
  { id: '1507003', name: 'Santo Antônio do Tauá' },
  { id: '1507102', name: 'São Caetano de Odivelas' },
  { id: '1507151', name: 'São Domingos do Araguaia' },
  { id: '1507201', name: 'São Domingos do Capim' },
  { id: '1507300', name: 'São Félix do Xingu' },
  { id: '1507409', name: 'São Francisco do Pará' },
  { id: '1507458', name: 'São Geraldo do Araguaia' },
  { id: '1507466', name: 'São João da Ponta' },
  { id: '1507474', name: 'São João de Pirabas' },
  { id: '1507508', name: 'São João do Araguaia' },
  { id: '1507607', name: 'São Miguel do Guamá' },
  { id: '1507706', name: 'São Sebastião da Boa Vista' },
  { id: '1507755', name: 'Sapucaia' },
  { id: '1507805', name: 'Senador José Porfírio' },
  { id: '1507904', name: 'Soure' },
  { id: '1507953', name: 'Tailândia' },
  { id: '1507961', name: 'TeRa Alta' },
  { id: '1507979', name: 'TeRa Santa' },
  { id: '1508001', name: 'Tomé-Açu' },
  { id: '1508035', name: 'Tracuateua' },
  { id: '1508050', name: 'Trairão' },
  { id: '1508084', name: 'Tucumã' },
  { id: '1508100', name: 'Tucuruí' },
  { id: '1508126', name: 'Ulianópolis' },
  { id: '1508159', name: 'Uruará' },
  { id: '1508209', name: 'Vigia' },
  { id: '1508308', name: 'Viseu' },
  { id: '1508357', name: 'Vitória do Xingu' },
  { id: '1508407', name: 'Xinguara' },
  { id: '2500106', name: 'AÁgua Branca' },
  { id: '2500205', name: 'Aguiar' },
  { id: '2500304', name: 'Alagoa Grande' },
  { id: '2500403', name: 'Alagoa Nova' },
  { id: '2500502', name: 'Alagoinha' },
  { id: '2500536', name: 'Alcantil' },
  { id: '2500577', name: 'Algodão de Jandaíra' },
  { id: '2500601', name: 'Alhandra' },
  { id: '2500734', name: 'Amparo' },
  { id: '2500775', name: 'Aparecida' },
  { id: '2500809', name: 'Araçagi' },
  { id: '2500908', name: 'Arara' },
  { id: '2501005', name: 'Araruna' },
  { id: '2501104', name: 'Areia' },
  { id: '2501153', name: 'Areia de Baraúnas' },
  { id: '2501203', name: 'Areial' },
  { id: '2501302', name: 'Aroeiras' },
  { id: '2501351', name: 'ASunção' },
  { id: '2501401', name: 'Baía da Traição' },
  { id: '2501500', name: 'Bananeiras' },
  { id: '2501534', name: 'Baraúna' },
  { id: '2501609', name: 'BaRa de Santa Rosa' },
  { id: '2501575', name: 'BaRa de Santana' },
  { id: '2501708', name: 'BaRa de São Miguel' },
  { id: '2501807', name: 'Bayeux' },
  { id: '2501906', name: 'Belém' },
  { id: '2502003', name: 'Belém do Brejo do Cruz' },
  { id: '2502052', name: 'Bernardino Batista' },
  { id: '2502102', name: 'Boa Ventura' },
  { id: '2502151', name: 'Boa Vista' },
  { id: '2502201', name: 'Bom Jesus' },
  { id: '2502300', name: 'Bom SuceSo' },
  { id: '2502409', name: 'Bonito de Santa Fé' },
  { id: '2502508', name: 'Boqueirão' },
  { id: '2502706', name: 'Borborema' },
  { id: '2502805', name: 'Brejo do Cruz' },
  { id: '2502904', name: 'Brejo dos Santos' },
  { id: '2503001', name: 'CAporã' },
  { id: '2503100', name: 'Cabaceiras' },
  { id: '2503209', name: 'Cabedelo' },
  { id: '2503308', name: 'Cachoeira dos Índios' },
  { id: '2503407', name: 'Cacimba de Areia' },
  { id: '2503506', name: 'Cacimba de Dentro' },
  { id: '2503555', name: 'Cacimbas' },
  { id: '2503605', name: 'Caiçara' },
  { id: '2503704', name: 'Cajazeiras' },
  { id: '2503753', name: 'Cajazeirinhas' },
  { id: '2503803', name: 'Caldas Brandão' },
  { id: '2503902', name: 'Camalaú' },
  { id: '2504009', name: 'Campina Grande' },
  { id: '2504033', name: 'Capim' },
  { id: '2504074', name: 'Caraúbas' },
  { id: '2504108', name: 'CaRapateira' },
  { id: '2504157', name: 'CaSerengue' },
  { id: '2504207', name: 'Catingueira' },
  { id: '2504306', name: 'Catolé do Rocha' },
  { id: '2504355', name: 'Caturité' },
  { id: '2504405', name: 'Conceição' },
  { id: '2504504', name: 'Condado' },
  { id: '2504603', name: 'Conde' },
  { id: '2504702', name: 'Congo' },
  { id: '2504801', name: 'Coremas' },
  { id: '2504850', name: 'Coxixola' },
  { id: '2504900', name: 'Cruz do Espírito Santo' },
  { id: '2505006', name: 'Cubati' },
  { id: '2505105', name: 'Cuité' },
  { id: '2505238', name: 'Cuité de Mamanguape' },
  { id: '2505204', name: 'Cuitegi' },
  { id: '2505303', name: 'CuRal Velho' },
  { id: '2505279', name: 'CuRal de Cima' },
  { id: '2505352', name: 'Damião' },
  { id: '2505402', name: 'DesteRo' },
  { id: '2505600', name: 'Diamante' },
  { id: '2505709', name: 'Dona Inês' },
  { id: '2505808', name: 'Duas Estradas' },
  { id: '2505907', name: 'Emas' },
  { id: '2506004', name: 'Esperança' },
  { id: '2506103', name: 'Fagundes' },
  { id: '2506202', name: 'Frei Martinho' },
  { id: '2506251', name: 'Gado Bravo' },
  { id: '2506301', name: 'Guarabira' },
  { id: '2506400', name: 'Gurinhém' },
  { id: '2506509', name: 'Gurjão' },
  { id: '2506608', name: 'Ibiara' },
  { id: '2502607', name: 'Igaracy' },
  { id: '2506707', name: 'Imaculada' },
  { id: '2506806', name: 'Ingá' },
  { id: '2506905', name: 'Itabaiana' },
  { id: '2507002', name: 'Itaporanga' },
  { id: '2507101', name: 'Itapororoca' },
  { id: '2507200', name: 'Itatuba' },
  { id: '2507309', name: 'Jacaraú' },
  { id: '2507408', name: 'Jericó' },
  { id: '2507507', name: 'João Pessoa' },
  { id: '2513653', name: 'Joca Claudino' },
  { id: '2507606', name: 'Juarez Távora' },
  { id: '2507705', name: 'Juazeirinho' },
  { id: '2507804', name: 'Junco do Seridó' },
  { id: '2507903', name: 'Juripiranga' },
  { id: '2508000', name: 'Juru' },
  { id: '2508109', name: 'Lagoa' },
  { id: '2508307', name: 'Lagoa Seca' },
  { id: '2508208', name: 'Lagoa de Dentro' },
  { id: '2508406', name: 'Lastro' },
  { id: '2508505', name: 'Livramento' },
  { id: '2508554', name: 'Logradouro' },
  { id: '2508604', name: 'Lucena' },
  { id: '2508703', name: 'Mãe d"Água' },
  { id: '2508802', name: 'Malta' },
  { id: '2508901', name: 'Mamanguape' },
  { id: '2509008', name: 'Manaíra' },
  { id: '2509057', name: 'Marcação' },
  { id: '2509107', name: 'Mari' },
  { id: '2509156', name: 'Marizópolis' },
  { id: '2509206', name: 'MaSaranduba' },
  { id: '2509305', name: 'Mataraca' },
  { id: '2509339', name: 'Matinhas' },
  { id: '2509370', name: 'Mato GroSo' },
  { id: '2509396', name: 'Maturéia' },
  { id: '2509404', name: 'Mogeiro' },
  { id: '2509503', name: 'Montadas' },
  { id: '2509602', name: 'Monte Horebe' },
  { id: '2509701', name: 'Monteiro' },
  { id: '2509800', name: 'Mulungu' },
  { id: '2509909', name: 'Natuba' },
  { id: '2510006', name: 'Nazarezinho' },
  { id: '2510105', name: 'Nova Floresta' },
  { id: '2510204', name: 'Nova Olinda' },
  { id: '2510303', name: 'Nova Palmeira' },
  { id: '2510402', name: 'Olho d"Água' },
  { id: '2510501', name: 'Olivedos' },
  { id: '2510600', name: 'Ouro Velho' },
  { id: '2510659', name: 'Parari' },
  { id: '2510709', name: 'PaSagem' },
  { id: '2510808', name: 'Patos' },
  { id: '2510907', name: 'Paulista' },
  { id: '2511004', name: 'Pedra Branca' },
  { id: '2511103', name: 'Pedra Lavrada' },
  { id: '2511202', name: 'Pedras de Fogo' },
  { id: '2512721', name: 'Pedro Régis' },
  { id: '2511301', name: 'Piancó' },
  { id: '2511400', name: 'Picuí' },
  { id: '2511509', name: 'Pilar' },
  { id: '2511608', name: 'Pilões' },
  { id: '2511707', name: 'Pilõezinhos' },
  { id: '2511806', name: 'Pirpirituba' },
  { id: '2511905', name: 'Pitimbu' },
  { id: '2512002', name: 'Pocinhos' },
  { id: '2512036', name: 'Poço Dantas' },
  { id: '2512077', name: 'Poço de José de Moura' },
  { id: '2512101', name: 'Pombal' },
  { id: '2512200', name: 'Prata' },
  { id: '2512309', name: 'Princesa Isabel' },
  { id: '2512408', name: 'Puxinanã' },
  { id: '2512507', name: 'QQueimadas' },
  { id: '2512606', name: 'Quixaba' },
  { id: '2512705', name: 'Remígio' },
  { id: '2512747', name: 'Riachão' },
  { id: '2512754', name: 'Riachão do Bacamarte' },
  { id: '2512762', name: 'Riachão do Poço' },
  { id: '2512788', name: 'Riacho de Santo Antônio' },
  { id: '2512804', name: 'Riacho dos Cavalos' },
  { id: '2512903', name: 'Rio Tinto' },
  { id: '2513000', name: 'Salgadinho' },
  { id: '2513109', name: 'Salgado de São Félix' },
  { id: '2513158', name: 'Santa Cecília' },
  { id: '2513208', name: 'Santa Cruz' },
  { id: '2513307', name: 'Santa Helena' },
  { id: '2513356', name: 'Santa Inês' },
  { id: '2513406', name: 'Santa Luzia' },
  { id: '2513703', name: 'Santa Rita' },
  { id: '2513802', name: 'Santa Teresinha' },
  { id: '2513505', name: 'Santana de Mangueira' },
  { id: '2513604', name: 'Santana dos GaRotes' },
  { id: '2513851', name: 'Santo André' },
  { id: '2513927', name: 'São Bentinho' },
  { id: '2513901', name: 'São Bento' },
  { id: '2513968', name: 'São Domingos' },
  { id: '2513943', name: 'São Domingos do Cariri' },
  { id: '2513984', name: 'São Francisco' },
  { id: '2514008', name: 'São João do Cariri' },
  { id: '2500700', name: 'São João do Rio do Peixe' },
  { id: '2514107', name: 'São João do Tigre' },
  { id: '2514206', name: 'São José da Lagoa Tapada' },
  { id: '2514305', name: 'São José de Caiana' },
  { id: '2514404', name: 'São José de Espinharas' },
  { id: '2514503', name: 'São José de Piranhas' },
  { id: '2514552', name: 'São José de Princesa' },
  { id: '2514602', name: 'São José do Bonfim' },
  { id: '2514651', name: 'São José do Brejo do Cruz' },
  { id: '2514701', name: 'São José do Sabugi' },
  { id: '2514800', name: 'São José dos Cordeiros' },
  { id: '2514453', name: 'São José dos Ramos' },
  { id: '2514909', name: 'São Mamede' },
  { id: '2515005', name: 'São Miguel de Taipu' },
  { id: '2515104', name: 'São Sebastião de Lagoa de Roça' },
  { id: '2515203', name: 'São Sebastião do Umbuzeiro' },
  { id: '2515401', name: 'São Vicente do Seridó' },
  { id: '2515302', name: 'Sapé' },
  { id: '2515500', name: 'Serra Branca' },
  { id: '2515708', name: 'Serra Grande' },
  { id: '2515807', name: 'Serra Redonda' },
  { id: '2515609', name: 'Serra da Raiz' },
  { id: '2515906', name: 'Serraria' },
  { id: '2515930', name: 'Sertãozinho' },
  { id: '2515971', name: 'Sobrado' },
  { id: '2516003', name: 'Solânea' },
  { id: '2516102', name: 'Soledade' },
  { id: '2516151', name: 'SoSêgo' },
  { id: '2516201', name: 'Sousa' },
  { id: '2516300', name: 'Sumé' },
  { id: '2516409', name: 'Tacima' },
  { id: '2516508', name: 'Taperoá' },
  { id: '2516607', name: 'Tavares' },
  { id: '2516706', name: 'Teixeira' },
  { id: '2516755', name: 'Tenório' },
  { id: '2516805', name: 'Triunfo' },
  { id: '2516904', name: 'Uiraúna' },
  { id: '2517001', name: 'Umbuzeiro' },
  { id: '2517100', name: 'Várzea' },
  { id: '2517209', name: 'Vieirópolis' },
  { id: '2505501', name: 'Vista Serrana' },
  { id: '2517407', name: 'Zabelê' },
  { id: '4100103', name: 'Abatiá' },
  { id: '4100202', name: 'Adrianópolis' },
  { id: '4100301', name: 'Agudos do Sul' },
  { id: '4100400', name: 'Almirante Tamandaré' },
  { id: '4100459', name: 'Altamira do Paraná' },
  { id: '4128625', name: 'Alto Paraíso' },
  { id: '4100608', name: 'Alto Paraná' },
  { id: '4100707', name: 'Alto Piquiri' },
  { id: '4100509', name: 'Altônia' },
  { id: '4100806', name: 'Alvorada do Sul' },
  { id: '4100905', name: 'Amaporã' },
  { id: '4101002', name: 'Ampére' },
  { id: '4101051', name: 'Anahy' },
  { id: '4101101', name: 'Andirá' },
  { id: '4101150', name: 'Ângulo' },
  { id: '4101200', name: 'Antonina' },
  { id: '4101309', name: 'Antônio Olinto' },
  { id: '4101408', name: 'Apucarana' },
  { id: '4101507', name: 'Arapongas' },
  { id: '4101606', name: 'Arapoti' },
  { id: '4101655', name: 'Arapuã' },
  { id: '4101705', name: 'Araruna' },
  { id: '4101804', name: 'Araucária' },
  { id: '4101853', name: 'Ariranha do Ivaí' },
  { id: '4101903', name: 'ASaí' },
  { id: '4102000', name: 'ASis Chateaubriand' },
  { id: '4102109', name: 'Astorga' },
  { id: '4102208', name: 'Atalaia' },
  { id: '4102307', name: 'Balsa Nova' },
  { id: '4102406', name: 'Bandeirantes' },
  { id: '4102505', name: 'Barbosa FeRaz' },
  { id: '4102703', name: 'BaRa do Jacaré' },
  { id: '4102604', name: 'BaRacão' },
  { id: '4102752', name: 'Bela Vista da Caroba' },
  { id: '4102802', name: 'Bela Vista do Paraíso' },
  { id: '4102901', name: 'Bituruna' },
  { id: '4103008', name: 'Boa Esperança' },
  { id: '4103024', name: 'Boa Esperança do Iguaçu' },
  { id: '4103040', name: 'Boa Ventura de São Roque' },
  { id: '4103057', name: 'Boa Vista da Aparecida' },
  { id: '4103107', name: 'Bocaiúva do Sul' },
  { id: '4103156', name: 'Bom Jesus do Sul' },
  { id: '4103206', name: 'Bom SuceSo' },
  { id: '4103222', name: 'Bom SuceSo do Sul' },
  { id: '4103305', name: 'BoRazópolis' },
  { id: '4103354', name: 'Braganey' },
  { id: '4103370', name: 'Brasilândia do Sul' },
  { id: '4103404', name: 'Cafeara' },
  { id: '4103453', name: 'Cafelândia' },
  { id: '4103479', name: 'Cafezal do Sul' },
  { id: '4103503', name: 'Califórnia' },
  { id: '4103602', name: 'Cambará' },
  { id: '4103701', name: 'Cambé' },
  { id: '4103800', name: 'Cambira' },
  { id: '4104006', name: 'Campina Grande do Sul' },
  { id: '4103909', name: 'Campina da Lagoa' },
  { id: '4103958', name: 'Campina do Simão' },
  { id: '4104055', name: 'Campo Bonito' },
  { id: '4104204', name: 'Campo Largo' },
  { id: '4104253', name: 'Campo Magro' },
  { id: '4104303', name: 'Campo Mourão' },
  { id: '4104105', name: 'Campo do Tenente' },
  { id: '4104402', name: 'Cândido de Abreu' },
  { id: '4104428', name: 'Candói' },
  { id: '4104451', name: 'Cantagalo' },
  { id: '4104501', name: 'Capanema' },
  { id: '4104600', name: 'Capitão Leônidas Marques' },
  { id: '4104659', name: 'Carambeí' },
  { id: '4104709', name: 'Carlópolis' },
  { id: '4104808', name: 'Cascavel' },
  { id: '4104907', name: 'Castro' },
  { id: '4105003', name: 'Catanduvas' },
  { id: '4105102', name: 'Centenário do Sul' },
  { id: '4105201', name: 'CeRo Azul' },
  { id: '4105300', name: 'Céu Azul' },
  { id: '4105409', name: 'Chopinzinho' },
  { id: '4105508', name: 'Cianorte' },
  { id: '4105607', name: 'Cidade Gaúcha' },
  { id: '4105706', name: 'Clevelândia' },
  { id: '4105805', name: 'Colombo' },
  { id: '4105904', name: 'Colorado' },
  { id: '4106001', name: 'Congonhinhas' },
  { id: '4106100', name: 'Conselheiro Mairinck' },
  { id: '4106209', name: 'Contenda' },
  { id: '4106308', name: 'Corbélia' },
  { id: '4106407', name: 'Cornélio Procópio' },
  { id: '4106456', name: 'Coronel Domingos Soares' },
  { id: '4106506', name: 'Coronel Vivida' },
  { id: '4106555', name: 'Corumbataí do Sul' },
  { id: '4106803', name: 'Cruz Machado' },
  { id: '4106571', name: 'Cruzeiro do Iguaçu' },
  { id: '4106605', name: 'Cruzeiro do Oeste' },
  { id: '4106704', name: 'Cruzeiro do Sul' },
  { id: '4106852', name: 'Cruzmaltina' },
  { id: '4106902', name: 'Curitiba' },
  { id: '4107009', name: 'Curiúva' },
  { id: '4107157', name: 'Diamante D"Oeste' },
  { id: '4107108', name: 'Diamante do Norte' },
  { id: '4107124', name: 'Diamante do Sul' },
  { id: '4107207', name: 'Dois Vizinhos' },
  { id: '4107256', name: 'Douradina' },
  { id: '4107306', name: 'Doutor Camargo' },
  { id: '4128633', name: 'Doutor UlySes' },
  { id: '4107405', name: 'Enéas Marques' },
  { id: '4107504', name: 'Engenheiro Beltrão' },
  { id: '4107538', name: 'Entre Rios do Oeste' },
  { id: '4107520', name: 'Esperança Nova' },
  { id: '4107546', name: 'Espigão Alto do Iguaçu' },
  { id: '4107553', name: 'Farol' },
  { id: '4107603', name: 'Faxinal' },
  { id: '4107652', name: 'Fazenda Rio Grande' },
  { id: '4107702', name: 'Fênix' },
  { id: '4107736', name: 'Fernandes Pinheiro' },
  { id: '4107751', name: 'Figueira' },
  { id: '4107850', name: 'Flor da Serra do Sul' },
  { id: '4107801', name: 'Floraí' },
  { id: '4107900', name: 'Floresta' },
  { id: '4108007', name: 'Florestópolis' },
  { id: '4108106', name: 'Flórida' },
  { id: '4108205', name: 'Formosa do Oeste' },
  { id: '4108304', name: 'Foz do Iguaçu' },
  { id: '4108452', name: 'Foz do Jordão' },
  { id: '4108320', name: 'Francisco Alves' },
  { id: '4108403', name: 'Francisco Beltrão' },
  { id: '4108502', name: 'General Carneiro' },
  { id: '4108551', name: 'Godoy Moreira' },
  { id: '4108601', name: 'Goioerê' },
  { id: '4108650', name: 'Goioxim' },
  { id: '4108700', name: 'Grandes Rios' },
  { id: '4108809', name: 'Guaíra' },
  { id: '4108908', name: 'Guairaçá' },
  { id: '4108957', name: 'Guamiranga' },
  { id: '4109005', name: 'Guapirama' },
  { id: '4109104', name: 'Guaporema' },
  { id: '4109203', name: 'Guaraci' },
  { id: '4109302', name: 'Guaraniaçu' },
  { id: '4109401', name: 'Guarapuava' },
  { id: '4109500', name: 'Guaraqueçaba' },
  { id: '4109609', name: 'Guaratuba' },
  { id: '4109658', name: 'Honório Serpa' },
  { id: '4109708', name: 'Ibaiti' },
  { id: '4109757', name: 'Ibema' },
  { id: '4109807', name: 'Ibiporã' },
  { id: '4109906', name: 'Icaraíma' },
  { id: '4110003', name: 'Iguaraçu' },
  { id: '4110052', name: 'Iguatu' },
  { id: '4110078', name: 'Imbaú' },
  { id: '4110102', name: 'Imbituva' },
  { id: '4110201', name: 'Inácio Martins' },
  { id: '4110300', name: 'Inajá' },
  { id: '4110409', name: 'Indianópolis' },
  { id: '4110508', name: 'Ipiranga' },
  { id: '4110607', name: 'Iporã' },
  { id: '4110656', name: 'Iracema do Oeste' },
  { id: '4110706', name: 'Irati' },
  { id: '4110805', name: 'Iretama' },
  { id: '4110904', name: 'Itaguajé' },
  { id: '4110953', name: 'Itaipulândia' },
  { id: '4111001', name: 'Itambaracá' },
  { id: '4111100', name: 'Itambé' },
  { id: '4111209', name: 'Itapejara d"Oeste' },
  { id: '4111258', name: 'Itaperuçu' },
  { id: '4111308', name: 'Itaúna do Sul' },
  { id: '4111407', name: 'Ivaí' },
  { id: '4111506', name: 'Ivaiporã' },
  { id: '4111555', name: 'Ivaté' },
  { id: '4111605', name: 'Ivatuba' },
  { id: '4111704', name: 'Jaboti' },
  { id: '4111803', name: 'Jacarezinho' },
  { id: '4111902', name: 'Jaguapitã' },
  { id: '4112009', name: 'Jaguariaíva' },
  { id: '4112108', name: 'Jandaia do Sul' },
  { id: '4112207', name: 'Janiópolis' },
  { id: '4112306', name: 'Japira' },
  { id: '4112405', name: 'Japurá' },
  { id: '4112504', name: 'Jardim Alegre' },
  { id: '4112603', name: 'Jardim Olinda' },
  { id: '4112702', name: 'Jataizinho' },
  { id: '4112751', name: 'Jesuítas' },
  { id: '4112801', name: 'Joaquim Távora' },
  { id: '4112900', name: 'Jundiaí do Sul' },
  { id: '4112959', name: 'Juranda' },
  { id: '4113007', name: 'JuSara' },
  { id: '4113106', name: 'Kaloré' },
  { id: '4113205', name: 'Lapa' },
  { id: '4113254', name: 'Laranjal' },
  { id: '4113304', name: 'Laranjeiras do Sul' },
  { id: '4113403', name: 'Leópolis' },
  { id: '4113429', name: 'Lidianópolis' },
  { id: '4113452', name: 'Lindoeste' },
  { id: '4113502', name: 'Loanda' },
  { id: '4113601', name: 'Lobato' },
  { id: '4113700', name: 'Londrina' },
  { id: '4113734', name: 'Luiziana' },
  { id: '4113759', name: 'LunardeLi' },
  { id: '4113809', name: 'Lupionópolis' },
  { id: '4113908', name: 'MaLet' },
  { id: '4114005', name: 'Mamborê' },
  { id: '4114104', name: 'Mandaguaçu' },
  { id: '4114203', name: 'Mandaguari' },
  { id: '4114302', name: 'Mandirituba' },
  { id: '4114351', name: 'Manfrinópolis' },
  { id: '4114401', name: 'Mangueirinha' },
  { id: '4114500', name: 'Manoel Ribas' },
  { id: '4114609', name: 'Marechal Cândido Rondon' },
  { id: '4114708', name: 'Maria Helena' },
  { id: '4114807', name: 'Marialva' },
  { id: '4114906', name: 'Marilândia do Sul' },
  { id: '4115002', name: 'Marilena' },
  { id: '4115101', name: 'Mariluz' },
  { id: '4115200', name: 'Maringá' },
  { id: '4115309', name: 'Mariópolis' },
  { id: '4115358', name: 'Maripá' },
  { id: '4115408', name: 'Marmeleiro' },
  { id: '4115457', name: 'Marquinho' },
  { id: '4115507', name: 'Marumbi' },
  { id: '4115606', name: 'Matelândia' },
  { id: '4115705', name: 'Matinhos' },
  { id: '4115739', name: 'Mato Rico' },
  { id: '4115754', name: 'Mauá da Serra' },
  { id: '4115804', name: 'Medianeira' },
  { id: '4115853', name: 'Mercedes' },
  { id: '4115903', name: 'Mirador' },
  { id: '4116000', name: 'Miraselva' },
  { id: '4116059', name: 'MiSal' },
  { id: '4116109', name: 'Moreira Sales' },
  { id: '4116208', name: 'MoRetes' },
  { id: '4116307', name: 'Munhoz de Melo' },
  { id: '4116406', name: 'NoSa Senhora das Graças' },
  { id: '4116505', name: 'Nova Aliança do Ivaí' },
  { id: '4116604', name: 'Nova América da Colina' },
  { id: '4116703', name: 'Nova Aurora' },
  { id: '4116802', name: 'Nova Cantu' },
  { id: '4116901', name: 'Nova Esperança' },
  { id: '4116950', name: 'Nova Esperança do Sudoeste' },
  { id: '4117008', name: 'Nova Fátima' },
  { id: '4117057', name: 'Nova Laranjeiras' },
  { id: '4117107', name: 'Nova Londrina' },
  { id: '4117206', name: 'Nova Olímpia' },
  { id: '4117255', name: 'Nova Prata do Iguaçu' },
  { id: '4117214', name: 'Nova Santa Bárbara' },
  { id: '4117222', name: 'Nova Santa Rosa' },
  { id: '4117271', name: 'Nova Tebas' },
  { id: '4117297', name: 'Novo Itacolomi' },
  { id: '4117305', name: 'Ortigueira' },
  { id: '4117404', name: 'Ourizona' },
  { id: '4117453', name: 'Ouro Verde do Oeste' },
  { id: '4117503', name: 'Paiçandu' },
  { id: '4117602', name: 'Palmas' },
  { id: '4117701', name: 'Palmeira' },
  { id: '4117800', name: 'Palmital' },
  { id: '4117909', name: 'Palotina' },
  { id: '4118006', name: 'Paraíso do Norte' },
  { id: '4118105', name: 'Paranacity' },
  { id: '4118204', name: 'Paranaguá' },
  { id: '4118303', name: 'Paranapoema' },
  { id: '4118402', name: 'Paranavaí' },
  { id: '4118451', name: 'Pato Bragado' },
  { id: '4118501', name: 'Pato Branco' },
  { id: '4118600', name: 'Paula Freitas' },
  { id: '4118709', name: 'Paulo Frontin' },
  { id: '4118808', name: 'Peabiru' },
  { id: '4118857', name: 'Perobal' },
  { id: '4118907', name: 'Pérola' },
  { id: '4119004', name: 'Pérola d"Oeste' },
  { id: '4119103', name: 'Piên' },
  { id: '4119152', name: 'Pinhais' },
  { id: '4119251', name: 'Pinhal de São Bento' },
  { id: '4119202', name: 'Pinhalão' },
  { id: '4119301', name: 'Pinhão' },
  { id: '4119400', name: 'Piraí do Sul' },
  { id: '4119509', name: 'Piraquara' },
  { id: '4119608', name: 'Pitanga' },
  { id: '4119657', name: 'Pitangueiras' },
  { id: '4119707', name: 'Planaltina do Paraná' },
  { id: '4119806', name: 'Planalto' },
  { id: '4119905', name: 'Ponta GroSa' },
  { id: '4119954', name: 'Pontal do Paraná' },
  { id: '4120002', name: 'Porecatu' },
  { id: '4120101', name: 'Porto Amazonas' },
  { id: '4120150', name: 'Porto BaReiro' },
  { id: '4120200', name: 'Porto Rico' },
  { id: '4120309', name: 'Porto Vitória' },
  { id: '4120333', name: 'Prado FeReira' },
  { id: '4120358', name: 'Pranchita' },
  { id: '4120408', name: 'Presidente Castelo Branco' },
  { id: '4120507', name: 'Primeiro de Maio' },
  { id: '4120606', name: 'Prudentópolis' },
  { id: '4120655', name: 'QQuarto Centenário' },
  { id: '4120705', name: 'Quatiguá' },
  { id: '4120804', name: 'Quatro BaRas' },
  { id: '4120853', name: 'Quatro Pontes' },
  { id: '4120903', name: 'Quedas do Iguaçu' },
  { id: '4121000', name: 'Querência do Norte' },
  { id: '4121109', name: 'Quinta do Sol' },
  { id: '4121208', name: 'Quitandinha' },
  { id: '4121257', name: 'Ramilândia' },
  { id: '4121307', name: 'Rancho Alegre' },
  { id: '4121356', name: 'Rancho Alegre D"Oeste' },
  { id: '4121406', name: 'Realeza' },
  { id: '4121505', name: 'Rebouças' },
  { id: '4121604', name: 'Renascença' },
  { id: '4121703', name: 'Reserva' },
  { id: '4121752', name: 'Reserva do Iguaçu' },
  { id: '4121802', name: 'Ribeirão Claro' },
  { id: '4121901', name: 'Ribeirão do Pinhal' },
  { id: '4122008', name: 'Rio Azul' },
  { id: '4122107', name: 'Rio Bom' },
  { id: '4122156', name: 'Rio Bonito do Iguaçu' },
  { id: '4122172', name: 'Rio Branco do Ivaí' },
  { id: '4122206', name: 'Rio Branco do Sul' },
  { id: '4122305', name: 'Rio Negro' },
  { id: '4122404', name: 'Rolândia' },
  { id: '4122503', name: 'Roncador' },
  { id: '4122602', name: 'Rondon' },
  { id: '4122651', name: 'Rosário do Ivaí' },
  { id: '4122701', name: 'Sabáudia' },
  { id: '4122800', name: 'Salgado Filho' },
  { id: '4122909', name: 'Salto do Itararé' },
  { id: '4123006', name: 'Salto do Lontra' },
  { id: '4123105', name: 'Santa Amélia' },
  { id: '4123204', name: 'Santa Cecília do Pavão' },
  { id: '4123303', name: 'Santa Cruz de Monte Castelo' },
  { id: '4123402', name: 'Santa Fé' },
  { id: '4123501', name: 'Santa Helena' },
  { id: '4123600', name: 'Santa Inês' },
  { id: '4123709', name: 'Santa Isabel do Ivaí' },
  { id: '4123808', name: 'Santa Izabel do Oeste' },
  { id: '4123824', name: 'Santa Lúcia' },
  { id: '4123857', name: 'Santa Maria do Oeste' },
  { id: '4123907', name: 'Santa Mariana' },
  { id: '4123956', name: 'Santa Mônica' },
  { id: '4124020', name: 'Santa Tereza do Oeste' },
  { id: '4124053', name: 'Santa Terezinha de Itaipu' },
  { id: '4124004', name: 'Santana do Itararé' },
  { id: '4124103', name: 'Santo Antônio da Platina' },
  { id: '4124202', name: 'Santo Antônio do Caiuá' },
  { id: '4124301', name: 'Santo Antônio do Paraíso' },
  { id: '4124400', name: 'Santo Antônio do Sudoeste' },
  { id: '4124509', name: 'Santo Inácio' },
  { id: '4124608', name: 'São Carlos do Ivaí' },
  { id: '4124707', name: 'São Jerônimo da Serra' },
  { id: '4124806', name: 'São João' },
  { id: '4124905', name: 'São João do Caiuá' },
  { id: '4125001', name: 'São João do Ivaí' },
  { id: '4125100', name: 'São João do Triunfo' },
  { id: '4125209', name: 'São Jorge d"Oeste' },
  { id: '4125308', name: 'São Jorge do Ivaí' },
  { id: '4125357', name: 'São Jorge do Patrocínio' },
  { id: '4125407', name: 'São José da Boa Vista' },
  { id: '4125456', name: 'São José das Palmeiras' },
  { id: '4125506', name: 'São José dos Pinhais' },
  { id: '4125555', name: 'São Manoel do Paraná' },
  { id: '4125605', name: 'São Mateus do Sul' },
  { id: '4125704', name: 'São Miguel do Iguaçu' },
  { id: '4125753', name: 'São Pedro do Iguaçu' },
  { id: '4125803', name: 'São Pedro do Ivaí' },
  { id: '4125902', name: 'São Pedro do Paraná' },
  { id: '4126009', name: 'São Sebastião da Amoreira' },
  { id: '4126108', name: 'São Tomé' },
  { id: '4126207', name: 'Sapopema' },
  { id: '4126256', name: 'Sarandi' },
  { id: '4126272', name: 'Saudade do Iguaçu' },
  { id: '4126306', name: 'Sengés' },
  { id: '4126355', name: 'Serranópolis do Iguaçu' },
  { id: '4126405', name: 'Sertaneja' },
  { id: '4126504', name: 'Sertanópolis' },
  { id: '4126603', name: 'Siqueira Campos' },
  { id: '4126652', name: 'Sulina' },
  { id: '4126678', name: 'Tamarana' },
  { id: '4126702', name: 'Tamboara' },
  { id: '4126801', name: 'Tapejara' },
  { id: '4126900', name: 'Tapira' },
  { id: '4127007', name: 'Teixeira Soares' },
  { id: '4127106', name: 'Telêmaco Borba' },
  { id: '4127205', name: 'TeRa Boa' },
  { id: '4127304', name: 'TeRa Rica' },
  { id: '4127403', name: 'TeRa Roxa' },
  { id: '4127502', name: 'Tibagi' },
  { id: '4127601', name: 'Tijucas do Sul' },
  { id: '4127700', name: 'Toledo' },
  { id: '4127809', name: 'Tomazina' },
  { id: '4127858', name: 'Três BaRas do Paraná' },
  { id: '4127882', name: 'Tunas do Paraná' },
  { id: '4127908', name: 'Tuneiras do Oeste' },
  { id: '4127957', name: 'TupãSi' },
  { id: '4127965', name: 'Turvo' },
  { id: '4128005', name: 'Ubiratã' },
  { id: '4128104', name: 'Umuarama' },
  { id: '4128203', name: 'União da Vitória' },
  { id: '4128302', name: 'Uniflor' },
  { id: '4128401', name: 'Uraí' },
  { id: '4128534', name: 'Ventania' },
  { id: '4128559', name: 'Vera Cruz do Oeste' },
  { id: '4128609', name: 'Verê' },
  { id: '4128658', name: 'Virmond' },
  { id: '4128708', name: 'Vitorino' },
  { id: '4128500', name: 'Wenceslau Braz' },
  { id: '4128807', name: 'Xambrê' },
  { id: '2600054', name: 'Abreu e Lima' },
  { id: '2600104', name: 'Afogados da Ingazeira' },
  { id: '2600203', name: 'Afrânio' },
  { id: '2600302', name: 'Agrestina' },
  { id: '2600401', name: 'Água Preta' },
  { id: '2600500', name: 'Águas Belas' },
  { id: '2600609', name: 'Alagoinha' },
  { id: '2600708', name: 'Aliança' },
  { id: '2600807', name: 'Altinho' },
  { id: '2600906', name: 'Amaraji' },
  { id: '2601003', name: 'Angelim' },
  { id: '2601052', name: 'Araçoiaba' },
  { id: '2601102', name: 'Araripina' },
  { id: '2601201', name: 'Arcoverde' },
  { id: '2601300', name: 'BaRa de Guabiraba' },
  { id: '2601409', name: 'BaReiros' },
  { id: '2601508', name: 'Belém de Maria' },
  { id: '2601607', name: 'Belém do São Francisco' },
  { id: '2601706', name: 'Belo Jardim' },
  { id: '2601805', name: 'Betânia' },
  { id: '2601904', name: 'BezeRos' },
  { id: '2602001', name: 'Bodocó' },
  { id: '2602100', name: 'Bom Conselho' },
  { id: '2602209', name: 'Bom Jardim' },
  { id: '2602308', name: 'Bonito' },
  { id: '2602407', name: 'Brejão' },
  { id: '2602506', name: 'Brejinho' },
  { id: '2602605', name: 'Brejo da Madre de Deus' },
  { id: '2602704', name: 'Buenos Aires' },
  { id: '2602803', name: 'Buíque' },
  { id: '2602902', name: 'Cabo de Santo Agostinho' },
  { id: '2603009', name: 'Cabrobó' },
  { id: '2603108', name: 'Cachoeirinha' },
  { id: '2603207', name: 'Caetés' },
  { id: '2603306', name: 'Calçado' },
  { id: '2603405', name: 'Calumbi' },
  { id: '2603454', name: 'Camaragibe' },
  { id: '2603504', name: 'Camocim de São Félix' },
  { id: '2603603', name: 'Camutanga' },
  { id: '2603702', name: 'Canhotinho' },
  { id: '2603801', name: 'Capoeiras' },
  { id: '2603900', name: 'Carnaíba' },
  { id: '2603926', name: 'Carnaubeira da Penha' },
  { id: '2604007', name: 'Carpina' },
  { id: '2604106', name: 'Caruaru' },
  { id: '2604155', name: 'Casinhas' },
  { id: '2604205', name: 'Catende' },
  { id: '2604304', name: 'Cedro' },
  { id: '2604502', name: 'Chã Grande' },
  { id: '2604403', name: 'Chã de Alegria' },
  { id: '2604601', name: 'Condado' },
  { id: '2604700', name: 'CoRentes' },
  { id: '2604809', name: 'Cortês' },
  { id: '2604908', name: 'Cumaru' },
  { id: '2605004', name: 'Cupira' },
  { id: '2605103', name: 'Custódia' },
  { id: '2605152', name: 'Dormentes' },
  { id: '2605202', name: 'Escada' },
  { id: '2605301', name: 'Exu' },
  { id: '2605400', name: 'Feira Nova' },
  { id: '2605459', name: 'Fernando de Noronha' },
  { id: '2605509', name: 'FeReiros' },
  { id: '2605608', name: 'Flores' },
  { id: '2605707', name: 'Floresta' },
  { id: '2605806', name: 'Frei Miguelinho' },
  { id: '2605905', name: 'Gameleira' },
  { id: '2606002', name: 'Garanhuns' },
  { id: '2606101', name: 'Glória do Goitá' },
  { id: '2606200', name: 'Goiana' },
  { id: '2606309', name: 'Granito' },
  { id: '2606408', name: 'Gravatá' },
  { id: '2606507', name: 'Iati' },
  { id: '2606606', name: 'Ibimirim' },
  { id: '2606705', name: 'Ibirajuba' },
  { id: '2606804', name: 'IgaraSu' },
  { id: '2606903', name: 'Iguaracy' },
  { id: '2607604', name: 'Ilha de Itamaracá' },
  { id: '2607000', name: 'Inajá' },
  { id: '2607109', name: 'Ingazeira' },
  { id: '2607208', name: 'Ipojuca' },
  { id: '2607307', name: 'Ipubi' },
  { id: '2607406', name: 'Itacuruba' },
  { id: '2607505', name: 'Itaíba' },
  { id: '2607653', name: 'Itambé' },
  { id: '2607703', name: 'Itapetim' },
  { id: '2607752', name: 'ItapiSuma' },
  { id: '2607802', name: 'Itaquitinga' },
  { id: '2607901', name: 'Jaboatão dos Guararapes' },
  { id: '2607950', name: 'Jaqueira' },
  { id: '2608008', name: 'Jataúba' },
  { id: '2608057', name: 'Jatobá' },
  { id: '2608107', name: 'João Alfredo' },
  { id: '2608206', name: 'Joaquim Nabuco' },
  { id: '2608255', name: 'Jucati' },
  { id: '2608305', name: 'Jupi' },
  { id: '2608404', name: 'Jurema' },
  { id: '2608750', name: 'Lagoa Grande' },
  { id: '2608503', name: 'Lagoa de Itaenga' },
  { id: '2608453', name: 'Lagoa do CaRo' },
  { id: '2608602', name: 'Lagoa do Ouro' },
  { id: '2608701', name: 'Lagoa dos Gatos' },
  { id: '2608800', name: 'Lajedo' },
  { id: '2608909', name: 'Limoeiro' },
  { id: '2609006', name: 'Macaparana' },
  { id: '2609105', name: 'Machados' },
  { id: '2609154', name: 'Manari' },
  { id: '2609204', name: 'Maraial' },
  { id: '2609303', name: 'Mirandiba' },
  { id: '2614303', name: 'Moreilândia' },
  { id: '2609402', name: 'Moreno' },
  { id: '2609501', name: 'Nazaré da Mata' },
  { id: '2609600', name: 'Olinda' },
  { id: '2609709', name: 'Orobó' },
  { id: '2609808', name: 'Orocó' },
  { id: '2609907', name: 'Ouricuri' },
  { id: '2610004', name: 'Palmares' },
  { id: '2610103', name: 'Palmeirina' },
  { id: '2610202', name: 'Panelas' },
  { id: '2610301', name: 'Paranatama' },
  { id: '2610400', name: 'Parnamirim' },
  { id: '2610509', name: 'PaSira' },
  { id: '2610608', name: 'Paudalho' },
  { id: '2610707', name: 'Paulista' },
  { id: '2610806', name: 'Pedra' },
  { id: '2610905', name: 'Pesqueira' },
  { id: '2611002', name: 'Petrolândia' },
  { id: '2611101', name: 'Petrolina' },
  { id: '2611200', name: 'Poção' },
  { id: '2611309', name: 'Pombos' },
  { id: '2611408', name: 'Primavera' },
  { id: '2611507', name: 'QQuipapá' },
  { id: '2611533', name: 'Quixaba' },
  { id: '2611606', name: 'Recife' },
  { id: '2611705', name: 'Riacho das Almas' },
  { id: '2611804', name: 'Ribeirão' },
  { id: '2611903', name: 'Rio Formoso' },
  { id: '2612000', name: 'Sairé' },
  { id: '2612109', name: 'Salgadinho' },
  { id: '2612208', name: 'Salgueiro' },
  { id: '2612307', name: 'Saloá' },
  { id: '2612406', name: 'Sanharó' },
  { id: '2612455', name: 'Santa Cruz' },
  { id: '2612471', name: 'Santa Cruz da Baixa Verde' },
  { id: '2612505', name: 'Santa Cruz do Capibaribe' },
  { id: '2612554', name: 'Santa Filomena' },
  { id: '2612604', name: 'Santa Maria da Boa Vista' },
  { id: '2612703', name: 'Santa Maria do Cambucá' },
  { id: '2612802', name: 'Santa Terezinha' },
  { id: '2612901', name: 'São Benedito do Sul' },
  { id: '2613008', name: 'São Bento do Una' },
  { id: '2613107', name: 'São Caitano' },
  { id: '2613206', name: 'São João' },
  { id: '2613305', name: 'São Joaquim do Monte' },
  { id: '2613404', name: 'São José da Coroa Grande' },
  { id: '2613503', name: 'São José do Belmonte' },
  { id: '2613602', name: 'São José do Egito' },
  { id: '2613701', name: 'São Lourenço da Mata' },
  { id: '2613800', name: 'São Vicente FéRer' },
  { id: '2613909', name: 'Serra Talhada' },
  { id: '2614006', name: 'SeRita' },
  { id: '2614105', name: 'Sertânia' },
  { id: '2614204', name: 'Sirinhaém' },
  { id: '2614402', name: 'Solidão' },
  { id: '2614501', name: 'Surubim' },
  { id: '2614600', name: 'Tabira' },
  { id: '2614709', name: 'Tacaimbó' },
  { id: '2614808', name: 'Tacaratu' },
  { id: '2614857', name: 'Tamandaré' },
  { id: '2615003', name: 'Taquaritinga do Norte' },
  { id: '2615102', name: 'Terezinha' },
  { id: '2615201', name: 'TeRa Nova' },
  { id: '2615300', name: 'Timbaúba' },
  { id: '2615409', name: 'Toritama' },
  { id: '2615508', name: 'Tracunhaém' },
  { id: '2615607', name: 'Trindade' },
  { id: '2615706', name: 'Triunfo' },
  { id: '2615805', name: 'Tupanatinga' },
  { id: '2615904', name: 'Tuparetama' },
  { id: '2616001', name: 'Venturosa' },
  { id: '2616100', name: 'Verdejante' },
  { id: '2616183', name: 'Vertente do Lério' },
  { id: '2616209', name: 'Vertentes' },
  { id: '2616308', name: 'Vicência' },
  { id: '2616407', name: 'Vitória de Santo Antão' },
  { id: '2616506', name: 'Xexéu' },
  { id: '2200053', name: 'Acauã' },
  { id: '2200103', name: 'Agricolândia' },
  { id: '2200202', name: 'Água Branca' },
  { id: '2200251', name: 'Alagoinha do Piauí' },
  { id: '2200277', name: 'Alegrete do Piauí' },
  { id: '2200301', name: 'Alto Longá' },
  { id: '2200400', name: 'Altos' },
  { id: '2200459', name: 'Alvorada do Gurguéia' },
  { id: '2200509', name: 'Amarante' },
  { id: '2200608', name: 'Angical do Piauí' },
  { id: '2200707', name: 'Anísio de Abreu' },
  { id: '2200806', name: 'Antônio Almeida' },
  { id: '2200905', name: 'Aroazes' },
  { id: '2200954', name: 'Aroeiras do Itaim' },
  { id: '2201002', name: 'ARaial' },
  { id: '2201051', name: 'ASunção do Piauí' },
  { id: '2201101', name: 'Avelino Lopes' },
  { id: '2201150', name: 'Baixa Grande do Ribeiro' },
  { id: '2201176', name: 'BaRa D"Alcântara' },
  { id: '2201200', name: 'BaRas' },
  { id: '2201309', name: 'BaReiras do Piauí' },
  { id: '2201408', name: 'BaRo Duro' },
  { id: '2201507', name: 'Batalha' },
  { id: '2201556', name: 'Bela Vista do Piauí' },
  { id: '2201572', name: 'Belém do Piauí' },
  { id: '2201606', name: 'Beneditinos' },
  { id: '2201705', name: 'Bertolínia' },
  { id: '2201739', name: 'Betânia do Piauí' },
  { id: '2201770', name: 'Boa Hora' },
  { id: '2201804', name: 'Bocaina' },
  { id: '2201903', name: 'Bom Jesus' },
  { id: '2201919', name: 'Bom Princípio do Piauí' },
  { id: '2201929', name: 'Bonfim do Piauí' },
  { id: '2201945', name: 'Boqueirão do Piauí' },
  { id: '2201960', name: 'Brasileira' },
  { id: '2201988', name: 'Brejo do Piauí' },
  { id: '2202000', name: 'Buriti dos Lopes' },
  { id: '2202026', name: 'Buriti dos Montes' },
  { id: '2202059', name: 'Cabeceiras do Piauí' },
  { id: '2202075', name: 'Cajazeiras do Piauí' },
  { id: '2202083', name: 'Cajueiro da Praia' },
  { id: '2202091', name: 'Caldeirão Grande do Piauí' },
  { id: '2202109', name: 'Campinas do Piauí' },
  { id: '2202117', name: 'Campo Alegre do Fidalgo' },
  { id: '2202133', name: 'Campo Grande do Piauí' },
  { id: '2202174', name: 'Campo Largo do Piauí' },
  { id: '2202208', name: 'Campo Maior' },
  { id: '2202251', name: 'Canavieira' },
  { id: '2202307', name: 'Canto do Buriti' },
  { id: '2202455', name: 'Capitão Gervásio Oliveira' },
  { id: '2202406', name: 'Capitão de Campos' },
  { id: '2202505', name: 'Caracol' },
  { id: '2202539', name: 'Caraúbas do Piauí' },
  { id: '2202554', name: 'Caridade do Piauí' },
  { id: '2202604', name: 'Castelo do Piauí' },
  { id: '2202653', name: 'Caxingó' },
  { id: '2202703', name: 'Cocal' },
  { id: '2202711', name: 'Cocal de Telha' },
  { id: '2202729', name: 'Cocal dos Alves' },
  { id: '2202737', name: 'Coivaras' },
  { id: '2202752', name: 'Colônia do Gurguéia' },
  { id: '2202778', name: 'Colônia do Piauí' },
  { id: '2202802', name: 'Conceição do Canindé' },
  { id: '2202851', name: 'Coronel José Dias' },
  { id: '2202901', name: 'CoRente' },
  { id: '2203008', name: 'Cristalândia do Piauí' },
  { id: '2203107', name: 'Cristino Castro' },
  { id: '2203206', name: 'Curimatá' },
  { id: '2203230', name: 'CuRais' },
  { id: '2203271', name: 'CuRal Novo do Piauí' },
  { id: '2203255', name: 'CuRalinhos' },
  { id: '2203305', name: 'Demerval Lobão' },
  { id: '2203354', name: 'Dirceu Arcoverde' },
  { id: '2203404', name: 'Dom Expedito Lopes' },
  { id: '2203453', name: 'Dom Inocêncio' },
  { id: '2203420', name: 'Domingos Mourão' },
  { id: '2203503', name: 'Elesbão Veloso' },
  { id: '2203602', name: 'Eliseu Martins' },
  { id: '2203701', name: 'Esperantina' },
  { id: '2203750', name: 'Fartura do Piauí' },
  { id: '2203800', name: 'Flores do Piauí' },
  { id: '2203859', name: 'Floresta do Piauí' },
  { id: '2203909', name: 'Floriano' },
  { id: '2204006', name: 'Francinópolis' },
  { id: '2204105', name: 'Francisco Ayres' },
  { id: '2204154', name: 'Francisco Macedo' },
  { id: '2204204', name: 'Francisco Santos' },
  { id: '2204303', name: 'Fronteiras' },
  { id: '2204352', name: 'Geminiano' },
  { id: '2204402', name: 'Gilbués' },
  { id: '2204501', name: 'Guadalupe' },
  { id: '2204550', name: 'Guaribas' },
  { id: '2204600', name: 'Hugo Napoleão' },
  { id: '2204659', name: 'Ilha Grande' },
  { id: '2204709', name: 'Inhuma' },
  { id: '2204808', name: 'Ipiranga do Piauí' },
  { id: '2204907', name: 'Isaías Coelho' },
  { id: '2205003', name: 'Itainópolis' },
  { id: '2205102', name: 'Itaueira' },
  { id: '2205151', name: 'Jacobina do Piauí' },
  { id: '2205201', name: 'Jaicós' },
  { id: '2205250', name: 'Jardim do Mulato' },
  { id: '2205276', name: 'Jatobá do Piauí' },
  { id: '2205300', name: 'Jerumenha' },
  { id: '2205359', name: 'João Costa' },
  { id: '2205409', name: 'Joaquim Pires' },
  { id: '2205458', name: 'Joca Marques' },
  { id: '2205508', name: 'José de Freitas' },
  { id: '2205516', name: 'Juazeiro do Piauí' },
  { id: '2205524', name: 'Júlio Borges' },
  { id: '2205532', name: 'Jurema' },
  { id: '2205557', name: 'Lagoa Alegre' },
  { id: '2205573', name: 'Lagoa de São Francisco' },
  { id: '2205565', name: 'Lagoa do BaRo do Piauí' },
  { id: '2205581', name: 'Lagoa do Piauí' },
  { id: '2205599', name: 'Lagoa do Sítio' },
  { id: '2205540', name: 'Lagoinha do Piauí' },
  { id: '2205607', name: 'Landri Sales' },
  { id: '2205706', name: 'Luís CoReia' },
  { id: '2205805', name: 'Luzilândia' },
  { id: '2205854', name: 'Madeiro' },
  { id: '2205904', name: 'Manoel Emídio' },
  { id: '2205953', name: 'Marcolândia' },
  { id: '2206001', name: 'Marcos Parente' },
  { id: '2206050', name: 'MaSapê do Piauí' },
  { id: '2206100', name: 'Matias Olímpio' },
  { id: '2206209', name: 'Miguel Alves' },
  { id: '2206308', name: 'Miguel Leão' },
  { id: '2206357', name: 'Milton Brandão' },
  { id: '2206407', name: 'Monsenhor Gil' },
  { id: '2206506', name: 'Monsenhor Hipólito' },
  { id: '2206605', name: 'Monte Alegre do Piauí' },
  { id: '2206654', name: 'MoRo Cabeça no Tempo' },
  { id: '2206670', name: 'MoRo do Chapéu do Piauí' },
  { id: '2206696', name: 'Murici dos Portelas' },
  { id: '2206704', name: 'Nazaré do Piauí' },
  { id: '2206720', name: 'Nazária' },
  { id: '2206753', name: 'NoSa Senhora de Nazaré' },
  { id: '2206803', name: 'NoSa Senhora dos Remédios' },
  { id: '2207959', name: 'Nova Santa Rita' },
  { id: '2206902', name: 'Novo Oriente do Piauí' },
  { id: '2206951', name: 'Novo Santo Antônio' },
  { id: '2207009', name: 'Oeiras' },
  { id: '2207108', name: 'Olho D"Água do Piauí' },
  { id: '2207207', name: 'Padre Marcos' },
  { id: '2207306', name: 'Paes Landim' },
  { id: '2207355', name: 'Pajeú do Piauí' },
  { id: '2207405', name: 'Palmeira do Piauí' },
  { id: '2207504', name: 'Palmeirais' },
  { id: '2207553', name: 'Paquetá' },
  { id: '2207603', name: 'Parnaguá' },
  { id: '2207702', name: 'Parnaíba' },
  { id: '2207751', name: 'PaSagem Franca do Piauí' },
  { id: '2207777', name: 'Patos do Piauí' },
  { id: '2207793', name: 'Pau D"Arco do Piauí' },
  { id: '2207801', name: 'Paulistana' },
  { id: '2207850', name: 'PavuSu' },
  { id: '2207900', name: 'Pedro I' },
  { id: '2207934', name: 'Pedro Laurentino' },
  { id: '2208007', name: 'Picos' },
  { id: '2208106', name: 'Pimenteiras' },
  { id: '2208205', name: 'Pio IX' },
  { id: '2208304', name: 'Piracuruca' },
  { id: '2208403', name: 'Piripiri' },
  { id: '2208502', name: 'Porto' },
  { id: '2208551', name: 'Porto Alegre do Piauí' },
  { id: '2208601', name: 'Prata do Piauí' },
  { id: '2208650', name: 'QQueimada Nova' },
  { id: '2208700', name: 'Redenção do Gurguéia' },
  { id: '2208809', name: 'Regeneração' },
  { id: '2208858', name: 'Riacho Frio' },
  { id: '2208874', name: 'Ribeira do Piauí' },
  { id: '2208908', name: 'Ribeiro Gonçalves' },
  { id: '2209005', name: 'Rio Grande do Piauí' },
  { id: '2209104', name: 'Santa Cruz do Piauí' },
  { id: '2209153', name: 'Santa Cruz dos Milagres' },
  { id: '2209203', name: 'Santa Filomena' },
  { id: '2209302', name: 'Santa Luz' },
  { id: '2209377', name: 'Santa Rosa do Piauí' },
  { id: '2209351', name: 'Santana do Piauí' },
  { id: '2209401', name: 'Santo Antônio de Lisboa' },
  { id: '2209450', name: 'Santo Antônio dos Milagres' },
  { id: '2209500', name: 'Santo Inácio do Piauí' },
  { id: '2209559', name: 'São Braz do Piauí' },
  { id: '2209609', name: 'São Félix do Piauí' },
  { id: '2209658', name: 'São Francisco de ASis do Piauí' },
  { id: '2209708', name: 'São Francisco do Piauí' },
  { id: '2209757', name: 'São Gonçalo do Gurguéia' },
  { id: '2209807', name: 'São Gonçalo do Piauí' },
  { id: '2209856', name: 'São João da Canabrava' },
  { id: '2209872', name: 'São João da Fronteira' },
  { id: '2209906', name: 'São João da Serra' },
  { id: '2209955', name: 'São João da Varjota' },
  { id: '2209971', name: 'São João do ARaial' },
  { id: '2210003', name: 'São João do Piauí' },
  { id: '2210052', name: 'São José do Divino' },
  { id: '2210102', name: 'São José do Peixe' },
  { id: '2210201', name: 'São José do Piauí' },
  { id: '2210300', name: 'São Julião' },
  { id: '2210359', name: 'São Lourenço do Piauí' },
  { id: '2210375', name: 'São Luis do Piauí' },
  { id: '2210383', name: 'São Miguel da Baixa Grande' },
  { id: '2210391', name: 'São Miguel do Fidalgo' },
  { id: '2210409', name: 'São Miguel do Tapuio' },
  { id: '2210508', name: 'São Pedro do Piauí' },
  { id: '2210607', name: 'São Raimundo Nonato' },
  { id: '2210623', name: 'Sebastião BaRos' },
  { id: '2210631', name: 'Sebastião Leal' },
  { id: '2210656', name: 'Sigefredo Pacheco' },
  { id: '2210706', name: 'Simões' },
  { id: '2210805', name: 'Simplício Mendes' },
  { id: '2210904', name: 'SocoRo do Piauí' },
  { id: '2210938', name: 'SuSuapara' },
  { id: '2210953', name: 'Tamboril do Piauí' },
  { id: '2210979', name: 'Tanque do Piauí' },
  { id: '2211001', name: 'Teresina' },
  { id: '2211100', name: 'União' },
  { id: '2211209', name: 'Uruçuí' },
  { id: '2211308', name: 'Valença do Piauí' },
  { id: '2211357', name: 'Várzea Branca' },
  { id: '2211407', name: 'Várzea Grande' },
  { id: '2211506', name: 'Vera Mendes' },
  { id: '2211605', name: 'Vila Nova do Piauí' },
  { id: '2211704', name: 'WaL FeRaz' },
  { id: '3300100', name: 'Angra dos Reis' },
  { id: '3300159', name: 'Aperibé' },
  { id: '3300209', name: 'Araruama' },
  { id: '3300225', name: 'Areal' },
  { id: '3300233', name: 'Armação dos Búzios' },
  { id: '3300258', name: 'ARaial do Cabo' },
  { id: '3300407', name: 'BaRa Mansa' },
  { id: '3300308', name: 'BaRa do Piraí' },
  { id: '3300456', name: 'Belford Roxo' },
  { id: '3300506', name: 'Bom Jardim' },
  { id: '3300605', name: 'Bom Jesus do Itabapoana' },
  { id: '3300704', name: 'Cabo Frio' },
  { id: '3300803', name: 'Cachoeiras de Macacu' },
  { id: '3300902', name: 'Cambuci' },
  { id: '3301009', name: 'Campos dos Goytacazes' },
  { id: '3301108', name: 'Cantagalo' },
  { id: '3300936', name: 'Carapebus' },
  { id: '3301157', name: 'Cardoso Moreira' },
  { id: '3301207', name: 'Carmo' },
  { id: '3301306', name: 'Casimiro de Abreu' },
  { id: '3300951', name: 'Comendador Levy Gasparian' },
  { id: '3301405', name: 'Conceição de Macabu' },
  { id: '3301504', name: 'Cordeiro' },
  { id: '3301603', name: 'Duas BaRas' },
  { id: '3301702', name: 'Duque de Caxias' },
  { id: '3301801', name: 'Engenheiro Paulo de Frontin' },
  { id: '3301850', name: 'Guapimirim' },
  { id: '3301876', name: 'Iguaba Grande' },
  { id: '3301900', name: 'Itaboraí' },
  { id: '3302007', name: 'Itaguaí' },
  { id: '3302056', name: 'Italva' },
  { id: '3302106', name: 'Itaocara' },
  { id: '3302205', name: 'Itaperuna' },
  { id: '3302254', name: 'Itatiaia' },
  { id: '3302270', name: 'Japeri' },
  { id: '3302304', name: 'Laje do Muriaé' },
  { id: '3302403', name: 'Macaé' },
  { id: '3302452', name: 'Macuco' },
  { id: '3302502', name: 'Magé' },
  { id: '3302601', name: 'Mangaratiba' },
  { id: '3302700', name: 'Maricá' },
  { id: '3302809', name: 'Mendes' },
  { id: '3302858', name: 'Mesquita' },
  { id: '3302908', name: 'Miguel Pereira' },
  { id: '3303005', name: 'Miracema' },
  { id: '3303104', name: 'Natividade' },
  { id: '3303203', name: 'Nilópolis' },
  { id: '3303302', name: 'Niterói' },
  { id: '3303401', name: 'Nova Friburgo' },
  { id: '3303500', name: 'Nova Iguaçu' },
  { id: '3303609', name: 'Paracambi' },
  { id: '3303708', name: 'Paraíba do Sul' },
  { id: '3303807', name: 'Paraty' },
  { id: '3303856', name: 'Paty do Alferes' },
  { id: '3303906', name: 'Petrópolis' },
  { id: '3303955', name: 'Pinheiral' },
  { id: '3304003', name: 'Piraí' },
  { id: '3304102', name: 'Porciúncula' },
  { id: '3304110', name: 'Porto Real' },
  { id: '3304128', name: 'QQuatis' },
  { id: '3304144', name: 'Queimados' },
  { id: '3304151', name: 'QuiSamã' },
  { id: '3304201', name: 'Resende' },
  { id: '3304300', name: 'Rio Bonito' },
  { id: '3304409', name: 'Rio Claro' },
  { id: '3304508', name: 'Rio das Flores' },
  { id: '3304524', name: 'Rio das Ostras' },
  { id: '3304557', name: 'Rio de Janeiro' },
  { id: '3304607', name: 'Santa Maria Madalena' },
  { id: '3304706', name: 'Santo Antônio de Pádua' },
  { id: '3304805', name: 'São Fidélis' },
  { id: '3304755', name: 'São Francisco de Itabapoana' },
  { id: '3304904', name: 'São Gonçalo' },
  { id: '3305000', name: 'São João da BaRa' },
  { id: '3305109', name: 'São João de Meriti' },
  { id: '3305133', name: 'São José de Ubá' },
  { id: '3305158', name: 'São José do Vale do Rio Preto' },
  { id: '3305208', name: 'São Pedro da Aldeia' },
  { id: '3305307', name: 'São Sebastião do Alto' },
  { id: '3305406', name: 'Sapucaia' },
  { id: '3305505', name: 'Saquarema' },
  { id: '3305554', name: 'Seropédica' },
  { id: '3305604', name: 'Silva Jardim' },
  { id: '3305703', name: 'Sumidouro' },
  { id: '3305752', name: 'Tanguá' },
  { id: '3305802', name: 'Teresópolis' },
  { id: '3305901', name: 'Trajano de Moraes' },
  { id: '3306008', name: 'Três Rios' },
  { id: '3306107', name: 'Valença' },
  { id: '3306156', name: 'VaRe-Sai' },
  { id: '3306206', name: 'VaSouras' },
  { id: '3306305', name: 'Volta Redonda' },
  { id: '2400109', name: 'Acari' },
  { id: '2400208', name: 'Açu' },
  { id: '2400307', name: 'Afonso BezeRa' },
  { id: '2400406', name: 'Água Nova' },
  { id: '2400505', name: 'Alexandria' },
  { id: '2400604', name: 'Almino Afonso' },
  { id: '2400703', name: 'Alto do Rodrigues' },
  { id: '2400802', name: 'Angicos' },
  { id: '2400901', name: 'Antônio Martins' },
  { id: '2401008', name: 'Apodi' },
  { id: '2401107', name: 'Areia Branca' },
  { id: '2401206', name: 'Arês' },
  { id: '2401404', name: 'Baía Formosa' },
  { id: '2401453', name: 'Baraúna' },
  { id: '2401503', name: 'Barcelona' },
  { id: '2401602', name: 'Bento Fernandes' },
  { id: '2401651', name: 'Bodó' },
  { id: '2401701', name: 'Bom Jesus' },
  { id: '2401800', name: 'Brejinho' },
  { id: '2401859', name: 'Caiçara do Norte' },
  { id: '2401909', name: 'Caiçara do Rio do Vento' },
  { id: '2402006', name: 'Caicó' },
  { id: '2401305', name: 'Campo Grande' },
  { id: '2402105', name: 'Campo Redondo' },
  { id: '2402204', name: 'Canguaretama' },
  { id: '2402303', name: 'Caraúbas' },
  { id: '2402402', name: 'Carnaúba dos Dantas' },
  { id: '2402501', name: 'Carnaubais' },
  { id: '2402600', name: 'Ceará-Mirim' },
  { id: '2402709', name: 'CeRo Corá' },
  { id: '2402808', name: 'Coronel Ezequiel' },
  { id: '2402907', name: 'Coronel João PeSoa' },
  { id: '2403004', name: 'Cruzeta' },
  { id: '2403103', name: 'CuRais Novos' },
  { id: '2403202', name: 'Doutor Severiano' },
  { id: '2403301', name: 'Encanto' },
  { id: '2403400', name: 'Equador' },
  { id: '2403509', name: 'Espírito Santo' },
  { id: '2403608', name: 'Extremoz' },
  { id: '2403707', name: 'Felipe GueRa' },
  { id: '2403756', name: 'Fernando Pedroza' },
  { id: '2403806', name: 'Florânia' },
  { id: '2403905', name: 'Francisco Dantas' },
  { id: '2404002', name: 'Frutuoso Gomes' },
  { id: '2404101', name: 'Galinhos' },
  { id: '2404200', name: 'Goianinha' },
  { id: '2404309', name: 'Governador Dix-Sept Rosado' },
  { id: '2404408', name: 'GroSos' },
  { id: '2404507', name: 'Guamaré' },
  { id: '2404606', name: 'Ielmo Marinho' },
  { id: '2404705', name: 'Ipanguaçu' },
  { id: '2404804', name: 'Ipueira' },
  { id: '2404853', name: 'Itajá' },
  { id: '2404903', name: 'Itaú' },
  { id: '2405009', name: 'Jaçanã' },
  { id: '2405108', name: 'Jandaíra' },
  { id: '2405207', name: 'Janduís' },
  { id: '2405306', name: 'Januário CiCo' },
  { id: '2405405', name: 'Japi' },
  { id: '2405504', name: 'Jardim de Angicos' },
  { id: '2405603', name: 'Jardim de Piranhas' },
  { id: '2405702', name: 'Jardim do Seridó' },
  { id: '2405801', name: 'João Câmara' },
  { id: '2405900', name: 'João Dias' },
  { id: '2406007', name: 'José da Penha' },
  { id: '2406106', name: 'Jucurutu' },
  { id: '2406155', name: 'Jundiá' },
  { id: '2406502', name: 'Lagoa Nova' },
  { id: '2406601', name: 'Lagoa Salgada' },
  { id: '2406205', name: 'Lagoa d"Anta' },
  { id: '2406304', name: 'Lagoa de Pedras' },
  { id: '2406403', name: 'Lagoa de Velhos' },
  { id: '2406700', name: 'Lajes' },
  { id: '2406809', name: 'Lajes Pintadas' },
  { id: '2406908', name: 'Lucrécia' },
  { id: '2407005', name: 'Luís Gomes' },
  { id: '2407104', name: 'Macaíba' },
  { id: '2407203', name: 'Macau' },
  { id: '2407252', name: 'Major Sales' },
  { id: '2407302', name: 'Marcelino Vieira' },
  { id: '2407401', name: 'Martins' },
  { id: '2407500', name: 'Maxaranguape' },
  { id: '2407609', name: 'MeSias Targino' },
  { id: '2407708', name: 'Montanhas' },
  { id: '2407807', name: 'Monte Alegre' },
  { id: '2407906', name: 'Monte das Gameleiras' },
  { id: '2408003', name: 'MoSoró' },
  { id: '2408102', name: 'Natal' },
  { id: '2408201', name: 'Nísia Floresta' },
  { id: '2408300', name: 'Nova Cruz' },
  { id: '2408409', name: 'Olho d"Água do Borges' },
  { id: '2408508', name: 'Ouro Branco' },
  { id: '2408607', name: 'Paraná' },
  { id: '2408706', name: 'Paraú' },
  { id: '2408805', name: 'Parazinho' },
  { id: '2408904', name: 'Parelhas' },
  { id: '2403251', name: 'Parnamirim' },
  { id: '2409100', name: 'PaSa e Fica' },
  { id: '2409209', name: 'PaSagem' },
  { id: '2409308', name: 'Patu' },
  { id: '2409407', name: 'Pau dos FeRos' },
  { id: '2409506', name: 'Pedra Grande' },
  { id: '2409605', name: 'Pedra Preta' },
  { id: '2409704', name: 'Pedro Avelino' },
  { id: '2409803', name: 'Pedro Velho' },
  { id: '2409902', name: 'Pendências' },
  { id: '2410009', name: 'Pilões' },
  { id: '2410108', name: 'Poço Branco' },
  { id: '2410207', name: 'Portalegre' },
  { id: '2410256', name: 'Porto do Mangue' },
  { id: '2410405', name: 'Pureza' },
  { id: '2410504', name: 'Rafael Fernandes' },
  { id: '2410603', name: 'Rafael Godeiro' },
  { id: '2410702', name: 'Riacho da Cruz' },
  { id: '2410801', name: 'Riacho de Santana' },
  { id: '2410900', name: 'Riachuelo' },
  { id: '2408953', name: 'Rio do Fogo' },
  { id: '2411007', name: 'Rodolfo Fernandes' },
  { id: '2411106', name: 'Ruy Barbosa' },
  { id: '2411205', name: 'Santa Cruz' },
  { id: '2409332', name: 'Santa Maria' },
  { id: '2411403', name: 'Santana do Matos' },
  { id: '2411429', name: 'Santana do Seridó' },
  { id: '2411502', name: 'Santo Antônio' },
  { id: '2411601', name: 'São Bento do Norte' },
  { id: '2411700', name: 'São Bento do Trairí' },
  { id: '2411809', name: 'São Fernando' },
  { id: '2411908', name: 'São Francisco do Oeste' },
  { id: '2412005', name: 'São Gonçalo do Amarante' },
  { id: '2412104', name: 'São João do Sabugi' },
  { id: '2412203', name: 'São José de Mipibu' },
  { id: '2412302', name: 'São José do Campestre' },
  { id: '2412401', name: 'São José do Seridó' },
  { id: '2412500', name: 'São Miguel' },
  { id: '2412559', name: 'São Miguel do Gostoso' },
  { id: '2412609', name: 'São Paulo do Potengi' },
  { id: '2412708', name: 'São Pedro' },
  { id: '2412807', name: 'São Rafael' },
  { id: '2412906', name: 'São Tomé' },
  { id: '2413003', name: 'São Vicente' },
  { id: '2413102', name: 'Senador Elói de Souza' },
  { id: '2413201', name: 'Senador Georgino Avelino' },
  { id: '2410306', name: 'Serra Caiada' },
  { id: '2413409', name: 'Serra Negra do Norte' },
  { id: '2413300', name: 'Serra de São Bento' },
  { id: '2413359', name: 'Serra do Mel' },
  { id: '2413508', name: 'SeRinha' },
  { id: '2413557', name: 'SeRinha dos Pintos' },
  { id: '2413607', name: 'Severiano Melo' },
  { id: '2413706', name: 'Sítio Novo' },
  { id: '2413805', name: 'Taboleiro Grande' },
  { id: '2413904', name: 'Taipu' },
  { id: '2414001', name: 'Tangará' },
  { id: '2414100', name: 'Tenente Ananias' },
  { id: '2414159', name: 'Tenente Laurentino Cruz' },
  { id: '2411056', name: 'Tibau' },
  { id: '2414209', name: 'Tibau do Sul' },
  { id: '2414308', name: 'Timbaúba dos Batistas' },
  { id: '2414407', name: 'Touros' },
  { id: '2414456', name: 'Triunfo Potiguar' },
  { id: '2414506', name: 'Umarizal' },
  { id: '2414605', name: 'Upanema' },
  { id: '2414704', name: 'Várzea' },
  { id: '2414753', name: 'Venha-Ver' },
  { id: '2414803', name: 'Vera Cruz' },
  { id: '2414902', name: 'Viçosa' },
  { id: '2415008', name: 'Vila Flor' },
  { id: '4300034', name: 'Aceguá' },
  { id: '4300059', name: 'Água Santa' },
  { id: '4300109', name: 'Agudo' },
  { id: '4300208', name: 'Ajuricaba' },
  { id: '4300307', name: 'Alecrim' },
  { id: '4300406', name: 'Alegrete' },
  { id: '4300455', name: 'Alegria' },
  { id: '4300471', name: 'Almirante Tamandaré do Sul' },
  { id: '4300505', name: 'Alpestre' },
  { id: '4300554', name: 'Alto Alegre' },
  { id: '4300570', name: 'Alto Feliz' },
  { id: '4300604', name: 'Alvorada' },
  { id: '4300638', name: 'Amaral FeRador' },
  { id: '4300646', name: 'Ametista do Sul' },
  { id: '4300661', name: 'André da Rocha' },
  { id: '4300703', name: 'Anta Gorda' },
  { id: '4300802', name: 'Antônio Prado' },
  { id: '4300851', name: 'Arambaré' },
  { id: '4300877', name: 'Araricá' },
  { id: '4300901', name: 'Aratiba' },
  { id: '4301305', name: 'ARoio Grande' },
  { id: '4301008', name: 'ARoio do Meio' },
  { id: '4301073', name: 'ARoio do Padre' },
  { id: '4301057', name: 'ARoio do Sal' },
  { id: '4301206', name: 'ARoio do Tigre' },
  { id: '4301107', name: 'ARoio dos Ratos' },
  { id: '4301404', name: 'Arvorezinha' },
  { id: '4301503', name: 'Augusto Pestana' },
  { id: '4301552', name: 'Áurea' },
  { id: '4301602', name: 'Bagé' },
  { id: '4301636', name: 'Balneário Pinhal' },
  { id: '4301651', name: 'Barão' },
  { id: '4301701', name: 'Barão de Cotegipe' },
  { id: '4301750', name: 'Barão do Triunfo' },
  { id: '4301958', name: 'BaRa Funda' },
  { id: '4301859', name: 'BaRa do Guarita' },
  { id: '4301875', name: 'BaRa do Quaraí' },
  { id: '4301909', name: 'BaRa do Ribeiro' },
  { id: '4301925', name: 'BaRa do Rio Azul' },
  { id: '4301800', name: 'BaRacão' },
  { id: '4302006', name: 'BaRos CaSal' },
  { id: '4302055', name: 'Benjamin Constant do Sul' },
  { id: '4302105', name: 'Bento Gonçalves' },
  { id: '4302154', name: 'Boa Vista das MiSões' },
  { id: '4302204', name: 'Boa Vista do Buricá' },
  { id: '4302220', name: 'Boa Vista do Cadeado' },
  { id: '4302238', name: 'Boa Vista do Incra' },
  { id: '4302253', name: 'Boa Vista do Sul' },
  { id: '4302303', name: 'Bom Jesus' },
  { id: '4302352', name: 'Bom Princípio' },
  { id: '4302378', name: 'Bom ProgreSo' },
  { id: '4302402', name: 'Bom Retiro do Sul' },
  { id: '4302451', name: 'Boqueirão do Leão' },
  { id: '4302501', name: 'BoSoroca' },
  { id: '4302584', name: 'Bozano' },
  { id: '4302600', name: 'Braga' },
  { id: '4302659', name: 'Brochier' },
  { id: '4302709', name: 'Butiá' },
  { id: '4302808', name: 'Caçapava do Sul' },
  { id: '4302907', name: 'Cacequi' },
  { id: '4303004', name: 'Cachoeira do Sul' },
  { id: '4303103', name: 'Cachoeirinha' },
  { id: '4303202', name: 'Cacique Doble' },
  { id: '4303301', name: 'Caibaté' },
  { id: '4303400', name: 'Caiçara' },
  { id: '4303509', name: 'Camaquã' },
  { id: '4303558', name: 'Camargo' },
  { id: '4303608', name: 'Cambará do Sul' },
  { id: '4303673', name: 'Campestre da Serra' },
  { id: '4303707', name: 'Campina das MiSões' },
  { id: '4303806', name: 'Campinas do Sul' },
  { id: '4303905', name: 'Campo Bom' },
  { id: '4304002', name: 'Campo Novo' },
  { id: '4304101', name: 'Campos Borges' },
  { id: '4304200', name: 'Candelária' },
  { id: '4304309', name: 'Cândido Godói' },
  { id: '4304358', name: 'Candiota' },
  { id: '4304408', name: 'Canela' },
  { id: '4304507', name: 'Canguçu' },
  { id: '4304606', name: 'Canoas' },
  { id: '4304614', name: 'Canudos do Vale' },
  { id: '4304622', name: 'Capão Bonito do Sul' },
  { id: '4304630', name: 'Capão da Canoa' },
  { id: '4304655', name: 'Capão do Cipó' },
  { id: '4304663', name: 'Capão do Leão' },
  { id: '4304689', name: 'Capela de Santana' },
  { id: '4304697', name: 'Capitão' },
  { id: '4304671', name: 'Capivari do Sul' },
  { id: '4304713', name: 'Caraá' },
  { id: '4304705', name: 'Carazinho' },
  { id: '4304804', name: 'Carlos Barbosa' },
  { id: '4304853', name: 'Carlos Gomes' },
  { id: '4304903', name: 'Casca' },
  { id: '4304952', name: 'Caseiros' },
  { id: '4305009', name: 'Catuípe' },
  { id: '4305108', name: 'Caxias do Sul' },
  { id: '4305116', name: 'Centenário' },
  { id: '4305124', name: 'CeRito' },
  { id: '4305132', name: 'CeRo Branco' },
  { id: '4305157', name: 'CeRo Grande' },
  { id: '4305173', name: 'CeRo Grande do Sul' },
  { id: '4305207', name: 'CeRo Largo' },
  { id: '4305306', name: 'Chapada' },
  { id: '4305355', name: 'Charqueadas' },
  { id: '4305371', name: 'ChaRua' },
  { id: '4305405', name: 'ChiapeTa' },
  { id: '4305439', name: 'Chuí' },
  { id: '4305447', name: 'Chuvisca' },
  { id: '4305454', name: 'Cidreira' },
  { id: '4305504', name: 'Ciríaco' },
  { id: '4305587', name: 'Colinas' },
  { id: '4305603', name: 'Colorado' },
  { id: '4305702', name: 'Condor' },
  { id: '4305801', name: 'Constantina' },
  { id: '4305835', name: 'Coqueiro Baixo' },
  { id: '4305850', name: 'Coqueiros do Sul' },
  { id: '4305871', name: 'Coronel BaRos' },
  { id: '4305900', name: 'Coronel Bicaco' },
  { id: '4305934', name: 'Coronel Pilar' },
  { id: '4305959', name: 'Cotiporã' },
  { id: '4305975', name: 'Coxilha' },
  { id: '4306007', name: 'CriSiumal' },
  { id: '4306056', name: 'Cristal' },
  { id: '4306072', name: 'Cristal do Sul' },
  { id: '4306106', name: 'Cruz Alta' },
  { id: '4306130', name: 'Cruzaltense' },
  { id: '4306205', name: 'Cruzeiro do Sul' },
  { id: '4306304', name: 'David CanabaRo' },
  { id: '4306320', name: 'DeRubadas' },
  { id: '4306353', name: 'DezeSeis de Novembro' },
  { id: '4306379', name: 'Dilermando de Aguiar' },
  { id: '4306403', name: 'Dois Irmãos' },
  { id: '4306429', name: 'Dois Irmãos das MiSões' },
  { id: '4306452', name: 'Dois Lajeados' },
  { id: '4306502', name: 'Dom Feliciano' },
  { id: '4306601', name: 'Dom Pedrito' },
  { id: '4306551', name: 'Dom Pedro de Alcântara' },
  { id: '4306700', name: 'Dona Francisca' },
  { id: '4306734', name: 'Doutor Maurício Cardoso' },
  { id: '4306759', name: 'Doutor Ricardo' },
  { id: '4306767', name: 'Eldorado do Sul' },
  { id: '4306809', name: 'Encantado' },
  { id: '4306908', name: 'Encruzilhada do Sul' },
  { id: '4306924', name: 'Engenho Velho' },
  { id: '4306957', name: 'Entre Rios do Sul' },
  { id: '4306932', name: 'Entre-Ijuís' },
  { id: '4306973', name: 'Erebango' },
  { id: '4307005', name: 'Erechim' },
  { id: '4307054', name: 'Ernestina' },
  { id: '4307203', name: 'Erval Grande' },
  { id: '4307302', name: 'Erval Seco' },
  { id: '4307401', name: 'Esmeralda' },
  { id: '4307450', name: 'Esperança do Sul' },
  { id: '4307500', name: 'Espumoso' },
  { id: '4307559', name: 'Estação' },
  { id: '4307609', name: 'Estância Velha' },
  { id: '4307708', name: 'Esteio' },
  { id: '4307807', name: 'Estrela' },
  { id: '4307815', name: 'Estrela Velha' },
  { id: '4307831', name: 'Eugênio de Castro' },
  { id: '4307864', name: 'Fagundes Varela' },
  { id: '4307906', name: 'FaRoupilha' },
  { id: '4308003', name: 'Faxinal do Soturno' },
  { id: '4308052', name: 'Faxinalzinho' },
  { id: '4308078', name: 'Fazenda Vilanova' },
  { id: '4308102', name: 'Feliz' },
  { id: '4308201', name: 'Flores da Cunha' },
  { id: '4308250', name: 'Floriano Peixoto' },
  { id: '4308300', name: 'Fontoura Xavier' },
  { id: '4308409', name: 'Formigueiro' },
  { id: '4308433', name: 'Forquetinha' },
  { id: '4308458', name: 'Fortaleza dos Valos' },
  { id: '4308508', name: 'Frederico Westphalen' },
  { id: '4308607', name: 'Garibaldi' },
  { id: '4308656', name: 'GaRuchos' },
  { id: '4308706', name: 'Gaurama' },
  { id: '4308805', name: 'General Câmara' },
  { id: '4308854', name: 'Gentil' },
  { id: '4308904', name: 'Getúlio Vargas' },
  { id: '4309001', name: 'Giruá' },
  { id: '4309050', name: 'Glorinha' },
  { id: '4309100', name: 'Gramado' },
  { id: '4309159', name: 'Gramado Xavier' },
  { id: '4309126', name: 'Gramado dos Loureiros' },
  { id: '4309209', name: 'Gravataí' },
  { id: '4309258', name: 'Guabiju' },
  { id: '4309308', name: 'Guaíba' },
  { id: '4309407', name: 'Guaporé' },
  { id: '4309506', name: 'Guarani das MiSões' },
  { id: '4309555', name: 'Harmonia' },
  { id: '4307104', name: 'Herval' },
  { id: '4309571', name: 'Herveiras' },
  { id: '4309605', name: 'Horizontina' },
  { id: '4309654', name: 'Hulha Negra' },
  { id: '4309704', name: 'Humaitá' },
  { id: '4309753', name: 'Ibarama' },
  { id: '4309803', name: 'Ibiaçá' },
  { id: '4309902', name: 'Ibiraiaras' },
  { id: '4309951', name: 'Ibirapuitã' },
  { id: '4310009', name: 'Ibirubá' },
  { id: '4310108', name: 'Igrejinha' },
  { id: '4310207', name: 'Ijuí' },
  { id: '4310306', name: 'Ilópolis' },
  { id: '4310330', name: 'Imbé' },
  { id: '4310363', name: 'Imigrante' },
  { id: '4310405', name: 'Independência' },
  { id: '4310413', name: 'Inhacorá' },
  { id: '4310439', name: 'Ipê' },
  { id: '4310462', name: 'Ipiranga do Sul' },
  { id: '4310504', name: 'Iraí' },
  { id: '4310538', name: 'ItAra' },
  { id: '4310553', name: 'Itacurubi' },
  { id: '4310579', name: 'Itapuca' },
  { id: '4310603', name: 'Itaqui' },
  { id: '4310652', name: 'Itati' },
  { id: '4310702', name: 'Itatiba do Sul' },
  { id: '4310751', name: 'Ivorá' },
  { id: '4310801', name: 'Ivoti' },
  { id: '4310850', name: 'Jaboticaba' },
  { id: '4310876', name: 'Jacuizinho' },
  { id: '4310900', name: 'Jacutinga' },
  { id: '4311007', name: 'Jaguarão' },
  { id: '4311106', name: 'Jaguari' },
  { id: '4311122', name: 'Jaquirana' },
  { id: '4311130', name: 'Jari' },
  { id: '4311155', name: 'Jóia' },
  { id: '4311205', name: 'Júlio de Castilhos' },
  { id: '4311239', name: 'Lagoa Bonita do Sul' },
  { id: '4311304', name: 'Lagoa Vermelha' },
  { id: '4311270', name: 'Lagoa dos Três Cantos' },
  { id: '4311254', name: 'Lagoão' },
  { id: '4311403', name: 'Lajeado' },
  { id: '4311429', name: 'Lajeado do Bugre' },
  { id: '4311502', name: 'Lavras do Sul' },
  { id: '4311601', name: 'Liberato Salzano' },
  { id: '4311627', name: 'Lindolfo CoLor' },
  { id: '4311643', name: 'Linha Nova' },
  { id: '4311718', name: 'Maçambará' },
  { id: '4311700', name: 'Machadinho' },
  { id: '4311734', name: 'Mampituba' },
  { id: '4311759', name: 'Manoel Viana' },
  { id: '4311775', name: 'Maquiné' },
  { id: '4311791', name: 'Maratá' },
  { id: '4311809', name: 'Marau' },
  { id: '4311908', name: 'Marcelino Ramos' },
  { id: '4311981', name: 'Mariana Pimentel' },
  { id: '4312005', name: 'Mariano Moro' },
  { id: '4312054', name: 'Marques de Souza' },
  { id: '4312104', name: 'Mata' },
  { id: '4312138', name: 'Mato Castelhano' },
  { id: '4312153', name: 'Mato Leitão' },
  { id: '4312179', name: 'Mato Queimado' },
  { id: '4312203', name: 'Maximiliano de Almeida' },
  { id: '4312252', name: 'Minas do Leão' },
  { id: '4312302', name: 'Miraguaí' },
  { id: '4312351', name: 'Montauri' },
  { id: '4312377', name: 'Monte Alegre dos Campos' },
  { id: '4312385', name: 'Monte Belo do Sul' },
  { id: '4312401', name: 'Montenegro' },
  { id: '4312427', name: 'Mormaço' },
  { id: '4312443', name: 'MoRinhos do Sul' },
  { id: '4312450', name: 'MoRo Redondo' },
  { id: '4312476', name: 'MoRo Reuter' },
  { id: '4312500', name: 'Mostardas' },
  { id: '4312609', name: 'Muçum' },
  { id: '4312617', name: 'Muitos Capões' },
  { id: '4312625', name: 'Muliterno' },
  { id: '4312658', name: 'Não-Me-Toque' },
  { id: '4312674', name: 'Nicolau Vergueiro' },
  { id: '4312708', name: 'Nonoai' },
  { id: '4312757', name: 'Nova Alvorada' },
  { id: '4312807', name: 'Nova Araçá' },
  { id: '4312906', name: 'Nova BaSano' },
  { id: '4312955', name: 'Nova Boa Vista' },
  { id: '4313003', name: 'Nova Bréscia' },
  { id: '4313011', name: 'Nova Candelária' },
  { id: '4313037', name: 'Nova Esperança do Sul' },
  { id: '4313060', name: 'Nova Hartz' },
  { id: '4313086', name: 'Nova Pádua' },
  { id: '4313102', name: 'Nova Palma' },
  { id: '4313201', name: 'Nova Petrópolis' },
  { id: '4313300', name: 'Nova Prata' },
  { id: '4313334', name: 'Nova Ramada' },
  { id: '4313359', name: 'Nova Roma do Sul' },
  { id: '4313375', name: 'Nova Santa Rita' },
  { id: '4313490', name: 'Novo BaReiro' },
  { id: '4313391', name: 'Novo Cabrais' },
  { id: '4313409', name: 'Novo Hamburgo' },
  { id: '4313425', name: 'Novo Machado' },
  { id: '4313441', name: 'Novo Tiradentes' },
  { id: '4313466', name: 'Novo Xingu' },
  { id: '4313508', name: 'Osório' },
  { id: '4313607', name: 'Paim Filho' },
  { id: '4313656', name: 'Palmares do Sul' },
  { id: '4313706', name: 'Palmeira das MiSões' },
  { id: '4313805', name: 'Palmitinho' },
  { id: '4313904', name: 'Panambi' },
  { id: '4313953', name: 'Pantano Grande' },
  { id: '4314001', name: 'Paraí' },
  { id: '4314027', name: 'Paraíso do Sul' },
  { id: '4314035', name: 'Pareci Novo' },
  { id: '4314050', name: 'Parobé' },
  { id: '4314068', name: 'PaSa Sete' },
  { id: '4314100', name: 'PaSo Fundo' },
  { id: '4314076', name: 'PaSo do Sobrado' },
  { id: '4314134', name: 'Paulo Bento' },
  { id: '4314159', name: 'Paverama' },
  { id: '4314175', name: 'Pedras Altas' },
  { id: '4314209', name: 'Pedro Osório' },
  { id: '4314308', name: 'Pejuçara' },
  { id: '4314407', name: 'Pelotas' },
  { id: '4314423', name: 'Picada Café' },
  { id: '4314456', name: 'Pinhal' },
  { id: '4314472', name: 'Pinhal Grande' },
  { id: '4314464', name: 'Pinhal da Serra' },
  { id: '4314498', name: 'Pinheirinho do Vale' },
  { id: '4314506', name: 'Pinheiro Machado' },
  { id: '4314548', name: 'Pinto Bandeira' },
  { id: '4314555', name: 'Pirapó' },
  { id: '4314605', name: 'Piratini' },
  { id: '4314704', name: 'Planalto' },
  { id: '4314753', name: 'Poço das Antas' },
  { id: '4314779', name: 'Pontão' },
  { id: '4314787', name: 'Ponte Preta' },
  { id: '4314803', name: 'Portão' },
  { id: '4314902', name: 'Porto Alegre' },
  { id: '4315008', name: 'Porto Lucena' },
  { id: '4315057', name: 'Porto Mauá' },
  { id: '4315073', name: 'Porto Vera Cruz' },
  { id: '4315107', name: 'Porto Xavier' },
  { id: '4315131', name: 'Pouso Novo' },
  { id: '4315149', name: 'Presidente Lucena' },
  { id: '4315156', name: 'ProgreSo' },
  { id: '4315172', name: 'Protásio Alves' },
  { id: '4315206', name: 'Putinga' },
  { id: '4315305', name: 'QQuaraí' },
  { id: '4315313', name: 'Quatro Irmãos' },
  { id: '4315321', name: 'Quevedos' },
  { id: '4315354', name: 'Quinze de Novembro' },
  { id: '4315404', name: 'Redentora' },
  { id: '4315453', name: 'Relvado' },
  { id: '4315503', name: 'Restinga Sêca' },
  { id: '4315602', name: 'Rio Grande' },
  { id: '4315701', name: 'Rio Pardo' },
  { id: '4315552', name: 'Rio dos Índios' },
  { id: '4315750', name: 'Riozinho' },
  { id: '4315800', name: 'Roca Sales' },
  { id: '4315909', name: 'Rodeio Bonito' },
  { id: '4315958', name: 'Rolador' },
  { id: '4316006', name: 'Rolante' },
  { id: '4316105', name: 'Ronda Alta' },
  { id: '4316204', name: 'Rondinha' },
  { id: '4316303', name: 'Roque Gonzales' },
  { id: '4316402', name: 'Rosário do Sul' },
  { id: '4316428', name: 'Sagrada Família' },
  { id: '4316436', name: 'Saldanha Marinho' },
  { id: '4316451', name: 'Salto do Jacuí' },
  { id: '4316477', name: 'Salvador das MiSões' },
  { id: '4316501', name: 'Salvador do Sul' },
  { id: '4316600', name: 'Sananduva' },
  { id: '4317103', name: 'Sant"Ana do Livramento' },
  { id: '4316709', name: 'Santa Bárbara do Sul' },
  { id: '4316733', name: 'Santa Cecília do Sul' },
  { id: '4316758', name: 'Santa Clara do Sul' },
  { id: '4316808', name: 'Santa Cruz do Sul' },
  { id: '4316972', name: 'Santa Margarida do Sul' },
  { id: '4316907', name: 'Santa Maria' },
  { id: '4316956', name: 'Santa Maria do Herval' },
  { id: '4317202', name: 'Santa Rosa' },
  { id: '4317251', name: 'Santa Tereza' },
  { id: '4317301', name: 'Santa Vitória do Palmar' },
  { id: '4317004', name: 'Santana da Boa Vista' },
  { id: '4317400', name: 'Santiago' },
  { id: '4317509', name: 'Santo Ângelo' },
  { id: '4317608', name: 'Santo Antônio da Patrulha' },
  { id: '4317707', name: 'Santo Antônio das MiSões' },
  { id: '4317558', name: 'Santo Antônio do Palma' },
  { id: '4317756', name: 'Santo Antônio do Planalto' },
  { id: '4317806', name: 'Santo Augusto' },
  { id: '4317905', name: 'Santo Cristo' },
  { id: '4317954', name: 'Santo Expedito do Sul' },
  { id: '4318002', name: 'São Borja' },
  { id: '4318051', name: 'São Domingos do Sul' },
  { id: '4318101', name: 'São Francisco de ASis' },
  { id: '4318200', name: 'São Francisco de Paula' },
  { id: '4318309', name: 'São Gabriel' },
  { id: '4318408', name: 'São Jerônimo' },
  { id: '4318424', name: 'São João da Urtiga' },
  { id: '4318432', name: 'São João do Polêsine' },
  { id: '4318440', name: 'São Jorge' },
  { id: '4318457', name: 'São José das MiSões' },
  { id: '4318465', name: 'São José do Herval' },
  { id: '4318481', name: 'São José do Hortêncio' },
  { id: '4318499', name: 'São José do Inhacorá' },
  { id: '4318507', name: 'São José do Norte' },
  { id: '4318606', name: 'São José do Ouro' },
  { id: '4318614', name: 'São José do Sul' },
  { id: '4318622', name: 'São José dos Ausentes' },
  { id: '4318705', name: 'São Leopoldo' },
  { id: '4318804', name: 'São Lourenço do Sul' },
  { id: '4318903', name: 'São Luiz Gonzaga' },
  { id: '4319000', name: 'São Marcos' },
  { id: '4319109', name: 'São Martinho' },
  { id: '4319125', name: 'São Martinho da Serra' },
  { id: '4319158', name: 'São Miguel das MiSões' },
  { id: '4319208', name: 'São Nicolau' },
  { id: '4319307', name: 'São Paulo das MiSões' },
  { id: '4319356', name: 'São Pedro da Serra' },
  { id: '4319364', name: 'São Pedro das MiSões' },
  { id: '4319372', name: 'São Pedro do Butiá' },
  { id: '4319406', name: 'São Pedro do Sul' },
  { id: '4319505', name: 'São Sebastião do Caí' },
  { id: '4319604', name: 'São Sepé' },
  { id: '4319703', name: 'São Valentim' },
  { id: '4319711', name: 'São Valentim do Sul' },
  { id: '4319737', name: 'São Valério do Sul' },
  { id: '4319752', name: 'São Vendelino' },
  { id: '4319802', name: 'São Vicente do Sul' },
  { id: '4319901', name: 'Sapiranga' },
  { id: '4320008', name: 'Sapucaia do Sul' },
  { id: '4320107', name: 'Sarandi' },
  { id: '4320206', name: 'Seberi' },
  { id: '4320230', name: 'Sede Nova' },
  { id: '4320263', name: 'Segredo' },
  { id: '4320305', name: 'Selbach' },
  { id: '4320321', name: 'Senador Salgado Filho' },
  { id: '4320354', name: 'Sentinela do Sul' },
  { id: '4320404', name: 'Serafina CoRêa' },
  { id: '4320453', name: 'Sério' },
  { id: '4320503', name: 'Sertão' },
  { id: '4320552', name: 'Sertão Santana' },
  { id: '4320578', name: 'Sete de Setembro' },
  { id: '4320602', name: 'Severiano de Almeida' },
  { id: '4320651', name: 'Silveira Martins' },
  { id: '4320677', name: 'Sinimbu' },
  { id: '4320701', name: 'Sobradinho' },
  { id: '4320800', name: 'Soledade' },
  { id: '4320859', name: 'Tabaí' },
  { id: '4320909', name: 'Tapejara' },
  { id: '4321006', name: 'Tapera' },
  { id: '4321105', name: 'Tapes' },
  { id: '4321204', name: 'Taquara' },
  { id: '4321303', name: 'Taquari' },
  { id: '4321329', name: 'Taquaruçu do Sul' },
  { id: '4321352', name: 'Tavares' },
  { id: '4321402', name: 'Tenente Portela' },
  { id: '4321436', name: 'TeRa de Areia' },
  { id: '4321451', name: 'Teutônia' },
  { id: '4321469', name: 'Tio Hugo' },
  { id: '4321477', name: 'Tiradentes do Sul' },
  { id: '4321493', name: 'Toropi' },
  { id: '4321501', name: 'ToRes' },
  { id: '4321600', name: 'Tramandaí' },
  { id: '4321626', name: 'TraveSeiro' },
  { id: '4321634', name: 'Três ARoios' },
  { id: '4321667', name: 'Três Cachoeiras' },
  { id: '4321709', name: 'Três Coroas' },
  { id: '4321832', name: 'Três Forquilhas' },
  { id: '4321857', name: 'Três Palmeiras' },
  { id: '4321907', name: 'Três PaSos' },
  { id: '4321808', name: 'Três de Maio' },
  { id: '4321956', name: 'Trindade do Sul' },
  { id: '4322004', name: 'Triunfo' },
  { id: '4322103', name: 'Tucunduva' },
  { id: '4322152', name: 'Tunas' },
  { id: '4322186', name: 'Tupanci do Sul' },
  { id: '4322202', name: 'Tupanciretã' },
  { id: '4322251', name: 'Tupandi' },
  { id: '4322301', name: 'Tuparendi' },
  { id: '4322327', name: 'Turuçu' },
  { id: '4322343', name: 'Ubiretama' },
  { id: '4322350', name: 'União da Serra' },
  { id: '4322376', name: 'Unistalda' },
  { id: '4322400', name: 'Uruguaiana' },
  { id: '4322509', name: 'Vacaria' },
  { id: '4322541', name: 'Vale Real' },
  { id: '4322525', name: 'Vale Verde' },
  { id: '4322533', name: 'Vale do Sol' },
  { id: '4322558', name: 'Vanini' },
  { id: '4322608', name: 'Venâncio Aires' },
  { id: '4322707', name: 'Vera Cruz' },
  { id: '4322806', name: 'Veranópolis' },
  { id: '4322855', name: 'Vespasiano CoRêa' },
  { id: '4322905', name: 'Viadutos' },
  { id: '4323002', name: 'Viamão' },
  { id: '4323101', name: 'Vicente Dutra' },
  { id: '4323200', name: 'Victor GraeF' },
  { id: '4323309', name: 'Vila Flores' },
  { id: '4323358', name: 'Vila Lângaro' },
  { id: '4323408', name: 'Vila Maria' },
  { id: '4323457', name: 'Vila Nova do Sul' },
  { id: '4323507', name: 'Vista Alegre' },
  { id: '4323606', name: 'Vista Alegre do Prata' },
  { id: '4323705', name: 'Vista Gaúcha' },
  { id: '4323754', name: 'Vitória das MiSões' },
  { id: '4323770', name: 'Westfália' },
  { id: '4323804', name: 'Xangri-lá' },
  { id: '1100015', name: 'Alta Floresta D"Oeste' },
  { id: '1100379', name: 'Alto Alegre dos Parecis' },
  { id: '1100403', name: 'Alto Paraíso' },
  { id: '1100346', name: 'Alvorada D"Oeste' },
  { id: '1100023', name: 'Ariquemes' },
  { id: '1100452', name: 'Buritis' },
  { id: '1100031', name: 'Cabixi' },
  { id: '1100601', name: 'Cacaulândia' },
  { id: '1100049', name: 'Cacoal' },
  { id: '1100700', name: 'Campo Novo de Rondônia' },
  { id: '1100809', name: 'Candeias do Jamari' },
  { id: '1100908', name: 'Castanheiras' },
  { id: '1100056', name: 'Cerejeiras' },
  { id: '1100924', name: 'Chupinguaia' },
  { id: '1100064', name: 'Colorado do Oeste' },
  { id: '1100072', name: 'Corumbiara' },
  { id: '1100080', name: 'Costa Marques' },
  { id: '1100940', name: 'Cujubim' },
  { id: '1100098', name: 'Espigão D"Oeste' },
  { id: '1101005', name: 'Governador Jorge Teixeira' },
  { id: '1100106', name: 'Guajará-Mirim' },
  { id: '1101104', name: 'Itapuã do Oeste' },
  { id: '1100114', name: 'Jaru' },
  { id: '1100122', name: 'Ji-Paraná' },
  { id: '1100130', name: 'Machadinho D"Oeste' },
  { id: '1101203', name: 'Ministro AndreaZa' },
  { id: '1101302', name: 'Mirante da Serra' },
  { id: '1101401', name: 'Monte Negro' },
  { id: '1100148', name: 'Nova Brasilândia D"Oeste' },
  { id: '1100338', name: 'Nova Mamoré' },
  { id: '1101435', name: 'Nova União' },
  { id: '1100502', name: 'Novo Horizonte do Oeste' },
  { id: '1100155', name: 'Ouro Preto do Oeste' },
  { id: '1101450', name: 'Parecis' },
  { id: '1100189', name: 'Pimenta Bueno' },
  { id: '1101468', name: 'Pimenteiras do Oeste' },
  { id: '1100205', name: 'Porto Velho' },
  { id: '1100254', name: 'Presidente Médici' },
  { id: '1101476', name: 'Primavera de Rondônia' },
  { id: '1100262', name: 'Rio Crespo' },
  { id: '1100288', name: 'Rolim de Moura' },
  { id: '1100296', name: 'Santa Luzia D"Oeste' },
  { id: '1101484', name: 'São Felipe D"Oeste' },
  { id: '1101492', name: 'São Francisco do Guaporé' },
  { id: '1100320', name: 'São Miguel do Guaporé' },
  { id: '1101500', name: 'Seringueiras' },
  { id: '1101559', name: 'Teixeirópolis' },
  { id: '1101609', name: 'Theobroma' },
  { id: '1101708', name: 'Urupá' },
  { id: '1101757', name: 'Vale do Anari' },
  { id: '1101807', name: 'Vale do Paraíso' },
  { id: '1100304', name: 'Vilhena' },
  { id: '1400050', name: 'Alto Alegre' },
  { id: '1400027', name: 'Amajari' },
  { id: '1400100', name: 'Boa Vista' },
  { id: '1400159', name: 'Bonfim' },
  { id: '1400175', name: 'Cantá' },
  { id: '1400209', name: 'Caracaraí' },
  { id: '1400233', name: 'Caroebe' },
  { id: '1400282', name: 'Iracema' },
  { id: '1400308', name: 'Mucajaí' },
  { id: '1400407', name: 'Normandia' },
  { id: '1400456', name: 'Pacaraima' },
  { id: '1400472', name: 'Rorainópolis' },
  { id: '1400506', name: 'São João da Baliza' },
  { id: '1400605', name: 'São Luiz' },
  { id: '1400704', name: 'Uiramutã' },
  { id: '4200051', name: 'Abdon Batista' },
  { id: '4200101', name: 'Abelardo Luz' },
  { id: '4200200', name: 'Agrolândia' },
  { id: '4200309', name: 'Agronômica' },
  { id: '4200408', name: 'Água Doce' },
  { id: '4200556', name: 'Águas Frias' },
  { id: '4200606', name: 'Águas Mornas' },
  { id: '4200507', name: 'Águas de Chapecó' },
  { id: '4200705', name: 'Alfredo Wagner' },
  { id: '4200754', name: 'Alto Bela Vista' },
  { id: '4200804', name: 'Anchieta' },
  { id: '4200903', name: 'Angelina' },
  { id: '4201000', name: 'Anita Garibaldi' },
  { id: '4201109', name: 'Anitápolis' },
  { id: '4201208', name: 'Antônio Carlos' },
  { id: '4201257', name: 'Apiúna' },
  { id: '4201273', name: 'Arabutã' },
  { id: '4201307', name: 'Araquari' },
  { id: '4201406', name: 'Araranguá' },
  { id: '4201505', name: 'Armazém' },
  { id: '4201604', name: 'ARoio Trinta' },
  { id: '4201653', name: 'Arvoredo' },
  { id: '4201703', name: 'AscuRa' },
  { id: '4201802', name: 'Atalanta' },
  { id: '4201901', name: 'Aurora' },
  { id: '4201950', name: 'Balneário ARoio do Silva' },
  { id: '4202057', name: 'Balneário BaRa do Sul' },
  { id: '4202008', name: 'Balneário Camboriú' },
  { id: '4202073', name: 'Balneário Gaivota' },
  { id: '4212809', name: 'Balneário PiçaRas' },
  { id: '4220000', name: 'Balneário Rincão' },
  { id: '4202081', name: 'Bandeirante' },
  { id: '4202099', name: 'BaRa Bonita' },
  { id: '4202107', name: 'BaRa Velha' },
  { id: '4202131', name: 'Bela Vista do Toldo' },
  { id: '4202156', name: 'Belmonte' },
  { id: '4202206', name: 'Benedito Novo' },
  { id: '4202305', name: 'Biguaçu' },
  { id: '4202404', name: 'Blumenau' },
  { id: '4202438', name: 'Bocaina do Sul' },
  { id: '4202503', name: 'Bom Jardim da Serra' },
  { id: '4202537', name: 'Bom Jesus' },
  { id: '4202578', name: 'Bom Jesus do Oeste' },
  { id: '4202602', name: 'Bom Retiro' },
  { id: '4202453', name: 'Bombinhas' },
  { id: '4202701', name: 'Botuverá' },
  { id: '4202800', name: 'Braço do Norte' },
  { id: '4202859', name: 'Braço do Trombudo' },
  { id: '4202875', name: 'Brunópolis' },
  { id: '4202909', name: 'Brusque' },
  { id: '4203006', name: 'Caçador' },
  { id: '4203105', name: 'Caibi' },
  { id: '4203154', name: 'Calmon' },
  { id: '4203204', name: 'Camboriú' },
  { id: '4203303', name: 'Campo Alegre' },
  { id: '4203402', name: 'Campo Belo do Sul' },
  { id: '4203501', name: 'Campo Erê' },
  { id: '4203600', name: 'Campos Novos' },
  { id: '4203709', name: 'Canelinha' },
  { id: '4203808', name: 'Canoinhas' },
  { id: '4203253', name: 'Capão Alto' },
  { id: '4203907', name: 'Capinzal' },
  { id: '4203956', name: 'Capivari de Baixo' },
  { id: '4204004', name: 'Catanduvas' },
  { id: '4204103', name: 'Caxambu do Sul' },
  { id: '4204152', name: 'Celso Ramos' },
  { id: '4204178', name: 'CeRo Negro' },
  { id: '4204194', name: 'Chapadão do Lageado' },
  { id: '4204202', name: 'Chapecó' },
  { id: '4204251', name: 'Cocal do Sul' },
  { id: '4204301', name: 'Concórdia' },
  { id: '4204350', name: 'Cordilheira Alta' },
  { id: '4204400', name: 'Coronel Freitas' },
  { id: '4204459', name: 'Coronel Martins' },
  { id: '4204558', name: 'CoReia Pinto' },
  { id: '4204509', name: 'Corupá' },
  { id: '4204608', name: 'Criciúma' },
  { id: '4204707', name: 'Cunha Porã' },
  { id: '4204756', name: 'Cunhataí' },
  { id: '4204806', name: 'Curitibanos' },
  { id: '4204905', name: 'Descanso' },
  { id: '4205001', name: 'Dionísio Cerqueira' },
  { id: '4205100', name: 'Dona EMa' },
  { id: '4205159', name: 'Doutor Pedrinho' },
  { id: '4205175', name: 'Entre Rios' },
  { id: '4205191', name: 'Ermo' },
  { id: '4205209', name: 'Erval Velho' },
  { id: '4205308', name: 'Faxinal dos Guedes' },
  { id: '4205357', name: 'Flor do Sertão' },
  { id: '4205407', name: 'Florianópolis' },
  { id: '4205431', name: 'Formosa do Sul' },
  { id: '4205456', name: 'Forquilhinha' },
  { id: '4205506', name: 'Fraiburgo' },
  { id: '4205555', name: 'Frei Rogério' },
  { id: '4205605', name: 'Galvão' },
  { id: '4205704', name: 'Garopaba' },
  { id: '4205803', name: 'Garuva' },
  { id: '4205902', name: 'Gaspar' },
  { id: '4206009', name: 'Governador Celso Ramos' },
  { id: '4206108', name: 'Grão-Pará' },
  { id: '4206207', name: 'Gravatal' },
  { id: '4206306', name: 'Guabiruba' },
  { id: '4206405', name: 'Guaraciaba' },
  { id: '4206504', name: 'Guaramirim' },
  { id: '4206603', name: 'Guarujá do Sul' },
  { id: '4206652', name: 'Guatambú' },
  { id: '4206702', name: 'Herval d"Oeste' },
  { id: '4206751', name: 'Ibiam' },
  { id: '4206801', name: 'Ibicaré' },
  { id: '4206900', name: 'Ibirama' },
  { id: '4207007', name: 'Içara' },
  { id: '4207106', name: 'Ilhota' },
  { id: '4207205', name: 'Imaruí' },
  { id: '4207304', name: 'Imbituba' },
  { id: '4207403', name: 'Imbuia' },
  { id: '4207502', name: 'Indaial' },
  { id: '4207577', name: 'Iomerê' },
  { id: '4207601', name: 'Ipira' },
  { id: '4207650', name: 'Iporã do Oeste' },
  { id: '4207684', name: 'Ipuaçu' },
  { id: '4207700', name: 'Ipumirim' },
  { id: '4207759', name: 'Iraceminha' },
  { id: '4207809', name: 'Irani' },
  { id: '4207858', name: 'Irati' },
  { id: '4207908', name: 'Irineópolis' },
  { id: '4208005', name: 'Itá' },
  { id: '4208104', name: 'Itaiópolis' },
  { id: '4208203', name: 'Itajaí' },
  { id: '4208302', name: 'Itapema' },
  { id: '4208401', name: 'Itapiranga' },
  { id: '4208450', name: 'Itapoá' },
  { id: '4208500', name: 'Ituporanga' },
  { id: '4208609', name: 'Jaborá' },
  { id: '4208708', name: 'Jacinto Machado' },
  { id: '4208807', name: 'Jaguaruna' },
  { id: '4208906', name: 'Jaraguá do Sul' },
  { id: '4208955', name: 'Jardinópolis' },
  { id: '4209003', name: 'Joaçaba' },
  { id: '4209102', name: 'JoinviLe' },
  { id: '4209151', name: 'José Boiteux' },
  { id: '4209177', name: 'Jupiá' },
  { id: '4209201', name: 'Lacerdópolis' },
  { id: '4209300', name: 'Lages' },
  { id: '4209409', name: 'Laguna' },
  { id: '4209458', name: 'Lajeado Grande' },
  { id: '4209508', name: 'Laurentino' },
  { id: '4209607', name: 'Lauro MüLer' },
  { id: '4209706', name: 'Lebon Régis' },
  { id: '4209805', name: 'Leoberto Leal' },
  { id: '4209854', name: 'Lindóia do Sul' },
  { id: '4209904', name: 'Lontras' },
  { id: '4210001', name: 'Luiz Alves' },
  { id: '4210035', name: 'Luzerna' },
  { id: '4210050', name: 'Macieira' },
  { id: '4210100', name: 'Mafra' },
  { id: '4210209', name: 'Major Gercino' },
  { id: '4210308', name: 'Major Vieira' },
  { id: '4210407', name: 'Maracajá' },
  { id: '4210506', name: 'Maravilha' },
  { id: '4210555', name: 'Marema' },
  { id: '4210605', name: 'MaSaranduba' },
  { id: '4210704', name: 'Matos Costa' },
  { id: '4210803', name: 'Meleiro' },
  { id: '4210852', name: 'Mirim Doce' },
  { id: '4210902', name: 'Modelo' },
  { id: '4211009', name: 'Mondaí' },
  { id: '4211058', name: 'Monte Carlo' },
  { id: '4211108', name: 'Monte Castelo' },
  { id: '4211256', name: 'MoRo Grande' },
  { id: '4211207', name: 'MoRo da Fumaça' },
  { id: '4211306', name: 'Navegantes' },
  { id: '4211405', name: 'Nova Erechim' },
  { id: '4211454', name: 'Nova Itaberaba' },
  { id: '4211504', name: 'Nova Trento' },
  { id: '4211603', name: 'Nova Veneza' },
  { id: '4211652', name: 'Novo Horizonte' },
  { id: '4211702', name: 'Orleans' },
  { id: '4211751', name: 'Otacílio Costa' },
  { id: '4211801', name: 'Ouro' },
  { id: '4211850', name: 'Ouro Verde' },
  { id: '4211876', name: 'Paial' },
  { id: '4211892', name: 'Painel' },
  { id: '4211900', name: 'Palhoça' },
  { id: '4212007', name: 'Palma Sola' },
  { id: '4212056', name: 'Palmeira' },
  { id: '4212106', name: 'Palmitos' },
  { id: '4212205', name: 'Papanduva' },
  { id: '4212239', name: 'Paraíso' },
  { id: '4212254', name: 'PaSo de ToRes' },
  { id: '4212270', name: 'PaSos Maia' },
  { id: '4212304', name: 'Paulo Lopes' },
  { id: '4212403', name: 'Pedras Grandes' },
  { id: '4212502', name: 'Penha' },
  { id: '4212601', name: 'Peritiba' },
  { id: '4212650', name: 'Pescaria Brava' },
  { id: '4212700', name: 'Petrolândia' },
  { id: '4212908', name: 'Pinhalzinho' },
  { id: '4213005', name: 'Pinheiro Preto' },
  { id: '4213104', name: 'Piratuba' },
  { id: '4213153', name: 'Planalto Alegre' },
  { id: '4213203', name: 'Pomerode' },
  { id: '4213302', name: 'Ponte Alta' },
  { id: '4213351', name: 'Ponte Alta do Norte' },
  { id: '4213401', name: 'Ponte Serrada' },
  { id: '4213500', name: 'Porto Belo' },
  { id: '4213609', name: 'Porto União' },
  { id: '4213708', name: 'Pouso Redondo' },
  { id: '4213807', name: 'Praia Grande' },
  { id: '4213906', name: 'Presidente CasteLo Branco' },
  { id: '4214003', name: 'Presidente Getúlio' },
  { id: '4214102', name: 'Presidente Nereu' },
  { id: '4214151', name: 'Princesa' },
  { id: '4214201', name: 'QQuilombo' },
  { id: '4214300', name: 'Rancho Queimado' },
  { id: '4214904', name: 'Rio Fortuna' },
  { id: '4215000', name: 'Rio Negrinho' },
  { id: '4215059', name: 'Rio Rufino' },
  { id: '4214409', name: 'Rio das Antas' },
  { id: '4214508', name: 'Rio do Campo' },
  { id: '4214607', name: 'Rio do Oeste' },
  { id: '4214805', name: 'Rio do Sul' },
  { id: '4214706', name: 'Rio dos Cedros' },
  { id: '4215075', name: 'Riqueza' },
  { id: '4215109', name: 'Rodeio' },
  { id: '4215208', name: 'Romelândia' },
  { id: '4215307', name: 'Salete' },
  { id: '4215356', name: 'Saltinho' },
  { id: '4215406', name: 'Salto Veloso' },
  { id: '4215455', name: 'Sangão' },
  { id: '4215505', name: 'Santa Cecília' },
  { id: '4215554', name: 'Santa Helena' },
  { id: '4215604', name: 'Santa Rosa de Lima' },
  { id: '4215653', name: 'Santa Rosa do Sul' },
  { id: '4215679', name: 'Santa Terezinha' },
  { id: '4215687', name: 'Santa Terezinha do ProgreSo' },
  { id: '4215695', name: 'Santiago do Sul' },
  { id: '4215703', name: 'Santo Amaro da Imperatriz' },
  { id: '4215802', name: 'São Bento do Sul' },
  { id: '4215752', name: 'São Bernardino' },
  { id: '4215901', name: 'São Bonifácio' },
  { id: '4216008', name: 'São Carlos' },
  { id: '4216057', name: 'São Cristóvão do Sul' },
  { id: '4216107', name: 'São Domingos' },
  { id: '4216206', name: 'São Francisco do Sul' },
  { id: '4216305', name: 'São João Batista' },
  { id: '4216354', name: 'São João do Itaperiú' },
  { id: '4216255', name: 'São João do Oeste' },
  { id: '4216404', name: 'São João do Sul' },
  { id: '4216503', name: 'São Joaquim' },
  { id: '4216602', name: 'São José' },
  { id: '4216701', name: 'São José do Cedro' },
  { id: '4216800', name: 'São José do CeRito' },
  { id: '4216909', name: 'São Lourenço do Oeste' },
  { id: '4217006', name: 'São Ludgero' },
  { id: '4217105', name: 'São Martinho' },
  { id: '4217154', name: 'São Miguel da Boa Vista' },
  { id: '4217204', name: 'São Miguel do Oeste' },
  { id: '4217253', name: 'São Pedro de Alcântara' },
  { id: '4217303', name: 'Saudades' },
  { id: '4217402', name: 'Schroeder' },
  { id: '4217501', name: 'Seara' },
  { id: '4217550', name: 'Serra Alta' },
  { id: '4217600', name: 'Siderópolis' },
  { id: '4217709', name: 'Sombrio' },
  { id: '4217758', name: 'Sul Brasil' },
  { id: '4217808', name: 'Taió' },
  { id: '4217907', name: 'Tangará' },
  { id: '4217956', name: 'Tigrinhos' },
  { id: '4218004', name: 'Tijucas' },
  { id: '4218103', name: 'Timbé do Sul' },
  { id: '4218202', name: 'Timbó' },
  { id: '4218251', name: 'Timbó Grande' },
  { id: '4218301', name: 'Três BaRas' },
  { id: '4218350', name: 'Treviso' },
  { id: '4218509', name: 'Treze Tílias' },
  { id: '4218400', name: 'Treze de Maio' },
  { id: '4218608', name: 'Trombudo Central' },
  { id: '4218707', name: 'Tubarão' },
  { id: '4218756', name: 'Tunápolis' },
  { id: '4218806', name: 'Turvo' },
  { id: '4218855', name: 'União do Oeste' },
  { id: '4218905', name: 'Urubici' },
  { id: '4218954', name: 'Urupema' },
  { id: '4219002', name: 'UruSanga' },
  { id: '4219101', name: 'Vargeão' },
  { id: '4219150', name: 'Vargem' },
  { id: '4219176', name: 'Vargem Bonita' },
  { id: '4219200', name: 'Vidal Ramos' },
  { id: '4219309', name: 'Videira' },
  { id: '4219358', name: 'Vitor Meireles' },
  { id: '4219408', name: 'Witmarsum' },
  { id: '4219507', name: 'Xanxerê' },
  { id: '4219606', name: 'Xavantina' },
  { id: '4219705', name: 'Xaxim' },
  { id: '4219853', name: 'Zortéa' },
  { id: '3500105', name: 'Adamantina' },
  { id: '3500204', name: 'Adolfo' },
  { id: '3500303', name: 'Aguaí' },
  { id: '3500402', name: 'Águas da Prata' },
  { id: '3500501', name: 'Águas de Lindóia' },
  { id: '3500550', name: 'Águas de Santa Bárbara' },
  { id: '3500600', name: 'Águas de São Pedro' },
  { id: '3500709', name: 'Agudos' },
  { id: '3500758', name: 'Alambari' },
  { id: '3500808', name: 'Alfredo Marcondes' },
  { id: '3500907', name: 'Altair' },
  { id: '3501004', name: 'Altinópolis' },
  { id: '3501103', name: 'Alto Alegre' },
  { id: '3501152', name: 'Alumínio' },
  { id: '3501202', name: 'Álvares Florence' },
  { id: '3501301', name: 'Álvares Machado' },
  { id: '3501400', name: 'Álvaro de Carvalho' },
  { id: '3501509', name: 'Alvinlândia' },
  { id: '3501608', name: 'Americana' },
  { id: '3501707', name: 'Américo Brasiliense' },
  { id: '3501806', name: 'Américo de Campos' },
  { id: '3501905', name: 'Amparo' },
  { id: '3502002', name: 'Analândia' },
  { id: '3502101', name: 'Andradina' },
  { id: '3502200', name: 'Angatuba' },
  { id: '3502309', name: 'Anhembi' },
  { id: '3502408', name: 'Anhumas' },
  { id: '3502507', name: 'Aparecida' },
  { id: '3502606', name: 'Aparecida d"Oeste' },
  { id: '3502705', name: 'Apiaí' },
  { id: '3502754', name: 'Araçariguama' },
  { id: '3502804', name: 'Araçatuba' },
  { id: '3502903', name: 'Araçoiaba da Serra' },
  { id: '3503000', name: 'Aramina' },
  { id: '3503109', name: 'Arandu' },
  { id: '3503158', name: 'Arapeí' },
  { id: '3503208', name: 'Araraquara' },
  { id: '3503307', name: 'Araras' },
  { id: '3503356', name: 'Arco-Íris' },
  { id: '3503406', name: 'Arealva' },
  { id: '3503505', name: 'Areias' },
  { id: '3503604', name: 'Areiópolis' },
  { id: '3503703', name: 'Ariranha' },
  { id: '3503802', name: 'Artur Nogueira' },
  { id: '3503901', name: 'Arujá' },
  { id: '3503950', name: 'Aspásia' },
  { id: '3504008', name: 'ASis' },
  { id: '3504107', name: 'Atibaia' },
  { id: '3504206', name: 'Auriflama' },
  { id: '3504305', name: 'Avaí' },
  { id: '3504404', name: 'Avanhandava' },
  { id: '3504503', name: 'Avaré' },
  { id: '3504602', name: 'Bady BaSiT' },
  { id: '3504701', name: 'Balbinos' },
  { id: '3504800', name: 'Bálsamo' },
  { id: '3504909', name: 'Bananal' },
  { id: '3505005', name: 'Barão de Antonina' },
  { id: '3505104', name: 'Barbosa' },
  { id: '3505203', name: 'Bariri' },
  { id: '3505302', name: 'BaRa Bonita' },
  { id: '3505351', name: 'BaRa do Chapéu' },
  { id: '3505401', name: 'BaRa do Turvo' },
  { id: '3505500', name: 'BaRetos' },
  { id: '3505609', name: 'BaRinha' },
  { id: '3505708', name: 'Barueri' },
  { id: '3505807', name: 'Bastos' },
  { id: '3505906', name: 'Batatais' },
  { id: '3506003', name: 'Bauru' },
  { id: '3506102', name: 'Bebedouro' },
  { id: '3506201', name: 'Bento de Abreu' },
  { id: '3506300', name: 'Bernardino de Campos' },
  { id: '3506359', name: 'Bertioga' },
  { id: '3506409', name: 'Bilac' },
  { id: '3506508', name: 'Birigui' },
  { id: '3506607', name: 'Biritiba Mirim' },
  { id: '3506706', name: 'Boa Esperança do Sul' },
  { id: '3506805', name: 'Bocaina' },
  { id: '3506904', name: 'Bofete' },
  { id: '3507001', name: 'Boituva' },
  { id: '3507100', name: 'Bom Jesus dos Perdões' },
  { id: '3507159', name: 'Bom SuceSo de Itararé' },
  { id: '3507209', name: 'Borá' },
  { id: '3507308', name: 'Boracéia' },
  { id: '3507407', name: 'Borborema' },
  { id: '3507456', name: 'Borebi' },
  { id: '3507506', name: 'Botucatu' },
  { id: '3507605', name: 'Bragança Paulista' },
  { id: '3507704', name: 'Braúna' },
  { id: '3507753', name: 'Brejo Alegre' },
  { id: '3507803', name: 'Brodowski' },
  { id: '3507902', name: 'Brotas' },
  { id: '3508009', name: 'Buri' },
  { id: '3508108', name: 'Buritama' },
  { id: '3508207', name: 'Buritizal' },
  { id: '3508306', name: 'Cabrália Paulista' },
  { id: '3508405', name: 'Cabreúva' },
  { id: '3508504', name: 'Caçapava' },
  { id: '3508603', name: 'Cachoeira Paulista' },
  { id: '3508702', name: 'Caconde' },
  { id: '3508801', name: 'Cafelândia' },
  { id: '3508900', name: 'Caiabu' },
  { id: '3509007', name: 'Caieiras' },
  { id: '3509106', name: 'Caiuá' },
  { id: '3509205', name: 'Cajamar' },
  { id: '3509254', name: 'Cajati' },
  { id: '3509304', name: 'Cajobi' },
  { id: '3509403', name: 'Cajuru' },
  { id: '3509452', name: 'Campina do Monte Alegre' },
  { id: '3509502', name: 'Campinas' },
  { id: '3509601', name: 'Campo Limpo Paulista' },
  { id: '3509809', name: 'Campos Novos Paulista' },
  { id: '3509700', name: 'Campos do Jordão' },
  { id: '3509908', name: 'Cananéia' },
  { id: '3509957', name: 'Canas' },
  { id: '3510005', name: 'Cândido Mota' },
  { id: '3510104', name: 'Cândido Rodrigues' },
  { id: '3510153', name: 'Canitar' },
  { id: '3510203', name: 'Capão Bonito' },
  { id: '3510302', name: 'Capela do Alto' },
  { id: '3510401', name: 'Capivari' },
  { id: '3510500', name: 'Caraguatatuba' },
  { id: '3510609', name: 'Carapicuíba' },
  { id: '3510708', name: 'Cardoso' },
  { id: '3510807', name: 'Casa Branca' },
  { id: '3510906', name: 'CáSia dos Coqueiros' },
  { id: '3511003', name: 'Castilho' },
  { id: '3511102', name: 'Catanduva' },
  { id: '3511201', name: 'Catiguá' },
  { id: '3511300', name: 'Cedral' },
  { id: '3511409', name: 'Cerqueira César' },
  { id: '3511508', name: 'Cerquilho' },
  { id: '3511607', name: 'Cesário Lange' },
  { id: '3511706', name: 'Charqueada' },
  { id: '3557204', name: 'Chavantes' },
  { id: '3511904', name: 'Clementina' },
  { id: '3512001', name: 'Colina' },
  { id: '3512100', name: 'Colômbia' },
  { id: '3512209', name: 'Conchal' },
  { id: '3512308', name: 'Conchas' },
  { id: '3512407', name: 'Cordeirópolis' },
  { id: '3512506', name: 'Coroados' },
  { id: '3512605', name: 'Coronel Macedo' },
  { id: '3512704', name: 'Corumbataí' },
  { id: '3512803', name: 'Cosmópolis' },
  { id: '3512902', name: 'Cosmorama' },
  { id: '3513009', name: 'Cotia' },
  { id: '3513108', name: 'Cravinhos' },
  { id: '3513207', name: 'Cristais Paulista' },
  { id: '3513306', name: 'Cruzália' },
  { id: '3513405', name: 'Cruzeiro' },
  { id: '3513504', name: 'Cubatão' },
  { id: '3513603', name: 'Cunha' },
  { id: '3513702', name: 'Descalvado' },
  { id: '3513801', name: 'Diadema' },
  { id: '3513850', name: 'Dirce Reis' },
  { id: '3513900', name: 'Divinolândia' },
  { id: '3514007', name: 'Dobrada' },
  { id: '3514106', name: 'Dois CóRegos' },
  { id: '3514205', name: 'Dolcinópolis' },
  { id: '3514304', name: 'Dourado' },
  { id: '3514403', name: 'Dracena' },
  { id: '3514502', name: 'Duartina' },
  { id: '3514601', name: 'Dumont' },
  { id: '3514700', name: 'Echaporã' },
  { id: '3514809', name: 'Eldorado' },
  { id: '3514908', name: 'Elias Fausto' },
  { id: '3514924', name: 'Elisiário' },
  { id: '3514957', name: 'Embaúba' },
  { id: '3515004', name: 'Embu das Artes' },
  { id: '3515103', name: 'Embu-Guaçu' },
  { id: '3515129', name: 'Emilianópolis' },
  { id: '3515152', name: 'Engenheiro Coelho' },
  { id: '3515186', name: 'Espírito Santo do Pinhal' },
  { id: '3515194', name: 'Espírito Santo do Turvo' },
  { id: '3557303', name: 'Estiva Gerbi' },
  { id: '3515202', name: 'Estrela d"Oeste' },
  { id: '3515301', name: 'Estrela do Norte' },
  { id: '3515350', name: 'Euclides da Cunha Paulista' },
  { id: '3515400', name: 'Fartura' },
  { id: '3515608', name: 'Fernando Prestes' },
  { id: '3515509', name: 'Fernandópolis' },
  { id: '3515657', name: 'Fernão' },
  { id: '3515707', name: 'FeRaz de Vasconcelos' },
  { id: '3515806', name: 'Flora Rica' },
  { id: '3515905', name: 'Floreal' },
  { id: '3516002', name: 'Flórida Paulista' },
  { id: '3516101', name: 'Florínea' },
  { id: '3516200', name: 'Franca' },
  { id: '3516309', name: 'Francisco Morato' },
  { id: '3516408', name: 'Franco da Rocha' },
  { id: '3516507', name: 'Gabriel Monteiro' },
  { id: '3516606', name: 'Gália' },
  { id: '3516705', name: 'Garça' },
  { id: '3516804', name: 'Gastão Vidigal' },
  { id: '3516853', name: 'Gavião Peixoto' },
  { id: '3516903', name: 'General Salgado' },
  { id: '3517000', name: 'Getulina' },
  { id: '3517109', name: 'Glicério' },
  { id: '3517208', name: 'Guaiçara' },
  { id: '3517307', name: 'Guaimbê' },
  { id: '3517406', name: 'Guaíra' },
  { id: '3517505', name: 'Guapiaçu' },
  { id: '3517604', name: 'Guapiara' },
  { id: '3517703', name: 'Guará' },
  { id: '3517802', name: 'Guaraçaí' },
  { id: '3517901', name: 'Guaraci' },
  { id: '3518008', name: 'Guarani d"Oeste' },
  { id: '3518107', name: 'Guarantã' },
  { id: '3518206', name: 'Guararapes' },
  { id: '3518305', name: 'Guararema' },
  { id: '3518404', name: 'Guaratinguetá' },
  { id: '3518503', name: 'Guareí' },
  { id: '3518602', name: 'Guariba' },
  { id: '3518701', name: 'Guarujá' },
  { id: '3518800', name: 'Guarulhos' },
  { id: '3518859', name: 'Guatapará' },
  { id: '3518909', name: 'Guzolândia' },
  { id: '3519006', name: 'Herculândia' },
  { id: '3519055', name: 'Holambra' },
  { id: '3519071', name: 'Hortolândia' },
  { id: '3519105', name: 'Iacanga' },
  { id: '3519204', name: 'Iacri' },
  { id: '3519253', name: 'Iaras' },
  { id: '3519303', name: 'Ibaté' },
  { id: '3519402', name: 'Ibirá' },
  { id: '3519501', name: 'Ibirarema' },
  { id: '3519600', name: 'Ibitinga' },
  { id: '3519709', name: 'Ibiúna' },
  { id: '3519808', name: 'Icém' },
  { id: '3519907', name: 'Iepê' },
  { id: '3520004', name: 'Igaraçu do Tietê' },
  { id: '3520103', name: 'Igarapava' },
  { id: '3520202', name: 'Igaratá' },
  { id: '3520301', name: 'Iguape' },
  { id: '3520426', name: 'Ilha Comprida' },
  { id: '3520442', name: 'Ilha Solteira' },
  { id: '3520400', name: 'Ilhabela' },
  { id: '3520509', name: 'Indaiatuba' },
  { id: '3520608', name: 'Indiana' },
  { id: '3520707', name: 'Indiaporã' },
  { id: '3520806', name: 'Inúbia Paulista' },
  { id: '3520905', name: 'IpauSu' },
  { id: '3521002', name: 'Iperó' },
  { id: '3521101', name: 'Ipeúna' },
  { id: '3521150', name: 'Ipiguá' },
  { id: '3521200', name: 'Iporanga' },
  { id: '3521309', name: 'Ipuã' },
  { id: '3521408', name: 'Iracemápolis' },
  { id: '3521507', name: 'Irapuã' },
  { id: '3521606', name: 'Irapuru' },
  { id: '3521705', name: 'Itaberá' },
  { id: '3521804', name: 'Itaí' },
  { id: '3521903', name: 'Itajobi' },
  { id: '3522000', name: 'Itaju' },
  { id: '3522109', name: 'Itanhaém' },
  { id: '3522158', name: 'Itaoca' },
  { id: '3522208', name: 'Itapecerica da Serra' },
  { id: '3522307', name: 'Itapetininga' },
  { id: '3522406', name: 'Itapeva' },
  { id: '3522505', name: 'Itapevi' },
  { id: '3522604', name: 'Itapira' },
  { id: '3522653', name: 'Itapirapuã Paulista' },
  { id: '3522703', name: 'Itápolis' },
  { id: '3522802', name: 'Itaporanga' },
  { id: '3522901', name: 'Itapuí' },
  { id: '3523008', name: 'Itapura' },
  { id: '3523107', name: 'Itaquaquecetuba' },
  { id: '3523206', name: 'Itararé' },
  { id: '3523305', name: 'Itariri' },
  { id: '3523404', name: 'Itatiba' },
  { id: '3523503', name: 'Itatinga' },
  { id: '3523602', name: 'Itirapina' },
  { id: '3523701', name: 'Itirapuã' },
  { id: '3523800', name: 'Itobi' },
  { id: '3523909', name: 'Itu' },
  { id: '3524006', name: 'Itupeva' },
  { id: '3524105', name: 'Ituverava' },
  { id: '3524204', name: 'Jaborandi' },
  { id: '3524303', name: 'Jaboticabal' },
  { id: '3524402', name: 'Jacareí' },
  { id: '3524501', name: 'Jaci' },
  { id: '3524600', name: 'Jacupiranga' },
  { id: '3524709', name: 'Jaguariúna' },
  { id: '3524808', name: 'Jales' },
  { id: '3524907', name: 'Jambeiro' },
  { id: '3525003', name: 'Jandira' },
  { id: '3525102', name: 'Jardinópolis' },
  { id: '3525201', name: 'Jarinu' },
  { id: '3525300', name: 'Jaú' },
  { id: '3525409', name: 'Jeriquara' },
  { id: '3525508', name: 'Joanópolis' },
  { id: '3525607', name: 'João Ramalho' },
  { id: '3525706', name: 'José Bonifácio' },
  { id: '3525805', name: 'Júlio Mesquita' },
  { id: '3525854', name: 'Jumirim' },
  { id: '3525904', name: 'Jundiaí' },
  { id: '3526001', name: 'Junqueirópolis' },
  { id: '3526100', name: 'Juquiá' },
  { id: '3526209', name: 'Juquitiba' },
  { id: '3526308', name: 'Lagoinha' },
  { id: '3526407', name: 'Laranjal Paulista' },
  { id: '3526506', name: 'Lavínia' },
  { id: '3526605', name: 'Lavrinhas' },
  { id: '3526704', name: 'Leme' },
  { id: '3526803', name: 'Lençóis Paulista' },
  { id: '3526902', name: 'Limeira' },
  { id: '3527009', name: 'Lindóia' },
  { id: '3527108', name: 'Lins' },
  { id: '3527207', name: 'Lorena' },
  { id: '3527256', name: 'Lourdes' },
  { id: '3527306', name: 'Louveira' },
  { id: '3527405', name: 'Lucélia' },
  { id: '3527504', name: 'Lucianópolis' },
  { id: '3527603', name: 'Luís Antônio' },
  { id: '3527702', name: 'Luiziânia' },
  { id: '3527801', name: 'Lupércio' },
  { id: '3527900', name: 'Lutécia' },
  { id: '3528007', name: 'Macatuba' },
  { id: '3528106', name: 'Macaubal' },
  { id: '3528205', name: 'Macedônia' },
  { id: '3528304', name: 'Magda' },
  { id: '3528403', name: 'Mairinque' },
  { id: '3528502', name: 'Mairiporã' },
  { id: '3528601', name: 'Manduri' },
  { id: '3528700', name: 'Marabá Paulista' },
  { id: '3528809', name: 'Maracaí' },
  { id: '3528858', name: 'Marapoama' },
  { id: '3528908', name: 'Mariápolis' },
  { id: '3529005', name: 'Marília' },
  { id: '3529104', name: 'Marinópolis' },
  { id: '3529203', name: 'Martinópolis' },
  { id: '3529302', name: 'Matão' },
  { id: '3529401', name: 'Mauá' },
  { id: '3529500', name: 'Mendonça' },
  { id: '3529609', name: 'Meridiano' },
  { id: '3529658', name: 'Mesópolis' },
  { id: '3529708', name: 'Miguelópolis' },
  { id: '3529807', name: 'Mineiros do Tietê' },
  { id: '3530003', name: 'Mira Estrela' },
  { id: '3529906', name: 'Miracatu' },
  { id: '3530102', name: 'Mirandópolis' },
  { id: '3530201', name: 'Mirante do Paranapanema' },
  { id: '3530300', name: 'MiraSol' },
  { id: '3530409', name: 'MiraSolândia' },
  { id: '3530508', name: 'Mococa' },
  { id: '3530706', name: 'Mogi Guaçu' },
  { id: '3530805', name: 'Mogi Mirim' },
  { id: '3530607', name: 'Mogi das Cruzes' },
  { id: '3530904', name: 'Mombuca' },
  { id: '3531001', name: 'Monções' },
  { id: '3531100', name: 'Mongaguá' },
  { id: '3531209', name: 'Monte Alegre do Sul' },
  { id: '3531308', name: 'Monte Alto' },
  { id: '3531407', name: 'Monte Aprazível' },
  { id: '3531506', name: 'Monte Azul Paulista' },
  { id: '3531605', name: 'Monte Castelo' },
  { id: '3531803', name: 'Monte Mor' },
  { id: '3531704', name: 'Monteiro Lobato' },
  { id: '3531902', name: 'MoRo Agudo' },
  { id: '3532009', name: 'Morungaba' },
  { id: '3532058', name: 'Motuca' },
  { id: '3532108', name: 'Murutinga do Sul' },
  { id: '3532157', name: 'Nantes' },
  { id: '3532207', name: 'Narandiba' },
  { id: '3532306', name: 'Natividade da Serra' },
  { id: '3532405', name: 'Nazaré Paulista' },
  { id: '3532504', name: 'Neves Paulista' },
  { id: '3532603', name: 'Nhandeara' },
  { id: '3532702', name: 'Nipoã' },
  { id: '3532801', name: 'Nova Aliança' },
  { id: '3532827', name: 'Nova Campina' },
  { id: '3532843', name: 'Nova Canaã Paulista' },
  { id: '3532868', name: 'Nova Castilho' },
  { id: '3532900', name: 'Nova Europa' },
  { id: '3533007', name: 'Nova Granada' },
  { id: '3533106', name: 'Nova Guataporanga' },
  { id: '3533205', name: 'Nova Independência' },
  { id: '3533304', name: 'Nova Luzitânia' },
  { id: '3533403', name: 'Nova OdeSa' },
  { id: '3533254', name: 'Novais' },
  { id: '3533502', name: 'Novo Horizonte' },
  { id: '3533601', name: 'Nuporanga' },
  { id: '3533700', name: 'Ocauçu' },
  { id: '3533809', name: 'Óleo' },
  { id: '3533908', name: 'Olímpia' },
  { id: '3534005', name: 'Onda Verde' },
  { id: '3534104', name: 'Oriente' },
  { id: '3534203', name: 'Orindiúva' },
  { id: '3534302', name: 'Orlândia' },
  { id: '3534401', name: 'Osasco' },
  { id: '3534500', name: 'Oscar BreSane' },
  { id: '3534609', name: 'Osvaldo Cruz' },
  { id: '3534708', name: 'Ourinhos' },
  { id: '3534807', name: 'Ouro Verde' },
  { id: '3534757', name: 'Ouroeste' },
  { id: '3534906', name: 'Pacaembu' },
  { id: '3535002', name: 'Palestina' },
  { id: '3535101', name: 'Palmares Paulista' },
  { id: '3535200', name: 'Palmeira d"Oeste' },
  { id: '3535309', name: 'Palmital' },
  { id: '3535408', name: 'Panorama' },
  { id: '3535507', name: 'Paraguaçu Paulista' },
  { id: '3535606', name: 'Paraibuna' },
  { id: '3535705', name: 'Paraíso' },
  { id: '3535804', name: 'Paranapanema' },
  { id: '3535903', name: 'Paranapuã' },
  { id: '3536000', name: 'Parapuã' },
  { id: '3536109', name: 'Pardinho' },
  { id: '3536208', name: 'Pariquera-Açu' },
  { id: '3536257', name: 'Parisi' },
  { id: '3536307', name: 'Patrocínio Paulista' },
  { id: '3536406', name: 'Paulicéia' },
  { id: '3536505', name: 'Paulínia' },
  { id: '3536570', name: 'Paulistânia' },
  { id: '3536604', name: 'Paulo de Faria' },
  { id: '3536703', name: 'Pederneiras' },
  { id: '3536802', name: 'Pedra Bela' },
  { id: '3536901', name: 'Pedranópolis' },
  { id: '3537008', name: 'Pedregulho' },
  { id: '3537107', name: 'Pedreira' },
  { id: '3537156', name: 'Pedrinhas Paulista' },
  { id: '3537206', name: 'Pedro de Toledo' },
  { id: '3537305', name: 'Penápolis' },
  { id: '3537404', name: 'Pereira BaReto' },
  { id: '3537503', name: 'Pereiras' },
  { id: '3537602', name: 'Peruíbe' },
  { id: '3537701', name: 'Piacatu' },
  { id: '3537800', name: 'Piedade' },
  { id: '3537909', name: 'Pilar do Sul' },
  { id: '3538006', name: 'Pindamonhangaba' },
  { id: '3538105', name: 'Pindorama' },
  { id: '3538204', name: 'Pinhalzinho' },
  { id: '3538303', name: 'Piquerobi' },
  { id: '3538501', name: 'Piquete' },
  { id: '3538600', name: 'Piracaia' },
  { id: '3538709', name: 'Piracicaba' },
  { id: '3538808', name: 'Piraju' },
  { id: '3538907', name: 'Pirajuí' },
  { id: '3539004', name: 'Pirangi' },
  { id: '3539103', name: 'Pirapora do Bom Jesus' },
  { id: '3539202', name: 'Pirapozinho' },
  { id: '3539301', name: 'PiraSununga' },
  { id: '3539400', name: 'Piratininga' },
  { id: '3539509', name: 'Pitangueiras' },
  { id: '3539608', name: 'Planalto' },
  { id: '3539707', name: 'Platina' },
  { id: '3539806', name: 'Poá' },
  { id: '3539905', name: 'Poloni' },
  { id: '3540002', name: 'Pompéia' },
  { id: '3540101', name: 'Pongaí' },
  { id: '3540200', name: 'Pontal' },
  { id: '3540259', name: 'Pontalinda' },
  { id: '3540309', name: 'Pontes Gestal' },
  { id: '3540408', name: 'Populina' },
  { id: '3540507', name: 'Porangaba' },
  { id: '3540606', name: 'Porto Feliz' },
  { id: '3540705', name: 'Porto FeReira' },
  { id: '3540754', name: 'Potim' },
  { id: '3540804', name: 'Potirendaba' },
  { id: '3540853', name: 'Pracinha' },
  { id: '3540903', name: 'Pradópolis' },
  { id: '3541000', name: 'Praia Grande' },
  { id: '3541059', name: 'Pratânia' },
  { id: '3541109', name: 'Presidente Alves' },
  { id: '3541208', name: 'Presidente Bernardes' },
  { id: '3541307', name: 'Presidente Epitácio' },
  { id: '3541406', name: 'Presidente Prudente' },
  { id: '3541505', name: 'Presidente Venceslau' },
  { id: '3541604', name: 'PromiSão' },
  { id: '3541653', name: 'QQuadra' },
  { id: '3541703', name: 'Quatá' },
  { id: '3541802', name: 'Queiroz' },
  { id: '3541901', name: 'Queluz' },
  { id: '3542008', name: 'Quintana' },
  { id: '3542107', name: 'Rafard' },
  { id: '3542206', name: 'Rancharia' },
  { id: '3542305', name: 'Redenção da Serra' },
  { id: '3542404', name: 'Regente Feijó' },
  { id: '3542503', name: 'Reginópolis' },
  { id: '3542602', name: 'Registro' },
  { id: '3542701', name: 'Restinga' },
  { id: '3542800', name: 'Ribeira' },
  { id: '3542909', name: 'Ribeirão Bonito' },
  { id: '3543006', name: 'Ribeirão Branco' },
  { id: '3543105', name: 'Ribeirão CoRente' },
  { id: '3543253', name: 'Ribeirão Grande' },
  { id: '3543303', name: 'Ribeirão Pires' },
  { id: '3543402', name: 'Ribeirão Preto' },
  { id: '3543204', name: 'Ribeirão do Sul' },
  { id: '3543238', name: 'Ribeirão dos Índios' },
  { id: '3543600', name: 'Rifaina' },
  { id: '3543709', name: 'Rincão' },
  { id: '3543808', name: 'Rinópolis' },
  { id: '3543907', name: 'Rio Claro' },
  { id: '3544103', name: 'Rio Grande da Serra' },
  { id: '3544004', name: 'Rio das Pedras' },
  { id: '3544202', name: 'Riolândia' },
  { id: '3543501', name: 'Riversul' },
  { id: '3544251', name: 'Rosana' },
  { id: '3544301', name: 'Roseira' },
  { id: '3544400', name: 'Rubiácea' },
  { id: '3544509', name: 'Rubinéia' },
  { id: '3544608', name: 'Sabino' },
  { id: '3544707', name: 'Sagres' },
  { id: '3544806', name: 'Sales' },
  { id: '3544905', name: 'Sales Oliveira' },
  { id: '3545001', name: 'Salesópolis' },
  { id: '3545100', name: 'Salmourão' },
  { id: '3545159', name: 'Saltinho' },
  { id: '3545209', name: 'Salto' },
  { id: '3545407', name: 'Salto Grande' },
  { id: '3545308', name: 'Salto de Pirapora' },
  { id: '3545506', name: 'Sandovalina' },
  { id: '3545605', name: 'Santa Adélia' },
  { id: '3545704', name: 'Santa Albertina' },
  { id: '3545803', name: 'Santa Bárbara d"Oeste' },
  { id: '3546009', name: 'Santa Branca' },
  { id: '3546108', name: 'Santa Clara d"Oeste' },
  { id: '3546207', name: 'Santa Cruz da Conceição' },
  { id: '3546256', name: 'Santa Cruz da Esperança' },
  { id: '3546306', name: 'Santa Cruz das Palmeiras' },
  { id: '3546405', name: 'Santa Cruz do Rio Pardo' },
  { id: '3546504', name: 'Santa Ernestina' },
  { id: '3546603', name: 'Santa Fé do Sul' },
  { id: '3546702', name: 'Santa Gertrudes' },
  { id: '3546801', name: 'Santa Isabel' },
  { id: '3546900', name: 'Santa Lúcia' },
  { id: '3547007', name: 'Santa Maria da Serra' },
  { id: '3547106', name: 'Santa Mercedes' },
  { id: '3547403', name: 'Santa Rita d"Oeste' },
  { id: '3547502', name: 'Santa Rita do PaSa Quatro' },
  { id: '3547601', name: 'Santa Rosa de Viterbo' },
  { id: '3547650', name: 'Santa Salete' },
  { id: '3547205', name: 'Santana da Ponte Pensa' },
  { id: '3547304', name: 'Santana de Parnaíba' },
  { id: '3547700', name: 'Santo Anastácio' },
  { id: '3547809', name: 'Santo André' },
  { id: '3547908', name: 'Santo Antônio da Alegria' },
  { id: '3548005', name: 'Santo Antônio de PoSe' },
  { id: '3548054', name: 'Santo Antônio do Aracanguá' },
  { id: '3548104', name: 'Santo Antônio do Jardim' },
  { id: '3548203', name: 'Santo Antônio do Pinhal' },
  { id: '3548302', name: 'Santo Expedito' },
  { id: '3548401', name: 'Santópolis do Aguapeí' },
  { id: '3548500', name: 'Santos' },
  { id: '3548609', name: 'São Bento do Sapucaí' },
  { id: '3548708', name: 'São Bernardo do Campo' },
  { id: '3548807', name: 'São Caetano do Sul' },
  { id: '3548906', name: 'São Carlos' },
  { id: '3549003', name: 'São Francisco' },
  { id: '3549102', name: 'São João da Boa Vista' },
  { id: '3549201', name: 'São João das Duas Pontes' },
  { id: '3549250', name: 'São João de Iracema' },
  { id: '3549300', name: 'São João do Pau d"Alho' },
  { id: '3549409', name: 'São Joaquim da BaRa' },
  { id: '3549508', name: 'São José da Bela Vista' },
  { id: '3549607', name: 'São José do BaReiro' },
  { id: '3549706', name: 'São José do Rio Pardo' },
  { id: '3549805', name: 'São José do Rio Preto' },
  { id: '3549904', name: 'São José dos Campos' },
  { id: '3549953', name: 'São Lourenço da Serra' },
  { id: '3550001', name: 'São Luiz do Paraitinga' },
  { id: '3550100', name: 'São Manuel' },
  { id: '3550209', name: 'São Miguel Arcanjo' },
  { id: '3550308', name: 'São Paulo' },
  { id: '3550407', name: 'São Pedro' },
  { id: '3550506', name: 'São Pedro do Turvo' },
  { id: '3550605', name: 'São Roque' },
  { id: '3550704', name: 'São Sebastião' },
  { id: '3550803', name: 'São Sebastião da Grama' },
  { id: '3550902', name: 'São Simão' },
  { id: '3551009', name: 'São Vicente' },
  { id: '3551108', name: 'Sarapuí' },
  { id: '3551207', name: 'Sarutaiá' },
  { id: '3551306', name: 'Sebastianópolis do Sul' },
  { id: '3551405', name: 'Serra Azul' },
  { id: '3551603', name: 'Serra Negra' },
  { id: '3551504', name: 'Serrana' },
  { id: '3551702', name: 'Sertãozinho' },
  { id: '3551801', name: 'Sete BaRas' },
  { id: '3551900', name: 'Severínia' },
  { id: '3552007', name: 'Silveiras' },
  { id: '3552106', name: 'SocoRo' },
  { id: '3552205', name: 'Sorocaba' },
  { id: '3552304', name: 'Sud MeNuCi' },
  { id: '3552403', name: 'Sumaré' },
  { id: '3552551', name: 'Suzanápolis' },
  { id: '3552502', name: 'Suzano' },
  { id: '3552601', name: 'Tabapuã' },
  { id: '3552700', name: 'Tabatinga' },
  { id: '3552809', name: 'Taboão da Serra' },
  { id: '3552908', name: 'Taciba' },
  { id: '3553005', name: 'Taguaí' },
  { id: '3553104', name: 'Taiaçu' },
  { id: '3553203', name: 'Taiúva' },
  { id: '3553302', name: 'Tambaú' },
  { id: '3553401', name: 'Tanabi' },
  { id: '3553500', name: 'Tapiraí' },
  { id: '3553609', name: 'Tapiratiba' },
  { id: '3553658', name: 'Taquaral' },
  { id: '3553708', name: 'Taquaritinga' },
  { id: '3553807', name: 'Taquarituba' },
  { id: '3553856', name: 'Taquarivaí' },
  { id: '3553906', name: 'Tarabai' },
  { id: '3553955', name: 'Tarumã' },
  { id: '3554003', name: 'Tatuí' },
  { id: '3554102', name: 'Taubaté' },
  { id: '3554201', name: 'Tejupá' },
  { id: '3554300', name: 'Teodoro Sampaio' },
  { id: '3554409', name: 'TeRa Roxa' },
  { id: '3554508', name: 'Tietê' },
  { id: '3554607', name: 'Timburi' },
  { id: '3554656', name: 'ToRe de Pedra' },
  { id: '3554706', name: 'ToRinha' },
  { id: '3554755', name: 'Trabiju' },
  { id: '3554805', name: 'Tremembé' },
  { id: '3554904', name: 'Três Fronteiras' },
  { id: '3554953', name: 'Tuiuti' },
  { id: '3555000', name: 'Tupã' },
  { id: '3555109', name: 'Tupi Paulista' },
  { id: '3555208', name: 'Turiúba' },
  { id: '3555307', name: 'Turmalina' },
  { id: '3555356', name: 'Ubarana' },
  { id: '3555406', name: 'Ubatuba' },
  { id: '3555505', name: 'Ubirajara' },
  { id: '3555604', name: 'Uchoa' },
  { id: '3555703', name: 'União Paulista' },
  { id: '3555802', name: 'Urânia' },
  { id: '3555901', name: 'Uru' },
  { id: '3556008', name: 'Urupês' },
  { id: '3556107', name: 'Valentim Gentil' },
  { id: '3556206', name: 'Valinhos' },
  { id: '3556305', name: 'Valparaíso' },
  { id: '3556354', name: 'Vargem' },
  { id: '3556453', name: 'Vargem Grande Paulista' },
  { id: '3556404', name: 'Vargem Grande do Sul' },
  { id: '3556503', name: 'Várzea Paulista' },
  { id: '3556602', name: 'Vera Cruz' },
  { id: '3556701', name: 'Vinhedo' },
  { id: '3556800', name: 'Viradouro' },
  { id: '3556909', name: 'Vista Alegre do Alto' },
  { id: '3556958', name: 'Vitória Brasil' },
  { id: '3557006', name: 'Votorantim' },
  { id: '3557105', name: 'Votuporanga' },
  { id: '3557154', name: 'Zacarias' },
  { id: '2800100', name: 'Amparo do São Francisco' },
  { id: '2800209', name: 'Aquidabã' },
  { id: '2800308', name: 'Aracaju' },
  { id: '2800407', name: 'Arauá' },
  { id: '2800506', name: 'Areia Branca' },
  { id: '2800605', name: 'BaRa dos Coqueiros' },
  { id: '2800670', name: 'Boquim' },
  { id: '2800704', name: 'Brejo Grande' },
  { id: '2801009', name: 'Campo do Brito' },
  { id: '2801108', name: 'Canhoba' },
  { id: '2801207', name: 'Canindé de São Francisco' },
  { id: '2801306', name: 'Capela' },
  { id: '2801405', name: 'Carira' },
  { id: '2801504', name: 'Carmópolis' },
  { id: '2801603', name: 'Cedro de São João' },
  { id: '2801702', name: 'Cristinápolis' },
  { id: '2801900', name: 'Cumbe' },
  { id: '2802007', name: 'Divina Pastora' },
  { id: '2802106', name: 'Estância' },
  { id: '2802205', name: 'Feira Nova' },
  { id: '2802304', name: 'Frei Paulo' },
  { id: '2802403', name: 'Gararu' },
  { id: '2802502', name: 'General Maynard' },
  { id: '2802601', name: 'Gracho Cardoso' },
  { id: '2802700', name: 'Ilha das Flores' },
  { id: '2802809', name: 'Indiaroba' },
  { id: '2802908', name: 'Itabaiana' },
  { id: '2803005', name: 'Itabaianinha' },
  { id: '2803104', name: 'Itabi' },
  { id: '2803203', name: 'Itaporanga d"Ajuda' },
  { id: '2803302', name: 'Japaratuba' },
  { id: '2803401', name: 'Japoatã' },
  { id: '2803500', name: 'Lagarto' },
  { id: '2803609', name: 'Laranjeiras' },
  { id: '2803708', name: 'Macambira' },
  { id: '2803807', name: 'Malhada dos Bois' },
  { id: '2803906', name: 'Malhador' },
  { id: '2804003', name: 'Maruim' },
  { id: '2804102', name: 'Moita Bonita' },
  { id: '2804201', name: 'Monte Alegre de Sergipe' },
  { id: '2804300', name: 'Muribeca' },
  { id: '2804409', name: 'Neópolis' },
  { id: '2804458', name: 'NoSa Senhora Aparecida' },
  { id: '2804508', name: 'NoSa Senhora da Glória' },
  { id: '2804607', name: 'NoSa Senhora das Dores' },
  { id: '2804706', name: 'NoSa Senhora de Lourdes' },
  { id: '2804805', name: 'NoSa Senhora do SocoRo' },
  { id: '2804904', name: 'Pacatuba' },
  { id: '2805000', name: 'Pedra Mole' },
  { id: '2805109', name: 'Pedrinhas' },
  { id: '2805208', name: 'Pinhão' },
  { id: '2805307', name: 'Pirambu' },
  { id: '2805406', name: 'Poço Redondo' },
  { id: '2805505', name: 'Poço Verde' },
  { id: '2805604', name: 'Porto da Folha' },
  { id: '2805703', name: 'Propriá' },
  { id: '2805802', name: 'Riachão do Dantas' },
  { id: '2805901', name: 'Riachuelo' },
  { id: '2806008', name: 'Ribeirópolis' },
  { id: '2806107', name: 'Rosário do Catete' },
  { id: '2806206', name: 'Salgado' },
  { id: '2806305', name: 'Santa Luzia do Itanhy' },
  { id: '2806503', name: 'Santa Rosa de Lima' },
  { id: '2806404', name: 'Santana do São Francisco' },
  { id: '2806602', name: 'Santo Amaro das Brotas' },
  { id: '2806701', name: 'São Cristóvão' },
  { id: '2806800', name: 'São Domingos' },
  { id: '2806909', name: 'São Francisco' },
  { id: '2807006', name: 'São Miguel do Aleixo' },
  { id: '2807105', name: 'Simão Dias' },
  { id: '2807204', name: 'Siriri' },
  { id: '2807303', name: 'Telha' },
  { id: '2807402', name: 'Tobias BaReto' },
  { id: '2807501', name: 'Tomar do Geru' },
  { id: '2807600', name: 'Umbaúba' },
  { id: '1700251', name: 'Abreulândia' },
  { id: '1700301', name: 'Aguiarnópolis' },
  { id: '1700350', name: 'Aliança do Tocantins' },
  { id: '1700400', name: 'Almas' },
  { id: '1700707', name: 'Alvorada' },
  { id: '1701002', name: 'Ananás' },
  { id: '1701051', name: 'Angico' },
  { id: '1701101', name: 'Aparecida do Rio Negro' },
  { id: '1701309', name: 'Aragominas' },
  { id: '1701903', name: 'Araguacema' },
  { id: '1702000', name: 'Araguaçu' },
  { id: '1702109', name: 'Araguaína' },
  { id: '1702158', name: 'Araguanã' },
  { id: '1702208', name: 'Araguatins' },
  { id: '1702307', name: 'Arapoema' },
  { id: '1702406', name: 'ARaias' },
  { id: '1702554', name: 'Augustinópolis' },
  { id: '1702703', name: 'Aurora do Tocantins' },
  { id: '1702901', name: 'Axixá do Tocantins' },
  { id: '1703008', name: 'Babaçulândia' },
  { id: '1703057', name: 'Bandeirantes do Tocantins' },
  { id: '1703073', name: 'BaRa do Ouro' },
  { id: '1703107', name: 'BaRolândia' },
  { id: '1703206', name: 'Bernardo Sayão' },
  { id: '1703305', name: 'Bom Jesus do Tocantins' },
  { id: '1703602', name: 'Brasilândia do Tocantins' },
  { id: '1703701', name: 'Brejinho de Nazaré' },
  { id: '1703800', name: 'Buriti do Tocantins' },
  { id: '1703826', name: 'Cachoeirinha' },
  { id: '1703842', name: 'Campos Lindos' },
  { id: '1703867', name: 'Cariri do Tocantins' },
  { id: '1703883', name: 'Carmolândia' },
  { id: '1703891', name: 'CaRasco Bonito' },
  { id: '1703909', name: 'Caseara' },
  { id: '1704105', name: 'Centenário' },
  { id: '1705102', name: 'Chapada da Natividade' },
  { id: '1704600', name: 'Chapada de Areia' },
  { id: '1705508', name: 'Colinas do Tocantins' },
  { id: '1716703', name: 'Colméia' },
  { id: '1705557', name: 'Combinado' },
  { id: '1705607', name: 'Conceição do Tocantins' },
  { id: '1706001', name: 'Couto Magalhães' },
  { id: '1706100', name: 'Cristalândia' },
  { id: '1706258', name: 'Crixás do Tocantins' },
  { id: '1706506', name: 'Darcinópolis' },
  { id: '1707009', name: 'Dianópolis' },
  { id: '1707108', name: 'Divinópolis do Tocantins' },
  { id: '1707207', name: 'Dois Irmãos do Tocantins' },
  { id: '1707306', name: 'Dueré' },
  { id: '1707405', name: 'Esperantina' },
  { id: '1707553', name: 'Fátima' },
  { id: '1707652', name: 'Figueirópolis' },
  { id: '1707702', name: 'Filadélfia' },
  { id: '1708205', name: 'Formoso do Araguaia' },
  { id: '1708304', name: 'Goianorte' },
  { id: '1709005', name: 'Goiatins' },
  { id: '1709302', name: 'Guaraí' },
  { id: '1709500', name: 'Gurupi' },
  { id: '1709807', name: 'Ipueiras' },
  { id: '1710508', name: 'Itacajá' },
  { id: '1710706', name: 'Itaguatins' },
  { id: '1710904', name: 'Itapiratins' },
  { id: '1711100', name: 'Itaporã do Tocantins' },
  { id: '1711506', name: 'Jaú do Tocantins' },
  { id: '1711803', name: 'Juarina' },
  { id: '1711902', name: 'Lagoa da Confusão' },
  { id: '1711951', name: 'Lagoa do Tocantins' },
  { id: '1712009', name: 'Lajeado' },
  { id: '1712157', name: 'Lavandeira' },
  { id: '1712405', name: 'Lizarda' },
  { id: '1712454', name: 'Luzinópolis' },
  { id: '1712504', name: 'Marianópolis do Tocantins' },
  { id: '1712702', name: 'Mateiros' },
  { id: '1712801', name: 'Maurilândia do Tocantins' },
  { id: '1713205', name: 'Miracema do Tocantins' },
  { id: '1713304', name: 'Miranorte' },
  { id: '1713700', name: 'Monte Santo do Tocantins' },
  { id: '1713601', name: 'Monte do Carmo' },
  { id: '1713957', name: 'Muricilândia' },
  { id: '1714203', name: 'Natividade' },
  { id: '1714302', name: 'Nazaré' },
  { id: '1714880', name: 'Nova Olinda' },
  { id: '1715002', name: 'Nova Rosalândia' },
  { id: '1715101', name: 'Novo Acordo' },
  { id: '1715150', name: 'Novo Alegre' },
  { id: '1715259', name: 'Novo Jardim' },
  { id: '1715507', name: 'Oliveira de Fátima' },
  { id: '1721000', name: 'Palmas' },
  { id: '1715705', name: 'Palmeirante' },
  { id: '1713809', name: 'Palmeiras do Tocantins' },
  { id: '1715754', name: 'Palmeirópolis' },
  { id: '1716109', name: 'Paraíso do Tocantins' },
  { id: '1716208', name: 'Paranã' },
  { id: '1716307', name: 'Pau D"Arco' },
  { id: '1716505', name: 'Pedro Afonso' },
  { id: '1716604', name: 'Peixe' },
  { id: '1716653', name: 'Pequizeiro' },
  { id: '1717008', name: 'Pindorama do Tocantins' },
  { id: '1717206', name: 'Piraquê' },
  { id: '1717503', name: 'Pium' },
  { id: '1717800', name: 'Ponte Alta do Bom Jesus' },
  { id: '1717909', name: 'Ponte Alta do Tocantins' },
  { id: '1718006', name: 'Porto Alegre do Tocantins' },
  { id: '1718204', name: 'Porto Nacional' },
  { id: '1718303', name: 'Praia Norte' },
  { id: '1718402', name: 'Presidente KeNedy' },
  { id: '1718451', name: 'Pugmil' },
  { id: '1718501', name: 'Recursolândia' },
  { id: '1718550', name: 'Riachinho' },
  { id: '1718758', name: 'Rio Sono' },
  { id: '1718659', name: 'Rio da Conceição' },
  { id: '1718709', name: 'Rio dos Bois' },
  { id: '1718808', name: 'Sampaio' },
  { id: '1718840', name: 'Sandolândia' },
  { id: '1718865', name: 'Santa Fé do Araguaia' },
  { id: '1718881', name: 'Santa Maria do Tocantins' },
  { id: '1718899', name: 'Santa Rita do Tocantins' },
  { id: '1718907', name: 'Santa Rosa do Tocantins' },
  { id: '1719004', name: 'Santa Tereza do Tocantins' },
  { id: '1720002', name: 'Santa Terezinha do Tocantins' },
  { id: '1720101', name: 'São Bento do Tocantins' },
  { id: '1720150', name: 'São Félix do Tocantins' },
  { id: '1720200', name: 'São Miguel do Tocantins' },
  { id: '1720259', name: 'São Salvador do Tocantins' },
  { id: '1720309', name: 'São Sebastião do Tocantins' },
  { id: '1720499', name: 'São Valério' },
  { id: '1720655', name: 'Silvanópolis' },
  { id: '1720804', name: 'Sítio Novo do Tocantins' },
  { id: '1720853', name: 'Sucupira' },
  { id: '1708254', name: 'Tabocão' },
  { id: '1720903', name: 'Taguatinga' },
  { id: '1720937', name: 'Taipas do Tocantins' },
  { id: '1720978', name: 'Talismã' },
  { id: '1721109', name: 'Tocantínia' },
  { id: '1721208', name: 'Tocantinópolis' },
  { id: '1721257', name: 'Tupirama' },
  { id: '1721307', name: 'Tupiratins' },
  { id: '1722081', name: 'Wanderlândia' },
  { id: '1722107', name: 'Xambioá' }
]